<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ຈັດການບິນ
            <span v-if="b2bname"> : {{ b2bname }} </span>
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 77">
        <b-tab-item label="B2B">
          <div class="columns scrollme">
            <div class="column" >
              <b-field style="font-size: 18px; font-weight: bold;"
                >ລາຍການ B2B</b-field
              >
            </div>
          </div>
          <div class="columns scrollme">
            <div class="column">
              <b-field>
                

                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="1%">#</th>
                      <th class="has-text-left " width="30%">
                        ບໍລິສັດ | ຊື່ | Username
                      </th>
                      <th class="has-text-left " width="15%">
                        ທີ່ຕັ້ງ
                      </th>
                      <th class="has-text-left " width="20%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in activeb2b" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{data.USERID}}- {{ data.COMPANYNAME }} | {{ data.FULLNAME}} |  {{data.USERNAME}}  
                      </td>
                      <td>
                        {{ data.PROVINCENAME }}
                    
                        {{ data.DISTRICT }}
                     
                        {{ data.VILLAGE }}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <span v-if="data.ISNEW == 1 " style="color: red">New - {{data.PRODATEEND}} days</span>  
                            <b-button
                              class="btn-group-margin"
                              type="is-info"  
                              size="is-small"
                              @click="
                                productform(    
                                  data.USERID,
                                  data.USERNAME,
                                  data.CONTRACTID,
                                  data.PROVINCEID,
                                  data.DISTRICT,   
                                  data.VILLAGE,
                                  data.PHONENO,
                                  data.COMPANYNAME,
                                  data.COMPANYTYPE,
                                  data.PROVINCENAME,
                                  4
                                )
                              "
                              >quotation
                            </b-button>
                            <b-button
                              class="btn-group-margin"
                              type="is-info"  
                              size="is-small"
                              @click="
                                productform(    
                                  data.USERID,
                                  data.USERNAME,
                                  data.CONTRACTID,
                                  data.PROVINCEID,
                                  data.DISTRICT,   
                                  data.VILLAGE,
                                  data.PHONENO,
                                  data.COMPANYNAME,
                                  data.COMPANYTYPE,
                                  data.PROVINCENAME,
                                  5
                                )
                              "
                              >Invoice
                            </b-button>
 
                            <b-button
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              @click="
                                productform(  
                                  data.USERID,
                                  data.USERNAME,
                                  data.CONTRACTID,
                                  data.PROVINCEID,
                                  data.DISTRICT,
                                  data.VILLAGE,
                                  data.PHONENO,
                                  data.COMPANYNAME,
                                  data.COMPANYTYPE,
                                  data.PROVINCENAME,
                                  3
                                )
                              "
                              >ອໍເດີ້ທີ່ເຄີຍສັ່ງ
                            </b-button>

                            <!-- <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                productform(  
                                  data.USERID,
                                  data.USERNAME,
                                  data.CONTRACTID,
                                  data.PROVINCEID,
                                  data.DISTRICT,
                                  data.VILLAGE,
                                  data.PHONENO,
                                  data.COMPANYNAME,
                                  data.PROVINCENAME,
                                  1
                                )
                              "
                              >ຟອມສິນຄ້າ -
                            </b-button> -->

                            <!-- <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                productform(
                                  data.USERID,
                                  data.USERNAME,
                                  data.CONTRACTID,
                                  data.PROVINCEID,
                                  data.DISTRICT,
                                  data.VILLAGE,
                                  data.PHONENO,
                                  data.COMPANYNAME,
                                  data.COMPANYTYPE,
                                  data.PROVINCENAME,
                                  0
                                )
                              "
                              >Order ມາໃໝ່ <span v-if="data.COUNTWAIT>0" style="color: red">({{ data.COUNTWAIT }})</span>
                            </b-button> -->
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="Form">
          <!-- <b-field v-if="b2busername === null">
            <button class="button is-info" @click="gotoB2Blist">
              ເລືອກ B2B
            </button>
          </b-field> -->
          <b-field v-if="1===1">
            
          </b-field>
          <b-field v-else>
            <div v-if="!isContractProductList">
              <div class="columns">
                <div class="column">
                  <b-field style="font-size: 20px; font-weight: bold;"
                    >ຟອມສິນຄ້າ</b-field
                  >
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field class="group">
                    <b-field label="ວັນທີ" style="margin-right: 15px;">
                    </b-field>
                    <b-field>
                      <b-datepicker
                        :date-formatter="dateFormatter"
                        v-model="selecteddate"
                        @input="onSelecteddate"
                      >
                      </b-datepicker>
                    </b-field>
                    <b-field style="margin-left:15px;">
                      <b-button
                        v-if="
                          !isContractProductList &&
                            productB2BSTATUS != null
                        "
                        class="btn-group-margin"
                        type="is-primary"
                        @click="submitProductsAmount()"
                        >ຢືນຢັນລາຍການ
                      </b-button>
                      <b-button
                          v-if="productB2BSTATUS == 0"
                          class="btn-group-margin"
                          type="is-danger"
                          @click="cancelForm()"
                        >
                          ຍົກເລີກລາຍການ
                        </b-button>
                    </b-field>
                  </b-field>
                </div>
                
              </div>
                <b-tabs v-model="activeFormTypeTab" style="margin-top:-30px;">
                  <b-tab-item label="ຄົ້ນຫາ">
                    <b-field grouped>
                      <b-field>
                        ຄົ້ນຫາສິນຄ້າ
                      </b-field>
                      <b-field>
                        <input
                          type="text"
                          class="input"
                          v-model.trim="b2bproductsearch"
                          @input="productSearch"
                        />
                      </b-field>
                    </b-field>

                    <b-field
                      v-for="productsearch in filteredProducts"
                      :key="productsearch.productsearchID_SUB"
                    >
                      <div class="columns" style="box-shadow: 0 2px rgba(0, 0, 0, 0.1); margin-bottom: -10px;">  
                        <div class="column has-text-left" style=" margin-bottom: 0px;">  
                          <b-field style="margin-top:0px; margin-bottom: 0px; ">   
                            {{ productsearch.PRODUCTNAME_SUB }} 
                          </b-field>
                          <b-field grouped style=" margin-bottom: -10px; " >       
                            <img
                              class="image-area"
                              style="width: 70px; "
                              :src="getImgUrl('products/' + productsearch.PHOTONAME)"
                                
                            />                            
                            
                            <b-field>  
                            
                              <b-field v-if="productsearch.B2BAMOUNT === null" style="padding-top:20px">  
                               
                                <b-form-select
                                    v-model.trim="productsearch.AMOUNT"
                                    :options="amountOptions"
                                   
                                    style="width: 150px; border-radius: 5px; border: 1px solid #ced4da; padding: 0.375rem 0.75rem; font-size: 1rem; line-height: 1.5; color: #495057; background-color: #fff; background-clip: padding-box;"
                                    class="mb-3"
                                ></b-form-select>

                                {{ productsearch.UNITPRICE | formatNumberLocal }}
                              </b-field>
                              <b-field v-else style="padding-left:100px; padding-top:25px">    
                                {{ productsearch.B2BAMOUNT | formatNumberLocal }}
                              </b-field>
                              <b-field v-if="productsearch.B2BSTATUS == null" style="padding-top:20px">  
                                <b-button
                                  class="btn-group-margin"
                                  type="is-primary"
                                  size="is-small"
                                  @click="saveProductAmount(2)"
                                  >ບັນທຶກ
                                </b-button>
                              </b-field>
                              <b-field v-if="productsearch.B2BSTATUS == 0" style="padding-top:20px">
                                <b-button
                                  class="btn-group-margin"
                                  type="is-warning"
                                  size="is-small"
                                  @click="unSetProductAmount(productsearch.ID, 0)"
                                  >ລຶບຂໍ້ມູນ
                                </b-button>
                              </b-field>
                            </b-field>

                          </b-field>
                        </div>
                      </div>
                    </b-field>
                        
                  </b-tab-item>

                  <b-tab-item label="ປະເພດສິນຄ້າ">
                    <b-tabs v-model="activeSubTab">
                      <b-tab-item
                        :label="type.TYPENAME"
                        v-for="type in productType"
                        :key="type.TYPEID"
                      >
                        

                        <div :label="type.TYPENAME">
                          <b-field
                            v-for="product in products"
                            :key="product.PRODUCTID_SUB"
                          >
                            <div
                              class="columns"
                              v-if="type.TYPEID === product.TYPEID"
                              style="box-shadow: 0 2px rgba(0, 0, 0, 0.1); margin-bottom: -10px;"
                              
                            >

                     
                                <div class="column has-text-left" style=" margin-bottom: 0px;">  
                                  <b-field style="margin-top:0px; margin-bottom: 0px; ">   
                                    {{ product.PRODUCTNAME_SUB }}
                                  </b-field>
                                  <b-field grouped style=" margin-bottom: -10px; " >       
                                    <img
                                      class="image-area"
                                      style="width: 70px;"
                                      :src="getImgUrl('products/' + product.PHOTONAME)"
                                   
                                    />                            
                                    
                                    <b-field>                                      
                                      <b-field v-if="product.B2BAMOUNT === null" style="padding-top:20px">
                                        <!-- <b-input
                                          v-model.trim="product.AMOUNT"
                                          type="number"  
                                          min="0"
                                          pattern="[0-9]+"
                                          style="width: 150px;"
                                        >
                                        </b-input> -->

                                        <!-- <b-field v-if="product.B2BAMOUNT === null" style="padding-top:20px">   -->
                               
                                          <b-form-select
                                              v-model.trim="product.AMOUNT"
                                              :options="amountOptions"
                                              style="width: 150px; border-radius: 5px; border: 1px solid #ced4da; padding: 0.375rem 0.75rem; font-size: 1rem; line-height: 1.5; color: #495057; background-color: #fff; background-clip: padding-box;"
                                              class="mb-3"
                                          ></b-form-select>

                                          {{ product.UNITPRICE | formatNumberLocal }}
                                        <!-- </b-field> -->


                                      </b-field>
                                      <b-field v-else style="padding-left:100px; padding-top:25px">
                                        {{ product.B2BAMOUNT | formatNumberLocal }}
                                      </b-field>


                                      <b-field v-if="product.B2BSTATUS == null" style="padding-top:20px">
                                        <b-button  
                                          class="btn-group-margin"
                                          type="is-primary"
                                          size="is-small"
                                          @click="saveProductAmount(1)"
                                          >ບັນທຶກ
                                        </b-button>
                                      </b-field>
                                      <b-field v-if="product.B2BSTATUS == 0" style="padding-top:20px">
                                        <b-button
                                          class="btn-group-margin"
                                          type="is-warning"
                                          size="is-small"
                                          @click="unSetProductAmount(product.ID, 0)"
                                          >ລຶບຂໍ້ມູນ
                                        </b-button>
                                      </b-field>
                                    </b-field>

                                  </b-field>
                                </div>
                              <!-- </div> -->

                              <!-- <div class="column has-text-right">
                                <b-field style="margin-top:10px;">
                                  {{ product.PRODUCTNAME_SUB }}
                                </b-field>
                                <b-field style="">
                                  <img
                                    class="image-area"
                                    style="width: 70px; box-shadow: 0 2px rgba(0, 0, 0, 0.1);"
                                    :src="getImgUrl('products/' + product.PHOTONAME)"
                                    alt="Placeholder image"
                                  />
                                </b-field>
                              </div>
                              <div class="column" style="text-align:right;">
                                <b-field v-if="product.B2BAMOUNT === null">
                                  <b-input
                                    v-model.trim="product.AMOUNT"
                                    type="number"
                                    min="0"
                                    pattern="[0-9]+"
                                  >
                                  </b-input>
                                </b-field>
                                <b-field v-else>
                                  {{ product.B2BAMOUNT | formatNumberLocal }}
                                </b-field>
                              </div>
                              <div class="column">
                                <b-field v-if="product.B2BSTATUS == null">
                                  <b-button
                                    class="btn-group-margin"
                                    type="is-primary"
                                    size="is-small"
                                    @click="saveProductAmount(1)"
                                    >ບັນທຶກ
                                  </b-button>
                                </b-field>
                                <b-field v-if="product.B2BSTATUS == 0" style="">
                                  <b-button
                                    class="btn-group-margin"
                                    type="is-warning"
                                    size="is-small"
                                    @click="unSetProductAmount(product.ID, 0)"
                                    >ລຶບຂໍ້ມູນ
                                  </b-button>
                                </b-field>
                              </div>

                              <div class="column"></div>
                              <div class="column"></div> -->
                            </div>
                          </b-field>
                          <!-- <b-field v-if="products[0].B2BSTATUS > 1">
                            ມື້ນີ້ ມີການຈັດສິນຄ້າແລ້ວ
                          </b-field> -->
                        </div>
                      </b-tab-item>
                    </b-tabs>
                  </b-tab-item>
                </b-tabs>

                    
            </div>
          </b-field>
        </b-tab-item>
        <b-tab-item label="Order">
          <b-field v-if="b2busername === null">
            <button class="button is-info" @click="gotoB2Blist">
              ເລືອກ B2B
            </button>
          </b-field>
          <b-field v-else>
            <b-tabs
              v-model="activeSub2TabWait"
              v-if="roleid == 77"
            >
              <b-tab-item label="ວັນທີສົ່ງສິນຄ້າ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="10%">
                        ລະຫັດສັ່ງຊື້
                      </th>
                      <th class="has-text-left " width="15%">
                        ວັນທີສົ່ງສິນຄ້າ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນ<br />ປະເພດ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນ<br />ສິນຄ້າ / ລາຍການ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນເງິນ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ສະຖານະ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in waitdatelist"
                      :key="data.PURCHASEID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.PURCHASEID }}
                      </td>
                      <td>
                        {{ dateFormatter(data.REDATE) }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.COUNTTYPE }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.COUNTPRODUCT }} / {{ data.COUNTPRODUCTSUB }}
                      </td>
                      <td class="has-text-right">
                        {{ data.TOTAL | formatNumberLocal }}
                      </td>
                      <td class="has-text-centered">
                        <b-button
                          class="btn-group-margin"
                          type="is-info"
                          size="is-small"
                          @click="openContractDateForm(0, data)"
                          >ລາຍລະອຽດ
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-tab-item>
              <b-tab-item label="ລາຍລະອຽດສິນຄ້າ">
                <div class="columns">
                  <div class="column">
                    ວັນທີສົ່ງສິນຄ້າ: {{ dateFormatter(selectedWaitDate) }}
                  </div>
                  <div class="column" style="text-align: right; ">
                    
                    <b-button v-if="selectedWaitDate"
                      class="btn-group-margin"
                      type="is-primary"
                      size="is-small"
                      @click="loadB2BProductRequirement()"
                      >ຮັບລາຍການຈາກ B2B
                    </b-button>
                  </div>
                </div>

                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>

                      <th class="has-text-left " width="15%">
                        ສິນຄ້າ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ
                      </th>
                      <th class="has-text-right " width="15%">
                        ລາຄາ
                      </th>
                      <th class="has-text-right " width="15%">
                        ລວມເປັນເງິນ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in waitdetaillist"
                      :key="data.PRODUCTID_SUB"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>

                      <td>
                        {{ data.PRODUCTNAME }} 
                      </td>
                      <td class="has-text-right">
                          {{ data.B2BAMOUNT | formatNumberLocal }}
                      </td>
                      <td class="has-text-right">
                        {{ data.UNITPRICE | formatNumberLocal }}
                      </td>
                      <td class="has-text-right">
                        {{ data.TOTAL | formatNumberLocal }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th colspan="4" class="has-text-centered">
                        ລວມ
                        {{ waitdetaillist.length | formatNumberLocal }}
                        ລາຍການ
                      </th>
                      <th class="has-text-right">
                        {{
                          _.sumBy(waitdetaillist, (i) => i["TOTAL"] * 1)
                            | formatNumberLocal
                        }}
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </b-tab-item>
            </b-tabs>
          </b-field>
        </b-tab-item>
        <b-tab-item label="Prepare">
          <b-field v-if="b2busername === null">
            <button class="button is-info" @click="gotoB2Blist">
              ເລືອກ B2B
            </button>
          </b-field>
          <b-field v-else>
            <b-tabs
              v-model="activeSub2TabPrepare"
              v-if="roleid == 77"
            >
              <b-tab-item label="ວັນທີສົ່ງສິນຄ້າ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="10%">
                        ລະຫັດສັ່ງຊື້
                      </th>
                      <th class="has-text-left " width="15%">
                        ວັນທີສົ່ງສິນຄ້າ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນ<br />ປະເພດ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນ<br />ສິນຄ້າ / ລາຍການ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນເງິນ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ສະຖານະ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in preparedatelist"
                      :key="data.PURCHASEID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.PURCHASEID }}
                      </td>
                      <td>
                        {{ dateFormatter(data.REDATE) }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.COUNTTYPE }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.COUNTPRODUCT }} / {{ data.COUNTPRODUCTSUB }}
                      </td>
                      <td class="has-text-right">
                        {{ data.TOTAL | formatNumberLocal }}
                      </td>
                      <td class="has-text-centered">
                        <b-button
                          class="btn-group-margin"
                          type="is-info"
                          size="is-small"
                          @click="openContractDateForm(1, data)"
                          >ລາຍລະອຽດ
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-tab-item>
              <b-tab-item label="ລາຍລະອຽດສິນຄ້າ">
                <div class="columns">
                  <div class="column">
                    ວັນທີສົ່ງສິນຄ້າ: {{ dateFormatter(selectedPrepareDate) }}
                  </div>
                  <div class="column" style="text-align: right; ">
                    <b-button
                      v-if="
                        enableprepareedit == 0 && preparedetaillist.length > 0
                      "
                      class="is-small btn-group-margin"
                      type="is-danger"
                      @click="cancelPrepare()"
                      >ຍົກເລີກ
                    </b-button>
                    <!-- <b-button
                      v-if="
                        enableprepareedit == 0 &&
                          preparedetaillist.length > 0 &&
                          hasSomeUnSubmitPurchase == 0
                      "
                      class="is-small btn-group-margin"
                      type="is-danger"
                      @click="backToForm()"
                      >ກັບຄືນຟອມ
                    </b-button> -->
                    <b-button
                      v-if="
                        enableprepareedit == 0 && preparedetaillist.length > 0
                      "
                      class="is-small btn-group-margin"
                      type="is-warning"
                      @click="enablePrepareEdit()"
                      >ແກ້ໄຂຈຳນວນ ແລະ PO
                    </b-button>
                    <b-button
                      v-if="
                        enableprepareedit == 1 && preparedetaillist.length > 0
                      "
                      class="is-small btn-group-margin"
                      type="is-primary"
                      @click="editPrepare()"
                      >ແກ້ໄຂຈຳນວນ ແລະ PO 
                    </b-button>

                    <b-button
                      v-if="
                        enableprepareedit == 0 && preparedetaillist.length > 0 && (preparecount.countall == preparecount.countcheck)  
                      "
                      class="btn-group-margin"
                      type="is-primary"
                      size="is-small"  
                      @click="changeContractDateStatus(2)"
                      >ສ້າງ Quotation
                    </b-button>
                  </div>  
                </div>
                <div class="columns" v-if=" enableprepareedit == 1 && preparedetaillist.length > 0">
                  <div class="column">
                   
                  </div>
                  <div class="column" style="text-align: right; ">
                    <b-field label="PO" style="float: right; width: 150px;">
                      <b-input 
                        v-model.trim="customerPO"
                        type="text"
                      >
                      </b-input>
                    </b-field>
                    
                    
                  </div>  
                </div>

                <div class="columns" v-if="enableprepareedit == 0 && preparedetaillist.length > 0 && (preparecount.countall == preparecount.countcheck)  ">
                  <div class="column">
                   
                  </div>
                  <div class="column" style="text-align: right; " v-if="!customerPO">
                    
                    
                  </div>  
                  <div class="column" style="text-align: right; " v-else>
                    <b-field >
                       PO: &nbsp; {{customerPO }}
                    </b-field>
                    
                    
                  </div>  
                </div>

                <div class="columns" v-if="subB2BList != 0 && enableprepareedit == 0 && preparedetaillist.length > 0 && (preparecount.countall == preparecount.countcheck)">    
                  <div class="column">
                   
                  </div>
                  <div class="column">
                   
                  </div>
                  <div class="column">
                   
                  </div>
                  <div class="column" style="text-align: right; ">
                    <Multiselect     
                      placeholder="ຊື່ລູກຄ້າ"
                      v-model.trim="selectedSubB2B"
                      label="NAME"
                      track-by="ID"
                      :options="subB2BList"   
                    ></Multiselect>
                  </div>
                </div>

                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">#</th>

                      <th class="has-text-left " width="68%">
                        ສິນຄ້າ
                      </th>
                      <th class="has-text-right " width="10%">
                        ຈຳນວນ
                      </th>
                      <th class="has-text-right " width="10%">  
                        ລາຄາ
                      </th>
                      <th class="has-text-right " width="10%">
                        ລວມເປັນເງິນ
                      </th>  
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in preparedetaillist" 
                      :key="data.PRODUCTID_SUB"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td> 

                      <td>
                        <b-field class="group is-flex is-align-items-center custom-flex-wrap">
                          <b-field style="margin-bottom: 0px">
                            <b-button v-if="data.ISEVERYDAY !=1"  
                                class="is-small btn-group-margin"
                                type="is-danger"
                                size="is-small"
                                @click="removeProductsubFormPurchaseList(data.DETAILID)"    
                            >X
                            </b-button> 
                            <b-button v-else
                                class="is-small btn-group-margin"
                                type="is-warning"
                                size="is-small"
                                
                            >ສັ່ງທຸກວັນ
                            </b-button> 
                            <b-button v-if="data.CHECKPREQUANTITY == 0 && enableprepareedit == 0" 
                              class="btn-group-margin"  
                              type="is-info"   
                              size="is-small"  
                              @click="checkPreQuantity(data.DETAILID)"  
                              >ຖືກຕ້ອງ      
                            </b-button>
                            <b-field v-if="data.CHECKPREQUANTITY == 0 && enableprepareedit == 0" style=" margin-bottom: 0px; color: red; font-size: 18px; font-weight: bold; margin-right: 50px;">     
                            
                                {{ data.B2BAMOUNT | formatNumberLocal }}
                              
                            </b-field>
                            
                          </b-field>
                          
                          <b-field class="product-name" v-if="data.ISCLIAMED==1"  style="font-weight: bold;  margin-top: 0px; margin-bottom: 0px">(ສິນຄ້າເຄຼມ)</b-field> 
                          <b-field class="product-name" style=" margin-top: 0px" > {{ data.PRODUCTNAME }}</b-field>     
                        </b-field>
                        
                      </td>
                      <td class="has-text-right">
                        <b-field style=" text-align: right; float: right"  >  
                          <b-field v-if="enableprepareedit == 1">
                            <b-input
                              v-model.trim="data.B2BAMOUNT"
                              type="number"
                              step="any"
                            >
                            </b-input>
                          </b-field>
                          <b-field v-if="enableprepareedit == 0" style=" margin-bottom: 0px;">    
                          
                              {{ data.B2BAMOUNT | formatNumberLocal }}
                            
                          </b-field>
                          
                          <span v-if="data.CHECKPREQUANTITY == 1 && enableprepareedit == 0" style="font-size:20px">
                            &#9989;
                          </span> 
                        </b-field>
                          
                      </td>
                      <td class="has-text-right">
                        {{ data.UNITPRICE | formatNumberLocal }}
                      </td>
                      <td class="has-text-right">
                        {{ data.B2BAMOUNT * data.UNITPRICE | formatNumberLocal }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th colspan="4" class="has-text-centered">
                        ລວມ
                        {{ preparedetaillist.length | formatNumberLocal }}
                        ລາຍການ
                      </th>
                      <th class="has-text-right">
                        {{
                          _.sumBy(preparedetaillist, (i) => i["B2BAMOUNT"]*i["UNITPRICE"] * 1)     
                            | formatNumberLocal
                        }} 
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </b-tab-item>
            </b-tabs>
          </b-field>
        </b-tab-item>
        <b-tab-item label="Quotation">
          <b-field v-if="b2busername === null">
            <button class="button is-info" @click="gotoB2Blist">
              ເລືອກ B2B
            </button>
          </b-field>
          <b-field v-else>
            <b-tabs
              v-model="activeSub2TabQuotation"
              v-if="roleid == 77"
            >
              <b-tab-item label="ວັນທີສົ່ງສິນຄ້າ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ລະຫັດສັ່ງຊື້
                      </th>
                      <th class="has-text-left " width="15%">
                        ວັນທີສົ່ງສິນຄ້າ
                      </th>
                      <th class="has-text-centered " width="5%">
                        ຈຳນວນ<br />ປະເພດ
                      </th>
                      <th class="has-text-centered " width="5%">
                        ຈຳນວນ<br />ສິນຄ້າ / ລາຍການ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນເງິນ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ສະຖານະ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in quotationdatelist" 
                      :key="data.PURCHASEID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.PURCHASEID }} 
                        <span v-if="data.FULLNAME != null">
                          ({{data.FULLNAME}})
                        </span>
                      </td>
                      <td>
                        {{ dateFormatter(data.REDATE) }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.COUNTTYPE }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.COUNTPRODUCT }} / {{ data.COUNTPRODUCTSUB }}
                      </td>
                      <td class="has-text-right">
                        {{ data.TOTAL | formatNumberLocal }}
                      </td>
                      <td class="has-text-centered">
                        <b-button
                          class="btn-group-margin"
                          type="is-info"
                          size="is-small"
                          @click="openContractDateForm(2, data)"
                          >ລາຍລະອຽດ
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-tab-item>
              <b-tab-item label="ລາຍລະອຽດສິນຄ້າ">
                <div class="columns">
                  <div class="column">
                    <b-field v-if="isQuotationChangeDate==0">
                      ວັນທີສົ່ງສິນຄ້າ: {{ dateFormatter(selectedQuotationDate) }}<br>
                    </b-field>
                    
                    <b-field v-else>
                      ວັນທີສົ່ງສິນຄ້າ: <b-datepicker
                        :date-formatter="dateFormatter"
                        v-model="quotationDate"
                      >
                      </b-datepicker><br>
                    </b-field>
                    <b-field v-if="customerPO">
                      Customer PO:- &nbsp; &nbsp; <span style='color: red'>{{ customerPO }}</span><br>
                    </b-field>
                    
                    <b-button
                      v-if="quotationdetaillist.length > 0 && isQuotationChangeDate==0 && isNumberEdit == 0"
                      class="is-small btn-group-margin"
                      type="is-danger"
                      @click="changeQuotationDateForm()" 
                      >ປ່ຽນວັນທີ
                    </b-button>
                    <b-button
                      v-if="quotationdetaillist.length > 0 && isQuotationChangeDate==1"
                      class="is-small btn-group-margin"
                      type="is-primary"
                      @click="changeQuotationDate()" 
                      >ປ່ຽນວັນທີ
                    </b-button>
                    
                  </div>
                  <div class="column" style="text-align: right; ">
                    <!-- <b-button
                      v-if="
                        enablequotationedit == 0 &&
                          quotationdetaillist.length > 0 && quotationmarketbatchstatus ==0
                      "
                      class="is-small btn-group-margin"
                      type="is-danger"
                      @click="cancelQuotation()"
                      >ຍົກເລີກ (Staff)
                    </b-button> -->
                    <b-button
                      v-if="
                        enablequotationedit == 0 &&
                          quotationdetaillist.length > 0 &&
                          hasSomeUnSubmitPurchase == 0 && quotationmarketbatchstatus ==0 && isNumberEdit == 0
                      "
                      class="is-small btn-group-margin"
                      type="is-danger"
                      @click="backToPrepare()"
                      >ກັບຄືນ Prepare
                    </b-button>

                    <b-button v-if="isNumberEdit ==0"
                      class="is-small btn-group-margin"
                      type="is-warning"
                      @click="numberEditForm()"
                      >ແກ້ໄຂລຳດັບ
                    </b-button>
                    <b-button v-else
                      class="is-small btn-group-margin"
                      type="is-danger"
                      @click="editNumber()"
                      >ແກ້ໄຂລຳດັບ
                    </b-button>
                    <!-- <b-button
                      v-if="
                        enablequotationedit == 0 &&
                          quotationdetaillist.length > 0
                      "
                      class="is-small btn-group-margin"
                      type="is-warning"
                      @click="enableQuotationEdit()"
                      >ຈຳນວນຊື້ຕົວຈິງ (Market-Staff)
                    </b-button> -->
                    <!-- <b-button
                      v-if="
                        enablequotationedit == 1 &&
                          quotationdetaillist.length > 0
                      "
                      class="is-small btn-group-margin"
                      type="is-primary"
                      @click="editQuotation()"
                      >ຈຳນວນຊື້ຕົວຈິງ (Market-Staff)
                    </b-button> -->
                    <b-button
                      v-if="quotationdetaillist.length > 0 && enablequotationedit ==0 && isNumberEdit == 0" 
                      class="is-small btn-group-margin"
                      type="is-info"
                      @click="print(22)"
                      >ພິມໃບສົ່ງເຄື່ອງ
                    </b-button>
                    <b-button
                      v-if="
                        enablequotationedit == 0 &&
                          quotationdetaillist.length > 0 && isNumberEdit == 0
                      "
                      class="is-small btn-group-margin"
                      type="is-info"
                      @click="print(2)"
                      >ພິມ Quotation
                    </b-button>
                    <b-button
                      v-if="
                        enablequotationedit == 0 &&
                          quotationdetaillist.length > 0 && isNumberEdit == 0
                      "
                      class="is-small btn-group-margin"
                      type="is-info"
                      @click="print(222)"
                      >ພິມ Quotation (EN)
                    </b-button>

                    <!-- <b-button
                      v-if="
                        enablequotationedit == 0 &&
                          quotationdetaillist.length > 0 && isNumberEdit == 0 
                      "
                      class="btn-group-margin"
                      type="is-primary"
                      size="is-small"
                      @click="changeContractDateStatus(3)"
                      >ອອກໃບ Invoice
                    </b-button> -->
                  </div>
                </div>

                <b-field  v-if="quotationdetaillistfull.length > 0" style="font-weight: bold;">
                  ລາຍການສິນຄ້າ <span v-if="fullname">({{fullname}})  </span>
                </b-field>
                <table class="table is-fullwidth is-narrow is-small" v-if="quotationdetaillistfull.length > 0">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-centered " width="5%">ລຽນລຳດັບ</th>

                      <th class="has-text-left " width="15%">
                        ສິນຄ້າ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ
                      </th>
                      <th class="has-text-right " width="15%">   
                        ຫົວໜ່ວຍ
                      </th>
                      <th class="has-text-right " width="15%">
                        ລາຄາ
                      </th>
                      <th class="has-text-right " width="15%">
                        ລວມເປັນເງິນ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in quotationdetaillistfull"
                      :key="data.PRODUCTID_SUB"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td class="has-text-centered">
                        <b-field v-if="isNumberEdit == 0"> 
                          {{ data.NUMBER }} 
                        </b-field>
                        <b-field v-else>
                          <b-input
                            v-model.trim="data.NUMBER"
                            type="number"  
                          >
                          </b-input>
                        </b-field>

                        
                        
                        
                      </td>  

                      

                      <td>
                        <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                         <!-- <br> -->
                        <!-- <img   
                          class="image-area"
                          width="80px" 
                          height="80px"      
                          style=""
                          :src="getProductPhoto(data.PHOTONAME)"  
                          alt="Placeholder image"  
                        />    -->
                      </td>
                      <td class="has-text-right">
                        
                          {{ data.B2BAMOUNT | formatNumberLocal }}
                     
                      </td>
                      <td class="has-text-right">
                        {{ data.UNIT }}    
                      </td>
                      
                      <td class="has-text-right">
                        <b-field v-if="enablequotationedit == 1">
                          <b-input
                            v-model.trim="data.UNITPRICE"
                            type="number"
                            min="0"
                            pattern="[0-1000]+"
                          >  
                          </b-input>
                        </b-field>
                        <b-field v-if="enablequotationedit == 0">
                          {{ data.UNITPRICE | formatNumberLocal }}
                        </b-field>
                        
                      </td>
                      <td class="has-text-right">
                        {{ data.B2BAMOUNT * data.UNITPRICE | formatNumberLocal }}  
                      </td>
                    </tr>
                  </tbody>
                  
                </table>
                

                <table class="table is-fullwidth is-narrow is-small"  >
                  <tfoot>
                    <tr>
                      <th class="has-text-right" style="background-color: beige; width: 80%;">
                        ລວມ
                        {{ quotationdetaillistfull.length | formatNumberLocal }}
                        ລາຍການ
                      </th>
                      <th class="has-text-right" style="background-color: beige; width: 20%;">
                        {{  
                  
                           _.sumBy(quotationdetaillistfull, (i) => i["B2BAMOUNT"] * i["UNITPRICE"] * 1)  
                           | formatNumberLocal
                        }}
                      </th>
                    </tr>
                  </tfoot>
                  
                </table>
              </b-tab-item>
            </b-tabs>
          </b-field>
        </b-tab-item>  
        <b-tab-item label="Invoice">
          <b-field v-if="b2busername === null">
            <button class="button is-info" @click="gotoB2Blist">
              ເລືອກ B2B
            </button>
          </b-field>
          <b-field v-else>
            <b-tabs
              v-model="activeSub2TabInvoice"
              v-if="roleid == 77"
            >
              <b-tab-item label="ວັນທີສົ່ງສິນຄ້າ">
                <div class="columns">
                  <div class="column">
                   
                  </div>
                  <div class="column" style="text-align: right; ">
                    <!-- <b-button
                      v-if="invoicedatelist.length > 0" 
                      class="is-small btn-group-margin"
                      type="is-info"
                      @click="print(333)"  
                      >ພິມ Invoice ລວມ  
                    </b-button> -->
                  </div>

                </div>
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="10%">
                        ລະຫັດສັ່ງຊື້
                      </th>
                      <th class="has-text-left " width="15%">
                        ວັນທີສົ່ງສິນຄ້າ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນ<br />ປະເພດ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນ<br />ສິນຄ້າ / ລາຍການ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນເງິນ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ສະຖານະ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in invoicedatelist"
                      :key="data.PURCHASEID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.PURCHASEID }}
                      </td>
                      <td>
                        {{ dateFormatter(data.REDATE) }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.COUNTTYPE }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.COUNTPRODUCT }} / {{ data.COUNTPRODUCTSUB }}
                      </td>
                      <td class="has-text-right">
                        {{ data.TOTAL | formatNumberLocal }}
                      </td>
                      <td class="has-text-centered">
                        <span v-if="data.ACCOUNTSTATUS==1" style="color: red; font-weight: bold;"> 
                          ລົງບັນຊີຄ້າງຮັບແລ້ວ<br>
                        </span>
                      
                        <b-button
                          class="btn-group-margin"
                          type="is-info"
                          size="is-small"
                          @click="openContractDateForm(3, data)"
                          >ລາຍລະອຽດ
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-tab-item>
              <b-tab-item label="ລາຍລະອຽດສິນຄ້າ">
                <div class="columns">
                  <div class="column column-35">
                    ລະຫັດ: {{selectedPurchaseID}}   
                    <br>
                    ວັນທີສົ່ງສິນຄ້າ: {{ dateFormatter(selectedInvoiceDate) }}
                    <b-field v-if="customerPO">
                      Customer PO:- &nbsp; &nbsp; <span style='color: red'>{{ customerPO }}</span> 
                    </b-field>
                  </div>
                  <div class="column column-65" style="text-align: right; ">
                    <!-- {{ selectedPurchaseLOCKED }} -->
                    <b-field v-if="iskarghuptoaccount==1 && invoicedetaillist.length > 0 && enableinvoiceedit ==0 && paymentStatus ==0">
                      <span style="background-color: red; padding: 10px 10px 10px 10px  ; color: white">ລົງບັນຊີຄ້າງຮັບແລ້ວ</span>   
                      
                    </b-field>
                    

                    <!-- <b-button
                      v-if="
                        enableinvoiceedit == 0 &&
                          invoicedetaillist.length > 0 && paymentStatus ==0 && iskarghuptoaccount ==0
                      "
                      class="is-small btn-group-margin"
                      type="is-danger"
                      @click="backToPrepare()"  
                      >ກັບຄືນ Prepare
                    </b-button> -->
                    <b-button v-if="isNewB2B ==1 && selectedPurchaseLOCKED ==0 && iskarghuptoaccount ==0 " 
                      class="is-small btn-group-margin"
                      type="is-danger"
                      @click="lockNewB2BProductPrice()"
                      >Lock ລາຄາ
                    </b-button>

                    <!-- <b-button
                      v-if="
                        enableinvoiceedit == 0 &&
                          invoicedetaillist.length > 0 && paymentStatus ==0 && iskarghuptoaccount ==0
                      "
                      class="is-small btn-group-margin"
                      type="is-warning"
                      @click="enableInvoiceEdit()"
                      >ຈຳນວນໄດ້ຮັບຕົວຈິງ (B2B)
                    </b-button>
                    
                    <b-button
                      v-if="
                        enableinvoiceedit == 1 &&
                        invoicedetaillist.length > 0 && iskarghuptoaccount ==0
                      "
                      class="is-small btn-group-margin"
                      type="is-primary"
                      @click="editInvoice()"
                      >ຈຳນວນໄດ້ຮັບຕົວຈິງ (B2B)
                    </b-button> -->
                    <b-button
                      v-if="invoicedetaillist.length > 0 && enableinvoiceedit ==0  && paymentStatus ==0"
                      class="is-small btn-group-margin"
                      type="is-info"
                      @click="print(33)"
                      >ພິມໃບສົ່ງເຄື່ອງ
                    </b-button>

                    <!-- <b-button
                      v-if="invoicedetaillist.length > 0 && enableinvoiceedit ==0 && paymentStatus ==0"
                      class="is-small btn-group-margin"
                      type="is-info"
                      @click="print(3)"
                      >ພິມ Invoice
                    </b-button> -->
                    
                    <!-- <b-button
                      v-if="invoicedetaillist.length > 0 && enableinvoiceedit ==0 && paymentStatus ==0 && iskarghuptoaccount ==0"
                      class="btn-group-margin"
                      type="is-danger"
                      size="is-small"
                      @click="sendKangHuptoAccount(selectedInvoiceDate)"  
                      >ລົງບັນຊີຄ້າງຮັບ
                    </b-button>   -->

                    <!-- <b-button v-if="invoicedetaillist.length > 0 && enableinvoiceedit ==0 && paymentStatus ==0"
                      class="btn-group-margin"
                      type="is-primary"
                      size="is-small"
                      @click="paymentConfirmForm(selectedInvoiceDate)"  
                      >ຢືນຢັນການຊຳລະເງິນ
                    </b-button>  -->

                    <!-- <b-button v-if="iskarghuptoaccount==1 && invoicedetaillist.length > 0 && enableinvoiceedit ==0 && paymentStatus ==0"
                      class="btn-group-margin"
                      type="is-primary"
                      size="is-small"
                      @click="paymentConfirmForm(selectedInvoiceDate)"
                      >ຢືນຢັນການຊຳລະເງິນ
                    </b-button>  -->

                     
                  </div>
                </div>
                <div v-if="paymentStatus == 1">
                  <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ຢືນຢັນການຊຳລະ</div>    

                  <div class="columns">
                    <div class="column">  
                      ຈຳນວນເງິນຄ້າງຊຳລະ  
                      <b-field label="" style="color: red">
                        {{ invoicedetaillisttotal.total | formatNumberLocal}}
                         
                      </b-field>
                    </div>
                    <div class="column">  
                      ຈຳນວນເງິນທີ່ຊຳລະ   
                      <b-field label="">
                        
                        <b-field>
                          <input  
                            type="number"
                            class="input"
                            v-model.trim="invoiceTotal"
                            style=" width: 150px; text-align: right;" 
                          />

                          <!-- <b-input type="number" style="width: 150px; text-align: right;"
                          v-model.trim="invoiceTotal"
                        ></b-input> -->
                         
                        </b-field>
                      </b-field>
                    </div>
                    <div class="column"> </div>
                    <div class="column"> </div>
                  </div>
                  <div class="columns">
                    <div class="column">  
                      ວັນທີຮັບເງິນ   
                      <b-field label="">
                        <b-field>
                          <!-- <b-datepicker
                            :date-formatter="dateTimeFormatter"
                            v-model="stockDate"
                          >  
                          </b-datepicker> -->
                          <b-datepicker
                            v-model="receiptDateTime"
                            :datetime-formatter="dateFormatter"
                            placeholder="ວັນທີຮັບເງິນ"
                            :enable-seconds="true"
                          >
                          </b-datepicker>
                         
                        </b-field>
                      </b-field>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column">  
                      ເລກທີໃບຮັບເງິນ   
                      <b-field label="">
                        <b-field>
                          <b-input
                          v-model.trim="receiveno"
                          placeholder="ເລກທີໃບຮັບເງິນ"
                        ></b-input>
                         
                        </b-field>
                      </b-field>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column">
                      ບິນດຽວ ຫຼື ບິນລວມ
                      <b-field label="">
                        <Multiselect
                          placeholder="ເລືອກ"
                          v-model.trim="selectedPaymentType"
                          label="NAME"
                          track-by="ID"
                          :options="paymentTypeList"
                          @input="onSelectPaymentType"
                        >
                        </Multiselect>
                      </b-field>
                    </div>
                   
                  </div> 

                  <div class="columns" v-if="isManyBill == 1" style="margin: -20px 30px 20px 30px;"> 
                    <div class="column">
                      ເລກບິນທີ່ກ່ຽວຂ້ອງ
                      <div v-for="(bill, index) in billList" :key="index" style="margin-bottom: 10px">
                        <b-input
                          v-model.trim="billList[index]"
                          placeholder="ເລກບິນຮຽນເກັບເງິນ"
                        ></b-input>
                      </div>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column">
                      ທະນາຄານ
                      <b-field label="">
                        <Multiselect
                          placeholder="ເລືອກສິນຄ້າ"
                          v-model.trim="selectedBank"
                          label="NAME"
                          track-by="ID"
                          :options="bankList"
                        >
                        </Multiselect>
                      </b-field>
                    </div>
                  </div>
   
                  <div class="columns">
                    <div class="column">
                      <!-- Image preview -->
                      <img
                        v-if="photopreview"
                        :src="photopreview"
                        width="500"
                        height="500"
                      />
                    </div>
                  </div>
                 
                  <div class="columns">
                    <div class="column">
                      <b-field grouped position="is-right">
                        <div class="buttons">
                          <b-button
                            expanded    
                            type="is-warning"  
                            @click="goBacktoInvoiceDetail()"
                            >ກັບຄືນ
                          </b-button>
                          <b-button
                            expanded
                            type="is-primary"
                            @click="triggerFileInput"
                            >ເລືອກຮູບ
                          </b-button>
                          <b-button
                            expanded    
                            type="is-info"  
                            @click="doPaymentConfirm(selectedInvoiceDate)"
                            >ບັນທຶກ
                          </b-button> 
                        </div> 
                      </b-field>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <b-field
                        grouped
                        position="is-centered"
                      >
                        
                        
                      </b-field>
                      <input
                        type="file"
                        id="fileupload"
                        @change="onFileSelected"
                        style="visibility:hidden;"
                      />
                    </div>
                  </div>

                </div>  
                <div v-else>   
                  <b-field  v-if="invoicedetaillistfull.length > 0" style="font-weight: bold;">  
                    ລາຍການສິນຄ້າ ທີ່ໄດ້ຄົບ <span v-if="fullname">({{fullname}})  </span>
                  </b-field>
                  <table class="table is-fullwidth is-narrow is-small" v-if="invoicedetaillistfull.length > 0">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>

                        <th class="has-text-left " width="25%">
                          ສິນຄ້າ
                        </th>
                        <th class="has-text-left " width="5%">
                          ຫົວໜ່ວຍ
                        </th>
                        <th class="has-text-right " width="10%">
                          ຕ້ອງການ
                        </th>
                        <th class="has-text-right " width="10%">
                          QC1
                        </th>
                        <th class="has-text-right " width="10%">
                          QC2
                        </th>
                        <th class="has-text-right " width="10%">
                          ສົ່ງຕົວຈິງ
                        </th>
                        <th class="has-text-right " width="20%">
                          ລາຄາ
                        </th>
                        <th class="has-text-right " width="15%">
                          ລວມເປັນເງິນ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in invoicedetaillistfull"
                        :key="data.PRODUCTID_SUB"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>

                        <td>
                          <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> 
                          
                          <span v-if="data.ISPROMOTION ==1" style="background-color: greenyellow">{{ data.PRODUCTNAME }}   </span>  
                          <span v-else> {{ data.PRODUCTNAME }}   </span>
                        </td>
                        <td class="has-text-right">
                          
                          {{ data.UNIT }}
                    
                        </td>
                        <td class="has-text-right">
                          
                          {{ data.B2BAMOUNT | formatNumberLocal }}
                    
                        </td>
                      
                        <td class="has-text-right">
                          <b-field v-if="enableinvoiceedit == 1">  
                            <b-input
                              v-model.trim="data.MARKETAMOUNT"
                              type="number"
                              min="0"
                              pattern="[0-1000]+"
                            >
                            </b-input>
                          </b-field>
                          <b-field v-if="enableinvoiceedit == 0">
                            {{ data.MARKETAMOUNT | formatNumberLocal }}
                          </b-field>
                        </td>
                        <td class="has-text-right">
                          <b-field v-if="enableinvoiceedit == 1">
                            <b-input
                              v-model.trim="data.DELIVERAMOUNT"
                              type="number"
                              min="0"
                              pattern="[0-1000]+"
                            >
                            </b-input>
                          </b-field>
                          <b-field v-if="enableinvoiceedit == 0">
                            {{ data.DELIVERAMOUNT | formatNumberLocal }}
                          </b-field>
                        </td>
                        <td class="has-text-right">
                          <b-field v-if="enableinvoiceedit == 1">
                            <b-input
                              v-model.trim="data.B2BGETAMOUNT"  
                              type="number"
                              min="0"
                              pattern="[0-1000]+"
                            >
                            </b-input>
                          </b-field>
                          <b-field v-if="enableinvoiceedit == 0">
                            {{ data.B2BGETAMOUNT | formatNumberLocal }}
                          </b-field>
                        </td>
                        <td class="has-text-right">
                          <!-- {{ data.UNITPRICE | formatNumberLocal }} -->
                          <b-field v-if="enableinvoiceedit == 1">
                            <b-input
                              v-model.trim="data.UNITPRICE"
                              type="number"
                              min="0"
                              pattern="[0-1000]+"
                            >
                            </b-input>
                          </b-field>
                          <b-field v-if="enableinvoiceedit == 0">
                            <span v-if="data.ISPROMOTION ==1" style="background-color: greenyellow">
                              {{ data.UNITPRICE | formatNumberLocal }}
                            </span>
                            <span v-else>
                              {{ data.UNITPRICE | formatNumberLocal }}  
                            </span>
                            
                          </b-field>
                        </td>
                        <td class="has-text-right">
                          {{ data.B2BGETAMOUNT * data.UNITPRICE | formatNumberLocal }}  
                        </td>
                      </tr>
                    </tbody>
                    
                  </table>
                  <br>
                  <b-field v-if="invoicedetaillistsome.length > 0" style="font-weight: bold;">
                    ລາຍການສິນຄ້າ ທີ່ໄດ້ບາງສ່ວນ
                  </b-field>
                  <table class="table is-fullwidth is-narrow is-small"  v-if="invoicedetaillistsome.length > 0">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>

                        <th class="has-text-left " width="15%">
                          ສິນຄ້າ
                        </th>
                        <th class="has-text-left " width="5%">
                          ຫົວໜ່ວຍ
                        </th>
                        <th class="has-text-right " width="15%">
                          ຕ້ອງການ
                        </th>
                        <th class="has-text-right " width="15%">
                          QC1
                        </th>
                        <th class="has-text-right " width="15%">
                          QC2
                        </th>
                        <th class="has-text-right " width="15%">
                          ສົ່ງຕົວຈິງ
                        </th>
                        <th class="has-text-right " width="15%">
                          ລາຄາ
                        </th>
                        <th class="has-text-right " width="15%">
                          ລວມເປັນເງິນ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in invoicedetaillistsome"
                        :key="data.PRODUCTID_SUB"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>

                        <td>
                          {{ data.PRODUCTNAME }}
                        </td>
                        <td>
                          {{ data.UNIT }}  
                        </td>
                        <td class="has-text-right">
                          
                          {{ data.B2BAMOUNT | formatNumberLocal }}
                    
                      </td>
                    
                      <td class="has-text-right">
                          <b-field v-if="enableinvoiceedit == 1">
                            <b-input
                              v-model.trim="data.MARKETAMOUNT"
                              type="number"
                              min="0"
                              pattern="[0-1000]+"
                            >
                            </b-input>
                          </b-field>
                          <b-field v-if="enableinvoiceedit == 0">
                            {{ data.MARKETAMOUNT | formatNumberLocal }}
                          </b-field>
                        </td>
                        <td class="has-text-right">
                          <b-field v-if="enableinvoiceedit == 1">
                            <b-input
                              v-model.trim="data.DELIVERAMOUNT"
                              type="number"
                              min="0"
                              pattern="[0-1000]+"
                            >
                            </b-input>
                          </b-field>
                          <b-field v-if="enableinvoiceedit == 0">
                            {{ data.DELIVERAMOUNT | formatNumberLocal }}
                          </b-field>
                        </td>
                        <td class="has-text-right">
                          <b-field v-if="enableinvoiceedit == 1">
                            <b-input
                              v-model.trim="data.B2BGETAMOUNT"  
                              type="number"
                              min="0"
                              pattern="[0-1000]+"
                            >
                            </b-input>
                          </b-field>
                          <b-field v-if="enableinvoiceedit == 0">
                            {{ data.B2BGETAMOUNT | formatNumberLocal }}
                          </b-field>
                        </td>
                        <td class="has-text-right">
                          <!-- {{ data.UNITPRICE | formatNumberLocal }} -->
                          <b-field v-if="enableinvoiceedit == 1">
                            <b-input
                              v-model.trim="data.UNITPRICE"
                              type="number"
                              min="0"
                              pattern="[0-1000]+"
                            >
                            </b-input>
                          </b-field>
                          <b-field v-if="enableinvoiceedit == 0">
                            {{ data.UNITPRICE | formatNumberLocal }}
                          </b-field>
                        </td>
                      <td class="has-text-right">
                        {{ data.B2BGETAMOUNT * data.UNITPRICE | formatNumberLocal }}  
                      </td>
                      </tr>
                    </tbody>
                    
                  </table>
                  <br>
                  <b-field v-if="invoicedetaillistzero.length > 0" style="font-weight: bold;">
                    ລາຍການສິນຄ້າ ທີ່ບໍ່ມີ
                  </b-field>
                  <table class="table is-fullwidth is-narrow is-small"  v-if="invoicedetaillistzero.length > 0">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>

                        <th class="has-text-left " width="15%">
                          ສິນຄ້າ
                        </th>
                        <th class="has-text-left " width="5%">
                          ຫົວໜ່ວຍ
                        </th>
                        <th class="has-text-right " width="15%">
                          ຕ້ອງການ
                        </th>
                        <th class="has-text-right " width="15%">
                          QC1
                        </th>
                        <th class="has-text-right " width="15%">
                          QC2
                        </th>
                        <th class="has-text-right " width="15%">
                          ສົ່ງຕົວຈິງ
                        </th>
                        <th class="has-text-right " width="15%">
                          ລາຄາ
                        </th>
                        <th class="has-text-right " width="15%">
                          ລວມເປັນເງິນ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in invoicedetaillistzero"
                        :key="data.PRODUCTID_SUB"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>

                        <td>
                          {{ data.PRODUCTNAME }}
                        </td>
                        <td>
                          {{ data.UNIT }}
                        </td>
                        <td class="has-text-right">
                          
                            {{ data.B2BAMOUNT | formatNumberLocal }}
                      
                        </td>
                      
                        <td class="has-text-right">
                          <b-field v-if="enableinvoiceedit == 1">
                            <b-input
                              v-model.trim="data.MARKETAMOUNT"
                              type="number"
                              min="0"
                              pattern="[0-1000]+"
                            >
                            </b-input>
                          </b-field>
                          <b-field v-if="enableinvoiceedit == 0">
                            {{ data.MARKETAMOUNT | formatNumberLocal }}
                          </b-field>
                        </td>
                        <td class="has-text-right">
                          <b-field v-if="enableinvoiceedit == 1">
                            <b-input
                              v-model.trim="data.DELIVERAMOUNT"
                              type="number"
                              min="0"
                              pattern="[0-1000]+"
                            >
                            </b-input>
                          </b-field>
                          <b-field v-if="enableinvoiceedit == 0">
                            {{ data.DELIVERAMOUNT | formatNumberLocal }}
                          </b-field>
                        </td>
                        <td class="has-text-right">
                          <b-field v-if="enableinvoiceedit == 1">
                            <b-input
                              v-model.trim="data.B2BGETAMOUNT"  
                              type="number"
                              min="0"
                              pattern="[0-1000]+"
                            >
                            </b-input>
                          </b-field>
                          <b-field v-if="enableinvoiceedit == 0">
                            {{ data.B2BGETAMOUNT | formatNumberLocal }}
                          </b-field>
                        </td>
                        <td class="has-text-right">
                          <!-- {{ data.UNITPRICE | formatNumberLocal }} -->
                          <b-field v-if="enableinvoiceedit == 1">
                            <b-input
                              v-model.trim="data.UNITPRICE"
                              type="number"
                              min="0"
                              pattern="[0-1000]+"
                            >
                            </b-input>
                          </b-field>
                          <b-field v-if="enableinvoiceedit == 0">
                            {{ data.UNITPRICE | formatNumberLocal }}
                          </b-field>
                        </td>
                        <td class="has-text-right">
                          {{ data.B2BGETAMOUNT * data.UNITPRICE | formatNumberLocal }}  
                        </td>
                      </tr>
                    </tbody>
                    
                  </table>
                  <br>

                  <table class="table is-fullwidth is-narrow is-small"  >
                    <tfoot>
                      <tr>
                        <th class="has-text-right" style="background-color: gray; width: 80%;">
                          ລວມ
                          {{ invoicedetaillisttotal.count | formatNumberLocal }}
                          ລາຍການ
                        </th>
                        <th class="has-text-right" style="background-color: gray; width: 20%;">
                          {{  
                            invoicedetaillisttotal.total | formatNumberLocal
                          }}
                        </th>
                      </tr>
                    </tfoot>
                    
                  </table>  
                </div>
              </b-tab-item>
            </b-tabs>
          </b-field>
        </b-tab-item>
        <b-tab-item label="Receipt">
          <b-field v-if="b2busername === null">
            <button class="button is-info" @click="gotoB2Blist">
              ເລືອກ B2B
            </button>
          </b-field>
          <b-field v-else>
            <b-tabs
              v-model="activeSub2TabReceipt"
              v-if="roleid == 77"
            >
              <b-tab-item label="ວັນທີສົ່ງສິນຄ້າ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="10%">
                        ລະຫັດສັ່ງຊື້
                      </th>
                      <th class="has-text-left " width="15%">
                        ວັນທີສົ່ງສິນຄ້າ
                      </th>
                      <th class="has-text-left " width="15%">
                        ວັນທີຊຳລະ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນ<br />ສິນຄ້າ / ລາຍການ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນເງິນ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ສະຖານະ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in receiptdatelist"
                      :key="data.PURCHASEID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.PURCHASEID }}
                      </td>
                      <td>
                        {{ dateFormatter(data.REDATE) }}
                      </td>
                      <td>
                        {{ dateFormatter(data.RECEIPTDATETIME_ORIGINAL) }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.COUNTPRODUCT }} / {{ data.COUNTPRODUCTSUB }}
                      </td>
                      <td class="has-text-right">
                        {{ data.TOTAL | formatNumberLocal }}
                      </td>
                      <td class="has-text-centered">
                        <b-button
                          class="btn-group-margin"
                          type="is-info"
                          size="is-small"
                          @click="openContractDateForm(4, data)"
                          >ລາຍລະອຽດ
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-tab-item>
              <b-tab-item label="ລາຍລະອຽດສິນຄ້າ">
                <div class="columns">
                  <div class="column">
                    <div>ວັນທີສົ່ງສິນຄ້າ: <span class="receipt-highigt">{{ dateFormatter(selectedReceiptDate) }}</span></div>
                    <b-field v-if="customerPO">
                      Customer PO:- &nbsp; &nbsp; <span class="receipt-highigt" style='color: red'>{{ customerPO }}</span> 
                    </b-field>
                    <div>ວັນທີຊຳລະ:  <span class="receipt-highigt">{{ receiptdata.RECEIPTDATETIME }}</span></div>     
                    <div>ຮູບແບບຊຳລະ:  <span class="receipt-highigt">{{ receiptdata.PAYMENTTYPE}}</span> </div>
                    <div>ທະນາຄານຊຳລະ:  <span class="receipt-highigt">{{ receiptdata.BANK}}</span> </div>
                    <div>ໃບຮັບເງິນ:  <span class="receipt-highigt">{{ receiptdata.RECEIPTNO}}</span> </div>
                    <div> 
                      <!-- <b-button
                          class="btn-group-margin"
                          type="is-info"
                          size="is-small"
                           @click="showPopup(receiptdata.PHOTONAME)"
                          >ເບິງຫຼັກຖານການຊຳລະ
                        </b-button> -->
                      <!-- <img
                          data-v-xcxcc
                          :src="getReceiptImgUrl( receiptdata.PHOTONAME)"  
                          width="80"
                          height="80"  
                          @click="showPopup(receiptdata.PHOTONAME)"
                        /> -->
                    </div>
                    

                  </div>
                  <div class="column">
                  </div>
         
                  <div class="column" style="text-align: right; ">
                    <div class="columns">
                      <!-- <b-button
                      v-if="receiptdetaillist.length > 0"
                      class="is-small btn-group-margin"
                      type="is-info"
                      @click="print(4)"
                      >ພິມ Receipt
                    </b-button> -->
                    </div>
                    <div class="columns" style="margin-top:30px">
                      
                      <div class="column has-text-right">
                        <div>
                            <div>
                                <b-datepicker
                                    :date-formatter="dateFormatter"
                                    v-model="preparedate"
                                >
                                </b-datepicker>
                            </div>
                            <div>
                                <b-button
                                    v-if="receiptdetaillist.length > 0"
                                    class="is-small btn-group-margin"
                                    type="is-primary"
                                    @click="onCopyReceiptToPrepare"
                                >Copy ລາຍການໄປ Prepare
                                </b-button>
                            </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                

                
                                
                <b-field v-if="receiptdetaillistfull.length > 0">
                  ລາຍການສິນຄ້າ ທີ່ໄດ້ຄົບ <span v-if="fullname">({{fullname}})  </span>
                </b-field>
                <table class="table is-fullwidth is-narrow is-small" v-if="receiptdetaillistfull.length > 0">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>

                      <th class="has-text-left " width="15%">
                        ສິນຄ້າ
                      </th>
                      <th class="has-text-left " width="5%">
                        ຫົວໜ່ວຍ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ<br>ທີ່ສັ່ງ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ<br>ທີ່ໄດ້ຮັບ
                      </th>
                      <th class="has-text-right " width="15%">
                        ລາຄາ
                      </th>
                      <th class="has-text-right " width="15%">
                        ລວມເປັນເງິນ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in receiptdetaillistfull"
                      :key="data.PRODUCTID_SUB"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>

                      <td>
                        <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}   
                      </td>
                      <td class="has-text-centered">
                          {{ data.UNIT }}
                      </td>    
                      <td class="has-text-right">
                          {{ data.B2BAMOUNT | formatNumberLocal }}
                      </td>
                      <td class="has-text-right">
                          {{ data.B2BGETAMOUNT | formatNumberLocal }}
                      </td>
                      <td class="has-text-right">
                        {{ data.UNITPRICE | formatNumberLocal }}
                      </td>
                      <td class="has-text-right">
                        {{ data.B2BGETAMOUNT * data.UNITPRICE | formatNumberLocal }}
                      </td>
                    </tr>
                  </tbody>
                  
                </table>

                <br>
                <b-field v-if="receiptdetaillistsome.length > 0">
                  ລາຍການສິນຄ້າ ທີ່ໄດ້ບາງສ່ວນ
                </b-field>
                <table class="table is-fullwidth is-narrow is-small" v-if="receiptdetaillistsome.length > 0">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>

                      <th class="has-text-left " width="15%">
                        ສິນຄ້າ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ<br>ທີ່ສັ່ງ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ<br>ທີ່ໄດ້ຮັບ
                      </th>
                      <th class="has-text-right " width="15%">
                        ລາຄາ
                      </th>
                      <th class="has-text-right " width="15%">
                        ລວມເປັນເງິນ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in receiptdetaillistsome"
                      :key="data.PRODUCTID_SUB"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>

                      <td>
                        {{ data.PRODUCTNAME }}
                      </td>
                      <td class="has-text-right">
                          {{ data.B2BAMOUNT | formatNumberLocal }}
                      </td>
                      <td class="has-text-right">
                          {{ data.B2BGETAMOUNT | formatNumberLocal }}
                      </td>
                      <td class="has-text-right">
                        {{ data.UNITPRICE | formatNumberLocal }}
                      </td>
                      <td class="has-text-right">
                        {{ data.B2BGETAMOUNT * data.UNITPRICE | formatNumberLocal }}
                      </td>
                    </tr>
                  </tbody>
                  
                </table>
                <br>
                <b-field v-if="receiptdetaillistzero.length > 0">
                  ລາຍການສິນຄ້າ ທີ່ບໍ່ໄດ້
                </b-field>
                <table class="table is-fullwidth is-narrow is-small" v-if="receiptdetaillistzero.length > 0">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>

                      <th class="has-text-left " width="15%">
                        ສິນຄ້າ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ<br>ທີ່ສັ່ງ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ<br>ທີ່ໄດ້ຮັບ
                      </th>
                      <th class="has-text-right " width="15%">
                        ລາຄາ
                      </th>
                      <th class="has-text-right " width="15%">
                        ລວມເປັນເງິນ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in receiptdetaillistzero"
                      :key="data.PRODUCTID_SUB"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>

                      <td>
                        {{ data.PRODUCTNAME }}
                      </td>
                      <td class="has-text-right">
                          {{ data.B2BAMOUNT | formatNumberLocal }}
                      </td>
                      <td class="has-text-right">
                          {{ data.B2BGETAMOUNT | formatNumberLocal }}
                      </td>
                      <td class="has-text-right">
                        {{ data.UNITPRICE | formatNumberLocal }}
                      </td>
                      <td class="has-text-right">
                        {{ data.B2BGETAMOUNT * data.UNITPRICE | formatNumberLocal }}
                      </td>
                    </tr>
                  </tbody>
                  
                </table>

                <br>

                <table class="table is-fullwidth is-narrow is-small"  >
                  <tfoot>
                    <tr>
                      <th class="has-text-right" style="background-color: gray; width: 80%;">
                        ລວມ
                        {{ receiptdetaillisttotal.count | formatNumberLocal }}
                        ລາຍການ
                      </th>
                      <th class="has-text-right" style="background-color: gray; width: 20%;">
                        {{  
                           receiptdetaillisttotal.total | formatNumberLocal
                        }}
                      </th>
                    </tr>
                  </tfoot>
                  
                </table>
              </b-tab-item>

              <b-tab-item label="ສິນຄ້າທີ່ຊື້ປະຈຳ">
                
                <div class="columns">
                  <div class="column">
                    <Multiselect
                      placeholder="ປະເພດສິນຄ້າ"
                      v-model.trim="selectedBuyListProductType"
                      label="TYPENAME"
                      track-by="TYPENID"
                      :options="buyListProductTypeList"
                      @input="onSelectedProductType()"
                    ></Multiselect>
                  </div>
                  <div class="column">
                    <Multiselect  
                      placeholder="ສິນຄ້າ"
                      v-model.trim="selectedBuyListProduct"
                      label="PRODUCTNAME"
                      track-by="PRODUCTID"
                      :options="buyListProductList"
                      @input="onSelectedProduct()"
                    ></Multiselect>
                  </div>
                  <div class="column">
                    <Multiselect  
                      placeholder="ສິນຄ້າຍ່ອຍ"
                      v-model.trim="selectedBuyListProductSub"
                      label="PRODUCTNAME_SUB"
                      track-by="PRODUCTID_SUB"
                      :options="buyListProductSubList"
                      @input="onSelectedProductSub()"
                    ></Multiselect>
                  </div>
                  <div class="column has-text-right">
                    <div>
                        <div>
                            <b-datepicker
                                :date-formatter="dateFormatter"
                                v-model="preparedate"
                            >
                            </b-datepicker>
                        </div>
                        <div>
                            <b-button
                                class="btn-group-margin"
                                type="is-primary"   
                                @click="onCopyReceiptToPrepareV2"
                            >ເພີ່ມເຂົ້າລາຍການ Prepare
                            </b-button>
                        </div>
                    </div>
                  </div>
                </div>  

                
                <div class="columns">
                  <div class="column" style="color: white">   
                    -  
                  </div>
                  <div class="column" style="text-align: right">
                    <b-button
                        class="btn-group-margin"
                        type="is-info"
                        @click="saveBuyHistory()"
                      >ບັນທຶກລາຍການ
                    </b-button>    
                  </div>
                  <div class="column" style="color: white">   
                    -
                  </div>
                </div>                  
                
                <table class="table is-fullwidth is-narrow is-small" v-if="buylist.length > 0">
                  <thead>
                    <tr>
                      <!-- <th class="has-text-centered " width="2%">#</th> -->

                      <th class="has-text-left " width="20%">
                        ສິນຄ້າ (ຫົວໜ່ວຍ)
                      </th>
                      <th class="has-text-left " width="30%">
                        ຈຳນວນທີ1 (<span style="color: red">{{this.countBuyHistoryAmount1}}</span>)  
                      </th>
                      <th class="has-text-left " width="30%">
                        ຈຳນວນທີ2  (<span style="color: red">{{this.countBuyHistoryAmount2}}</span>)  
                      </th>
                      <th class="has-text-left " width="5%">
                        ຈັດການ
                      </th>  
                    </tr>   
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in buylist"
                      :key="data.ID"
                    >
                      <!-- <td class="has-text-centered">{{ index + 1 }}</td> -->

                      <td>
                        <!-- <b-button
                            class="is-small btn-group-margin"
                            type="is-danger"  
                            size="is-small"
                            @click="saveProductToBlackList(data)"  
                        >XXX 
                        </b-button> -->

                        <b-button
                            class="is-small btn-group-margin"
                            type="is-danger"
                            size="is-small"
                            @click="removeProductFormBuyList(data.ID)"  
                        >X
                        </b-button>   
                        <br>
                        {{ index + 1 }}. {{ data.PRODUCTNAME_SUB }} <br> <span style="color: white ; background-color: black " >({{data.UNIT}})</span>
                      </td>
                   
                      
                      <td>  
                        <span v-if="data.AMOUNT11 !=0 && data.AMOUNT11 != null" style="font-size:20px">
                          &#9989; <br>
                        </span> 
                        <b-field>      
                             
                          <b-input width="100px"
                            v-model.trim="data.AMOUNT1"
                            type="number"
                            step="any"
                          >     
                          </b-input>
                        </b-field>
                       
                        
                      </td>  
                      
                      <td>
                        <span v-if="data.AMOUNT22 !=0 && data.AMOUNT22 != null" style="font-size:20px">
                          &#9989; <br>
                        </span> 
                        <b-field>
                           
                          <b-input width="100px"
                            v-model.trim="data.AMOUNT2"
                            type="number"
                           step="any"
                          >  
                          </b-input> 
                        </b-field>
                        
                        
                      </td>
                      <td>
                        <b-form-select   
                            v-model.trim="data.ISCLIAMED"
                            :options="b2bproductIsCliamedList"
                            style="width: 50px; border-radius: 5px; border: 1px solid #ced4da; padding: 0.375rem 0.75rem; font-size: 1rem; line-height: 1.5; color: #495057; background-color: #fff; background-clip: padding-box;"
                            class="mb-3"
                        ></b-form-select>
                        <b-button
                            class="btn-group-margin"
                            type="is-info"
                            size="is-small"
                            @click="saveBuyHistory()"    
                          >ບັນທຶກ
                        </b-button> 
                      </td>
     
                    </tr>
                  </tbody>
                  
                </table>
              
              </b-tab-item>
            </b-tabs>
          </b-field>
        </b-tab-item>
        
      </b-tabs>
    </div>

    <div class="contain print-only page-break">
      <div class="contain">
        
        <div class="columns" v-if="printtype==2000">  
          <div class="column">
            <div v-if="printtype !=5 && printtype !=1000  && printtype !=10001"
              style=" padding: 0 0 0 0; margin: 0 0 0 0 ;"
            >
              <img
                class="image-area"
                style="width: 70px;"
                :src="getImgUrl('logo/agrilaologo.png')"
                alt="Placeholder image"
              />    
            </div>
            <div class="columns">
              <div class="column" style="" v-if="printtype !=5 && printtype !=1000 && printtype !=10001">
                <div style="font-size: 12px;">
                  Agrilao Innovation Ordinary Partnertship
                </div>
                <div style="font-size: 12px;">
                  Address: Dongdok-Sikuert Road,
                </div>
                <div style="font-size: 12px; padding-left: 50px;">
                  Sikhottabong Distirct, Vientiane Capital, Laos
                </div>
                <div style="font-size: 12px;">
                  Contact No: +85620 55333483, +85620 28040508
                </div>
                <div style="font-size: 12px;">
                  Email: argilao.lpdr@gmail.com
                </div>
              </div>
      
              <div class="column" style="text-align: right;">   
                <div>
                  
                  <span
                    v-if="checkProductList.length > 0 && printtype == 2000"
                    >Date:-
                    {{ dateFormatter(checkProductList[0].REDATE) }}</span
                  >


                </div>
                <div>
                  <span v-if="quotationdetaillist.length > 0 && printtype == 2"
                    >No: Agri-{{ quotationdetaillist[0].PURCHASEID }}/{{
                      year(quotationdetaillist[0].QUOTATIONDATE)
                    }}</span
                  >
                  <span v-if="quotationdetaillist.length > 0 && printtype == 22"
                    >No: Agri-{{ quotationdetaillist[0].PURCHASEID }}/{{
                      year(quotationdetaillist[0].QUOTATIONDATE)
                    }}</span
                  >
                  <span v-if="invoicedetaillist.length > 0 && printtype == 3"
                    >No: Agri-{{ invoicedetaillist[0].PURCHASEID }}/{{
                      year(invoicedetaillist[0].INVOICEDATE)
                    }}</span
                  >
                  <span v-if="invoicedetaillist.length > 0 && printtype == 33"
                    >No: Agri-{{ invoicedetaillist[0].PURCHASEID }}/{{
                      year(invoicedetaillist[0].INVOICEDATE)
                    }}</span
                  >
                  <span v-if="receiptdetaillist.length > 0 && printtype == 4"
                    >No: Agri-{{ receiptdetaillist[0].PURCHASEID }}/{{
                      year(receiptdetaillist[0].RECEIPTDATE)
                    }}</span
                  >
                  <span v-if="checkProductList.length > 0 && printtype == 2000"
                    >No: Agri-{{ checkProductList[0].PURCHASEID }}/{{
                      year(checkProductList[0].REDATE)
                    }}</span
                  >
                </div>
                <div v-if="marketorderdatedetail.length > 0 && printtype == 5">
                  <span>
                    BATCHID: {{marketorderdatedetail[0].MARKETBATCHID }}
                  </span><br>
                  <span> 
                    Date: {{ dateFormatter(marketorderdatedetail[0].REDATE) }}
                  </span><br>
                  <span >{{ marketorderdatedetail[0].MARKETNAME }}
                  </span>
                </div>
              </div>
            </div>

            
            <div style="margin-top: 0px; text-align: center;">
              <div style="font-size: 24px; font-weight: bold">
                <span v-if="printtype === 2"> Quotation <br>  
                  <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span><br>  
                  <span v-if="fullname">({{fullname}})  </span><br>
                  <span v-if="customerPO">(PO: &nbsp;{{customerPO}})  </span><br>
                </span>
                <span v-else-if="printtype === 22">ໃບສົ່ງເຄື່ອງ <br>
                  <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span>
                  <span v-if="fullname">({{fullname}})  </span>
                  <span v-if="customerPO">(PO: &nbsp;{{customerPO}})  </span><br>
                </span> 
                <span v-else-if="printtype === 3">Invoice<br>
                  <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span><br>
                  <span v-if="fullname">({{fullname}})  </span>  
                  <span v-if="customerPO">(PO: &nbsp;{{customerPO}})  </span><br>
                </span>  
                <span v-else-if="printtype === 33">ໃບສົ່ງເຄື່ອງ<br>
                  <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span><br>
                  <span v-if="fullname">({{fullname}})  </span>
                  <span v-if="customerPO">(PO: &nbsp;{{customerPO}})  </span><br>
                </span>  
                <span v-else-if="printtype === 333">Invoice<br>
                  <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span><br>
                  <span v-if="fullname">({{fullname}})  </span>
                  <span v-if="customerPO">(PO: &nbsp;{{customerPO}})  </span><br>
                </span>    
                <span v-else-if="printtype === 4">Receipt<br>
                  <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span><br>
                  <span v-if="fullname">({{fullname}})  </span>
                  <span v-if="customerPO">(PO: &nbsp;{{customerPO}})  </span><br>
                </span>
                <span v-else-if="printtype === 5">ໃບອອກຕະຫຼາດ</span>   
                
                
              </div>
            </div>   
            <div style="" v-if="printtype ===1000"> 
              <div class="columns">
                <div class="column" style="width: 90%; text-align: center">
                    <span style="font-size: 20px;">ບໍລິສັດ Agrilao ໃຫ້ບໍລິການອອກຕະຫຼາດ ອອນລາຍ<br>  
                    <span style="font-size: 18px;"> ລາຄາໂປຣໂມຊັນ ປະຈຳວັນທີ {{dateFormatter(promotionList[0].REDATE)}}</span><br>
                    <span style="font-size: 18px;"> (ລາຄາໂປຣໂມຊັນນີ້ ສຳລັບການສັ່ງຊື້ 1 ກິໂລ ຂຶ້ນໄປ)</span>  
                  </span>
                </div>
              </div>
              
            </div>  
            <div style="" v-if="printtype ===10001"> 
              <div class="columns">
                <div class="column" style="width: 90%; text-align: center">
                    <span style="font-size: 20px;">ບໍລິສັດ Agrilao ໃຫ້ບໍລິການອອກຕະຫຼາດ ອອນລາຍ<br>  
                    <span style="font-size: 18px;"> ລາຄາໂປຣໂມຊັນ (ຮ້ານໃໝ່) ປະຈຳວັນທີ {{dateFormatter(promotionList[0].REDATE)}}</span><br>
                    <span style="font-size: 18px;"> (ລາຄາໂປຣໂມຊັນນີ້ ສຳລັບການສັ່ງຊື້ 1 ກິໂລ ຂຶ້ນໄປ)</span>
                  </span>
                </div>
              </div>
              
            </div>
            <div style="height: 10px;"></div>

            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 1000  && promotionList.length > 0"   
            >
              <thead>  
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາກິໂລ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາໝື່ນ/ ແພັກ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in promotionList"
                  :key="data.PRODUCTNAME"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td  class="set-border">
                    {{data.PRODUCTNAME}} 
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.KGPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.PACKPRICE | formatNumberLocal }}
                  </td>
                  
                  
                  
                </tr>
              </tbody>
            </table>

            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 10001  && promotionList.length > 0"    
            >
              <thead>  
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາກິໂລ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາໝື່ນ/ ແພັກ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in promotionList"
                  :key="data.PRODUCTNAME"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td  class="set-border">
                    {{data.PRODUCTNAME}} 
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.KGPRICE-2000 | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ (data.KGPRICE-2000)*12  | formatNumberLocal }}
                  </td>
                  
                  
                  
                </tr>
              </tbody>
            </table>


            <b-field v-if="printtype == 2 && quotationdetaillistfull.length > 0">
              ລາຍການສິນຄ້າ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 2  && quotationdetaillistfull.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in quotationdetaillistfull"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}      
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BAMOUNT | formatNumberLocal }}     
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}    
                  </td>

                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BAMOUNT*data.UNITPRICE | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>

            <table class="table is-fullwidth is-narrow is-small"  v-if="printtype == 2">
              <tfoot>
                <tr>
                  <th class="has-text-right" style="background-color: beige; width: 80%;">
                    ລວມ
                    {{ quotationdetaillistfull.length | formatNumberLocal }}
                    ລາຍການ
                  </th>
                  <th class="has-text-right" style="background-color: beige; width: 20%;">
                    {{  
              
                        _.sumBy(quotationdetaillistfull, (i) => i["MARKETAMOUNT"] * i["UNITPRICE"] * 1)  
                        | formatNumberLocal
                    }}
                  </th>
                </tr>
              </tfoot>
            
            </table>
            
            



            <b-field v-if="printtype == 22  && quotationdetaillistfull.length > 0">
              ລາຍການສິນຄ້າ 
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 22 && quotationdetaillistfull.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ +  
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in quotationdetaillistfull"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BAMOUNT | formatNumberLocal }}  
                  </td>
                  
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}  
                  </td>
                  
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>
            

           

            <!-- statrt ໃບຮຽກເກັບລວມ -->
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 333  && invoicedatelist.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລຳດັບ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="40%"
                    style="vertical-align: middle;"
                  >
                    ລາຍການ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນເງິນ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedatelist" 
                  :key="data.PURCHASEID"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="has-text-left set-border">
                    ໃບເກັບເງິນເລກທີ: Agri-{{data.PURCHASEID}}/{{ year(data.REDATE)}}  ລົງວັນທີ: {{ dateFormatter(data.REDATE) }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.TOTAL | formatNumberLocal }}  
                  </td>

                  <td class="has-text-right set-border"></td>   
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th class="has-text-right set-border" colspan="2">  
                    ລວມ
                    {{ invoicedatelist.length | formatNumberLocal }}
                    ລາຍການ
                  </th>
                  <th class="has-text-right set-border" >
                    {{
                          _.sumBy(invoicedatelist, (i) => i["TOTAL"]*1)     
                            | formatNumberLocal
                        }} 
                  </th>
                  <th class="has-text-right set-border">
                      
                  </th>
                </tr>
              </tfoot>

            </table>

            <!-- end ໃບຮຽກເກັບລວມ -->

            <b-field v-if="printtype == 3 && invoicedetaillistfull.length > 0">
              ລາຍການສິນຄ້າ ທີ່ໄດ້ຄົບ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 3  && invoicedetaillistfull.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedetaillistfull"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}  
                  </td>

                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT*data.UNITPRICE | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>
            
            <b-field v-if="printtype == 3  && invoicedetaillistsome.length > 0">
              <br> ລາຍການສິນຄ້າ ທີ່ໄດ້ບາງສ່ວນ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 3  && invoicedetaillistsome.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ໋ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedetaillistsome"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}  
                  </td>

                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT*data.UNITPRICE | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>
            
              <b-field v-if="printtype == 3  && invoicedetaillistzero.length > 0">
                <br>ລາຍການສິນຄ້າ ທີ່ບໍ່ມີ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 3  && invoicedetaillistzero.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedetaillistzero "
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}  
                  </td>

                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT*data.UNITPRICE | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>

            <table class="table is-fullwidth is-narrow is-small"  v-if="printtype == 3">
              <tfoot>
                <tr>
                  <th class="has-text-right" style="background-color: gray; width: 70%;">
                    ລວມ
                    {{ invoicedetaillisttotal.count | formatNumberLocal }}
                    ລາຍການ
                  </th>
                  <th class="has-text-right" style="background-color: gray; width: 20%;">
                    {{  
                        invoicedetaillisttotal.total | formatNumberLocal
                    }}
                  </th>
                  <th class="has-text-right" style="background-color: gray; width: 10%;">
                    
                  </th>
                </tr>
              </tfoot>
            
            </table>
            
            <b-field v-if="printtype == 33  && invoicedetaillistfull.length > 0">
              ລາຍການສິນຄ້າ ທີ່ໄດ້ຄົບ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 33 && invoicedetaillistfull.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedetaillistfull"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}  
                  </td>
                  
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>

            <b-field v-if="printtype == 33  && invoicedetaillistsome.length > 0">
              ລາຍການສິນຄ້າ ທີ່ໄດ້ບາງສ່ວນ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 33 && invoicedetaillistsome.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ໋ວຍ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedetaillistsome"  
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}  
                  </td>
                  
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>

            <b-field v-if="printtype == 33  && invoicedetaillistzero.length > 0"> 
              ລາຍການສິນຄ້າ ທີ່ບໍ່ມີ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 33 && invoicedetaillistzero.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedetaillistzero"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}  
                  </td>
                  
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>

            
            <b-field v-if="printtype == 4 && receiptdetaillistfull.length > 0">
              ລາຍການສິນຄ້າ ທີ່ໄດ້ທັງໝົດ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 4 && receiptdetaillistfull.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in receiptdetaillistfull"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT * data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>
              
            </table>

            
            <b-field v-if="printtype == 4 && receiptdetaillistsome.length > 0">
              <br> ລາຍການສິນຄ້າ ທີ່ໄດ້ບາງສ່ວນ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 4 && receiptdetaillistsome.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in receiptdetaillistsome"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT * data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>
              
            </table>

            
            <b-field v-if="printtype == 4 && receiptdetaillistzero.length > 0">
              <br> ລາຍການສິນຄ້າ ທີ່ບໍ່ໄດ້
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 4 && receiptdetaillistzero.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in receiptdetaillistzero"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT * data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>
              
            </table>

            <table class="table is-fullwidth is-narrow is-small"  v-if="printtype == 4">
              <tfoot>
                <tr>
                  <th class="has-text-right" style="background-color: gray; width: 70%;">
                    ລວມ
                    {{ receiptdetaillisttotal.count | formatNumberLocal }}
                    ລາຍການ
                  </th>
                  <th class="has-text-right" style="background-color: gray; width: 20%;">
                    {{  
                       receiptdetaillisttotal.total | formatNumberLocal
                    }}
                  </th>
                  <th class="has-text-right" style="background-color: gray; width: 10%;">
                    
                  </th>
                </tr>
              </tfoot>
            
            </table>
           

            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 5"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in marketorderdatedetail"
                  :key="data.ID"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    {{ data.PRODUCTNAME_SUB }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.QUANTITY | formatNumberLocal }}
                  </td>

                 
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>
            </table>

            <div class="columns" style="page-break-inside: avoid;" >
              <div class="column" v-if="printtype !=5 && printtype !=1000 && printtype !=10001">  
                <div>
                  <div style="font-weight: bold; font-size: 16px;">
                    Confirm and Accept by Customer
                  </div>

                  <div style="font-size: 12px; ">Name: {{ b2bname }}</div>

                  <div style="font-size: 12px; " v-if="b2btype !=2">
                    Contact Number: {{ b2bphoneno }}
                  </div>

                  <div style="font-size: 12px; ">
                    Address: {{ b2bprovince }} {{ b2bdistrict }} {{ b2bvillage }}
                  </div>
                  <div style="font-size: 12px;">
                    .................................................................................
                  </div>
                  <div style="font-size: 12px; ">
                    (Signature/ Company Stamp)
                  </div>
                </div>
                <br>
                <div v-if="printtype ==3 || printtype ==333">  
                  <img 
                    class="image-area"
                    width="80%"    
                    style=""
                    :src="getImgUrl('sign/qr.png')"
                    alt="Placeholder image"
                  />
                </div>  
                
              </div>
             
              <div
                class="column"
                style="text-align: center; font-weight: bold; font-size: 16px;"
                v-if="printtype !=5"
              >
                <div style="text-align: center;">
                  <div v-if="printtype ===1000 || printtype ===10001" style="text-align: right;">
                    Agrilao Innovation Ordinary Partnership<br> 
                    Deputy Managing Director<br>
                  </div>
                  <div v-else>
                    Agrilao Innovation Ordinary Partnership<br> 
                    Deputy Managing Director<br>
                  </div>
                  
                  <!-- <b-field v-if="b2bname =='520' && (printtype == '3'|| printtype == '333')">  -->
                  <b-field v-if="companytype==2 || companytype==3">
                       
                  </b-field>  
                  <b-field v-else>
                    <b-field style="text-align: right;">
                      <img v-if="printtype ===1000 || printtype ===10001"
                        class="image-area"
                        width="25%"    
                        style=""
                        :src="getImgUrl('sign/deputymanagingdirector.png')"  
                        alt="Placeholder image"
                      />
                    </b-field>
                      
                    <img v-if="printtype !=1000 && printtype !=10001"
                      class="image-area"
                      style=""
                      :src="getImgUrl('sign/deputymanagingdirector.png')"
                      alt="Placeholder image"
                    />
                  </b-field>  
                  
                </div> 
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-else-if="printtype==3000"> 
          <div class="column">
              
            <div>
              <b-field
                  v-for="(quotation) in allquotationdatelist"
                  :key="quotation.PURCHASEID"
                >
                  <div class="columns" style="padding: 0 0 0 0; margin: 0 0 0 0 ; page-break-inside: avoid;"  v-if="quotation.PURCHASEID">    
                    <div class="column" style="padding: 0 0 0 0; margin: 0 0 0 0 ;">
                      <div style="padding: 0 0 0 0; margin: 0 0 0 0 ;">
                        <div class="columns">   
                          <div class="column">
                            <img
                              class="image-area"
                              style="width: 70px;"
                              :src="getImgUrl('logo/agrilaologo.png')"
                              alt="Placeholder image"
                            /> 
                          </div> 
                          
                        </div>
                      </div>  
                      <div  style="padding: 0 0 0 0; margin: 0 0 0 0 ;"> 
                        <div class="columns" style="padding: 0 0 0 0; margin: 0 0 0 0 ;"> 
                          <div class="column" style="padding: 0 0 0 0; margin: 0 0 0 0 ;">
                            <div style="font-size: 12px;">
                              Agrilao Innovation Ordinary Partnertship
                            </div>
                            <div style="font-size: 12px;">
                              Address: Dongdok-Sikuert Road,
                            </div>
                            <div style="font-size: 12px; padding-left: 50px;">
                              Sikhottabong Distirct, Vientiane Capital, Laos
                            </div>
                            <div style="font-size: 12px;">
                              Contact No: +85620 55333483, +85620 28040508
                            </div>
                            <div style="font-size: 12px;">
                              Email: argilao.lpdr@gmail.com
                            </div>
                          </div>
                          <div class="column" style="text-align: right; font-size: 14px;" >
                            <div>
                              <span>Date:{{ dateFormatter(quotation.REDATE) }}</span>
                            </div>
                            <div>
                              <span >No: Agri-{{ quotation.PURCHASEID }}/{{year(quotation.REDATE)}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="margin-top: -40px; margin-bottom:10px; font-weight: bold; text-align: center;">
                        <span style="font-size: 20px;">ໃບສົ່ງເຄື່ອງ<br>  
                          <span style="font-size: 20px; "> {{ quotation.COMPANY }}</span>
                        </span> 
                      </div>
                      
                      <table
                        class="table is-fullwidth is-narrow is-small"
                        v-if="quotation.full && quotation.full.length !== undefined && quotation.full.length !=0"
                        style="font-size: 14px"
                      >
                        <thead>  
                          <tr style="height: 50px;">
                            <th
                              class="has-text-centered set-border"
                              width="5%"
                              style="vertical-align: middle;"
                            >
                              #
                            </th>
                            <th
                              class="has-text-centered set-border"
                              width="20%"
                              style="vertical-align: middle;"
                            >
                              ສິນຄ້າ
                            </th>
                            <th
                              class="has-text-centered set-border"
                              width="10%"
                              style="vertical-align: middle;"
                            >
                              ຈຳນວນ <br> ທີ່ສັ່ງ
                            </th>
                            <th
                              class="has-text-centered set-border"
                              width="10%"
                              style="vertical-align: middle;"
                            >
                              ຈຳນວນ <br> ທີ່ໄດ້ຮັບ
                            </th>
                            
                            <th
                              class="has-text-centered set-border"
                              width="10%"
                              style="vertical-align: middle;"
                            >
                              ໝາຍເຫດ
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(data, index) in quotation.full"
                            :key="data.PRODUCTID_SUB"
                          >
                            <td class="has-text-centered set-border">{{ index + 1 }}</td>

                            <td class="set-border">
                              <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}      
                            </td>
                            <td class="has-text-right set-border">
                              {{ data.B2BAMOUNT | formatNumberLocal }}     
                            </td>
                            <td class="has-text-right set-border">
                              {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                            </td>

                           
                            <td class="has-text-right set-border"></td>
                          </tr>
                        </tbody>

                      </table>
                      <div style="page-break-inside: avoid;" >
                        <div class="columns" >
                          <div class="column" >  
                            <div>
                              <div style="font-weight: bold; font-size: 14px;">
                                Confirm and Accept by Customer
                              </div>

                              <div style="font-size: 12px; ">Name: {{ quotation.COMPANY }}</div>

                              <div style="font-size: 12px; " v-if="b2btype !=2">
                                Contact Number: {{ quotation.PHONENO }}
                              </div>

                              <div style="font-size: 12px; ">
                                Address: {{ quotation.PROVINCENAME }} {{ quotation.DISTRICT }} {{ quotation.VILLAGE }}
                              </div>
                              <div style="font-size: 12px;">
                                .................................................................................
                              </div>
                              <div style="font-size: 12px; ">
                                (Signature/ Company Stamp)
                              </div>
                            </div>
                            
                            
                          </div>
                        
                          <div
                            class="column"
                            style="text-align: center; font-weight: bold; font-size: 16px;"
                           
                          >
                            <div style="text-align: center;">
                             
                              <div style="font-size: 14px;">
                                Agrilao Innovation Ordinary Partnership<br> 
                                Deputy Managing Director<br>
                              </div>
                              <b-field v-if="companytype==2 || companytype==3">
                    
                              </b-field>      
                              
                              <b-field v-else>
                                <img
                                  width="60%"      
                                  class="image-area"
                                  style=""
                                  :src="getImgUrl('sign/deputymanagingdirector.png')"   
                                  alt="Placeholder image"
                                />
                              </b-field>  
                              
                            </div> 
                          </div>
                        </div>
                      </div>
                    </div>  
                  </div>
              </b-field>   
            </div>
            
          </div> 


            

              
        </div>

        <div class="columns" v-else>
          <div class="column">
            <div v-if="printtype !=5 && printtype !=1000 && printtype !=10001"
              style=" padding: 0 0 0 0; margin: 0 0 0 0 ;"
            >
              <img
                class="image-area"
                style="width: 70px;"
                :src="getImgUrl('logo/agrilaologo.png')"
                alt="Placeholder image"
              />    
            </div>
            <div class="columns">
              <div class="column" style="" v-if="printtype !=5 && printtype !=1000 && printtype !=10001">
                <div style="font-size: 12px;">
                  Agrilao Innovation Ordinary Partnertship
                </div>
                <div style="font-size: 12px;">
                  Address: Dongdok-Sikuert Road,
                </div>
                <div style="font-size: 12px; padding-left: 50px;">
                  Sikhottabong Distirct, Vientiane Capital, Laos
                </div>
                <div style="font-size: 12px;">
                  Contact No: +85620 55333483, +85620 28040508
                </div>
                <div style="font-size: 12px;">
                  Email: argilao.lpdr@gmail.com  
                </div>
                <div style="margin-top: 20px;">
                  Customer: &nbsp; <span style="font-size: 14px; font-weight: bold;"> {{ b2bname }}</span>
                </div>
                <div v-if="fullname">
                  Sub-Customer: &nbsp;  <span style="font-size: 14px;" >({{fullname}})  </span>
                </div>
                <div v-if="customerPO" >
                  PO: &nbsp;  <span style="font-size: 14px; font-weight: bold;"> {{customerPO}}  </span>
                </div>
                
              </div>
      
              <div class="column" style="text-align: right;">   
                <div>
                  <span v-if="quotationdetaillist.length > 0 && (printtype == 2 || printtype ==222)"
                    >Date:
                    {{
                      dateFormatter(quotationdetaillist[0].REDATE)
                    }}</span
                  >
                  <span
                    v-else-if="quotationdetaillist.length > 0 && printtype == 22"
                    >Date:
                    {{ dateFormatter(quotationdetaillist[0].REDATE) }}</span
                  >
                  <span
                    v-else-if="invoicedetaillist.length > 0 && printtype == 3"
                    >Date:
                    {{ dateFormatter(invoicedetaillist[0].REDATE) }}</span
                  >
                  <span
                    v-else-if="invoicedetaillist.length > 0 && printtype == 33"  
                    >Date:
                    {{ dateFormatter(invoicedetaillist[0].REDATE) }}</span
                  >
                  <span
                    v-else-if="invoicedatelist.length > 0 && printtype == 333"  
                    >Date:
                    <!-- {{ dateFormatter(currentDate) }}</span -->
                    {{ dateFormatter(invoicedatelist[0].REDATE) }}</span
                  >
                  <span
                    v-else-if="receiptdetaillist.length > 0 && printtype == 4"
                    >Date:
                    {{ dateFormatter(receiptdetaillist[0].REDATE) }}</span
                  >

                  <span
                    v-else-if="checkProductList.length > 0 && printtype == 2000"
                    >Date:
                    {{ dateFormatter(checkProductList[0].REDATE) }}</span
                  >


                </div>
                <div>
                  <span v-if="quotationdetaillist.length > 0 &&(printtype == 2 || printtype ==222)"
                    >No: Agri-{{ quotationdetaillist[0].PURCHASEID }}/{{
                      year(quotationdetaillist[0].QUOTATIONDATE)
                    }}</span
                  >
                  <span v-if="quotationdetaillist.length > 0 && printtype == 22"
                    >No: Agri-{{ quotationdetaillist[0].PURCHASEID }}/{{
                      year(quotationdetaillist[0].QUOTATIONDATE)
                    }}</span
                  >
                  <span v-if="invoicedetaillist.length > 0 && printtype == 3"
                    >No: Agri-{{ invoicedetaillist[0].PURCHASEID }}/{{
                      year(invoicedetaillist[0].INVOICEDATE)
                    }}</span
                  >
                  <span v-if="invoicedetaillist.length > 0 && printtype == 33"
                    >No: Agri-{{ invoicedetaillist[0].PURCHASEID }}/{{
                      year(invoicedetaillist[0].INVOICEDATE)
                    }}</span
                  >
                  <span v-if="receiptdetaillist.length > 0 && printtype == 4"
                    >No: Agri-{{ receiptdetaillist[0].PURCHASEID }}/{{
                      year(receiptdetaillist[0].RECEIPTDATE)
                    }}</span
                  >
                  <span v-if="checkProductList.length > 0 && printtype == 2000"
                    >No: Agri-{{ checkProductList[0].PURCHASEID }}/{{
                      year(checkProductList[0].REDATE)
                    }}</span
                  >
                </div>
                <div v-if="marketorderdatedetail.length > 0 && printtype == 5">
                  <span>
                    BATCHID: {{marketorderdatedetail[0].MARKETBATCHID }}
                  </span><br>
                  <span> 
                    Date: {{ dateFormatter(marketorderdatedetail[0].REDATE) }}
                  </span><br>
                  <span >{{ marketorderdatedetail[0].MARKETNAME }}
                  </span>
                </div>
              </div>
            </div>

            
            <div style="margin-top: 0px; text-align: center;">
              <div style="font-size: 24px; font-weight: bold">
                <!-- <span v-if="printtype === 2"> Quotation <br>
                  <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span>
                </span>
                <span v-else-if="printtype === 22">ໃບສົ່ງເຄື່ອງ <br>
                  <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span>
                </span> 
                <span v-else-if="printtype === 3">Invoice<br>
                  <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span>
                </span>
                <span v-else-if="printtype === 33">ໃບສົ່ງເຄື່ອງ<br>
                  <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span>
                </span>  
                <span v-else-if="printtype === 333">Invoice<br>
                  <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span>
                </span>    
                <span v-else-if="printtype === 4">Receipt<br>
                  <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span>     
                </span>
                <span v-else-if="printtype === 5">ໃບອອກຕະຫຼາດ</span> -->


                <span v-if="printtype === 2 || printtype === 222"> Quotation <br>
                  <!-- <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span>  -->
                  <!-- <span style="font-size: 18px; margin-left:10px" v-if="fullname">({{fullname}})  </span>
                  <span v-if="customerPO" style="font-size: 16px"> (PO: &nbsp;{{customerPO}})  </span><br> -->
                </span>
                <span v-else-if="printtype === 22">ໃບສົ່ງເຄື່ອງ <br>
                  <!-- <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span> -->
                  <!-- <span style="font-size: 18px; margin-left:10px" v-if="fullname">({{fullname}})  </span>
                  <span v-if="customerPO" style="font-size: 16px"> (PO: &nbsp;{{customerPO}})  </span><br> -->
                </span> 
                <span v-else-if="printtype === 3">Invoice<br>  
                  <!-- <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span> -->
                  <!-- <span style="font-size: 18px; margin-left:10px" v-if="fullname">({{fullname}})  </span>  
                  <span v-if="customerPO" style="font-size: 16px"> (PO: &nbsp;{{customerPO}})  </span><br> -->
                </span>  
                <span v-else-if="printtype === 33">ໃບສົ່ງເຄື່ອງ<br> 
                  <!-- <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span> -->
                  <!-- <span style="font-size: 18px; margin-left:10px" v-if="fullname">({{fullname}})  </span>
                  <span v-if="customerPO" style="font-size: 16px"> (PO: &nbsp;{{customerPO}})  </span><br> -->
                </span>  
                <span v-else-if="printtype === 333">Invoice<br>
                  <!-- <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span> -->
                  <!-- <span style="font-size: 18px; margin-left:10px" v-if="fullname">({{fullname}})  </span> 
                  <span v-if="customerPO" style="font-size: 16px"> (PO: &nbsp;{{customerPO}})  </span><br> -->
                </span>    
                <span v-else-if="printtype === 4">Receipt<br>  
                  <!-- <span style="font-size: 18px; margin-top: -50px"> {{ b2bname }}</span> -->
                  <!-- <span style="font-size: 18px; margin-left:10px" v-if="fullname">({{fullname}})  </span> -->
                  <!-- <span v-if="customerPO" style="font-size: 16px"> (PO: &nbsp;{{customerPO}})  </span><br> -->
                </span>
                <span v-else-if="printtype === 5">ໃບອອກຕະຫຼາດ</span>  

                   
                
              </div>   
            </div>   
            <div style="" v-if="printtype ===1000"> 
              <div class="columns">
                <div class="column" style="width: 90%; text-align: center">
                    <span style="font-size: 20px;">ບໍລິສັດ Agrilao ໃຫ້ບໍລິການອອກຕະຫຼາດ ອອນລາຍ<br>  
                    <span style="font-size: 18px;"> ລາຄາໂປຣໂມຊັນ ປະຈຳວັນທີ {{dateFormatter(promotionList[0].REDATE)}}</span><br>
                    <span style="font-size: 18px;"> (ລາຄາໂປຣໂມຊັນນີ້ ສຳລັບການສັ່ງຊື້ 1 ກິໂລ ຂຶ້ນໄປ)</span>  
                  </span>
                </div>
              </div>
              
            </div>
            <div style="" v-if="printtype ===10001"> 
              <div class="columns">
                <div class="column" style="width: 90%; text-align: center">
                    <span style="font-size: 20px;">ບໍລິສັດ Agrilao ໃຫ້ບໍລິການອອກຕະຫຼາດ ອອນລາຍ<br>  
                    <span style="font-size: 18px;"> ລາຄາໂປຣໂມຊັນ (ຮ້ານໃໝ່) ປະຈຳວັນທີ {{dateFormatter(promotionList[0].REDATE)}}</span><br>
                    <span style="font-size: 18px;"> (ລາຄາໂປຣໂມຊັນນີ້ ສຳລັບການສັ່ງຊື້ 1 ກິໂລ ຂຶ້ນໄປ)</span>
                  </span>
                </div>
              </div>
              
            </div>
            <div style="height: 10px;"></div>

            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 1000  && promotionList.length > 0"   
            >
              <thead>  
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາກິໂລ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາໝື່ນ/ ແພັກ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in promotionList"
                  :key="data.PRODUCTNAME"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td  class="set-border">
                    {{data.PRODUCTNAME}} 
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.KGPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.PACKPRICE | formatNumberLocal }}
                  </td>
                  
                  
                  
                </tr>
              </tbody>
            </table>

            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 10001  && promotionList.length > 0"   
            >
              <thead>  
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາກິໂລ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາໝື່ນ/ ແພັກ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in promotionList"
                  :key="data.PRODUCTNAME"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td  class="set-border">
                    {{data.PRODUCTNAME}} 
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.KGPRICE-2000 | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    <span v-if="data.SUBUNIT ==10 || data.SUBUNIT ==12 ">
                      {{ ((data.KGPRICE-2000)*data.SUBUNIT)-2000 | formatNumberLocal }}      
                    </span>
                    <span v-else> 
                     
                    </span>
                    
                  </td>
                  
                  
                  
                </tr>
              </tbody>
            </table>


            <b-field v-if="printtype == 2 && quotationdetaillistfull.length > 0">
              ລາຍການສິນຄ້າ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 2  && quotationdetaillistfull.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in quotationdetaillistfull"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>   

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}    
                  </td>
                

                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT*data.UNITPRICE | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>
            
            

            <table class="table is-fullwidth is-narrow is-small"  v-if="printtype == 2">
              <tfoot>
                <tr>
                  <th class="has-text-right" style="background-color: beige; width: 70%;">
                    ລວມ
                    {{ quotationdetaillistfull.length | formatNumberLocal }}
                    ລາຍການ
                  </th>
                  <th class="has-text-right" style="background-color: beige; width: 20%;">
                    {{  
              
                        _.sumBy(quotationdetaillistfull, (i) => i["B2BGETAMOUNT"] * i["UNITPRICE"] * 1)  
                        | formatNumberLocal
                    }}
                  </th>
                  <th class="has-text-right" style="background-color: beige; width: 20%;">
                    
                  </th>
                </tr>
              </tfoot>
            
            </table>

            <!-- start english quotation version -->   

            <b-field v-if="printtype == 222 && quotationdetaillistfull.length > 0"> 
              Product List
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 222  && quotationdetaillistfull.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    No
                  </th>
                  <th colspan="2"  
                    class="has-text-centered set-border"
                    width="40%"
                    style="vertical-align: middle;"
                  >
                    Product Name  
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    Qty
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    Unit
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    Unit Price
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;" 
                  >
                    Total
                  </th>  
                 
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in quotationdetaillistfull"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border"> 
                    {{ data.PRODUCTENNAME }} <br>
                    {{ data.PRODUCTNAME }}
                   
                     
                  </td>
                  <td class="set-border"> 
                    
                    
                    <img 
                      class="image-area"
                      width="80px" 
                      height="80px"    
                      style=""
                      :src="getProductPhoto(data.PHOTONAME)"
                      alt="Placeholder image"
                    />
                      
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BAMOUNT | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.ENUNIT }}    
                  </td>

                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BAMOUNT*data.UNITPRICE | formatNumberLocal }}   
                  </td>
                  
                </tr>
              </tbody>

            </table>

            <table class="table is-fullwidth is-narrow is-small"  v-if="printtype == 222">  
              <tfoot>
                <tr>
                  <th class="has-text-right" style="background-color: beige; width: 70%;">
                    
                    Total
                  </th>
                  <th class="has-text-right" style="background-color: beige; width: 30%;">
                    {{  
              
                        _.sumBy(quotationdetaillistfull, (i) => i["B2BAMOUNT"] * i["UNITPRICE"] * 1)  
                        | formatNumberLocal
                    }}
                  </th>
                </tr>
              </tfoot>
            
            </table>

            <!-- end english quotation version -->

            <b-field v-if="printtype == 22  && quotationdetaillistfull.length > 0">
              ລາຍການສິນຄ້າ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 22 && quotationdetaillistfull.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in quotationdetaillistfull"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}    
                  </td>
                  
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>

            <!-- statrt ໃບຮຽກເກັບລວມ -->
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 333  && invoicedatelist.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລຳດັບ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="40%"
                    style="vertical-align: middle;"
                  >
                    ລາຍການ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນເງິນ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedatelist" 
                  :key="data.PURCHASEID"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="has-text-left set-border">
                    ໃບເກັບເງິນເລກທີ: Agri-{{data.PURCHASEID}}/{{ year(data.REDATE)}}  ລົງວັນທີ: {{ dateFormatter(data.REDATE) }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.TOTAL | formatNumberLocal }}  
                  </td>

                  <td class="has-text-right set-border"></td>   
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th class="has-text-right set-border" colspan="2">  
                    ລວມ
                    {{ invoicedatelist.length | formatNumberLocal }}
                    ລາຍການ
                  </th>
                  <th class="has-text-right set-border" >
                    {{
                          _.sumBy(invoicedatelist, (i) => i["TOTAL"]*1)     
                            | formatNumberLocal
                        }} 
                  </th>
                  <th class="has-text-right set-border">
                      
                  </th>
                </tr>
              </tfoot>

            </table>

            <!-- end ໃບຮຽກເກັບລວມ -->

            <b-field v-if="printtype == 3 && invoicedetaillistfull.length > 0">
              ລາຍການສິນຄ້າ ທີ່ໄດ້ຄົບ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 3  && invoicedetaillistfull.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedetaillistfull"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}  
                  </td>

                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT*data.UNITPRICE | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>
            
            <b-field v-if="printtype == 3  && invoicedetaillistsome.length > 0">
              <br> ລາຍການສິນຄ້າ ທີ່ໄດ້ບາງສ່ວນ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 3  && invoicedetaillistsome.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedetaillistsome"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}  
                  </td>

                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT*data.UNITPRICE | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>
            
              <b-field v-if="printtype == 3  && invoicedetaillistzero.length > 0">
                <br>ລາຍການສິນຄ້າ ທີ່ບໍ່ມີ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 3  && invoicedetaillistzero.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedetaillistzero "
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}  
                  </td>

                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT*data.UNITPRICE | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>

            <table class="table is-fullwidth is-narrow is-small"  v-if="printtype == 3">
              <tfoot>
                <tr>
                  <th class="has-text-right" style="background-color: gray; width: 70%;">
                    ລວມ
                    {{ invoicedetaillisttotal.count | formatNumberLocal }}
                    ລາຍການ
                  </th>
                  <th class="has-text-right" style="background-color: gray; width: 20%;">
                    {{  
                        invoicedetaillisttotal.total | formatNumberLocal
                    }}
                  </th>
                  <th class="has-text-right" style="background-color: gray; width: 10%;">
                    
                  </th>
                </tr>
              </tfoot>
            
            </table>
            
            <b-field v-if="printtype == 33  && invoicedetaillistfull.length > 0">
              ລາຍການສິນຄ້າ ທີ່ໄດ້ຄົບ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 33 && invoicedetaillistfull.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedetaillistfull"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}  
                  </td>
                  
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>

            <b-field v-if="printtype == 33  && invoicedetaillistsome.length > 0">
              ລາຍການສິນຄ້າ ທີ່ໄດ້ບາງສ່ວນ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 33 && invoicedetaillistsome.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedetaillistsome"  
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}  
                  </td>
                  
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>

            <b-field v-if="printtype == 33  && invoicedetaillistzero.length > 0"> 
              ລາຍການສິນຄ້າ ທີ່ບໍ່ມີ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 33 && invoicedetaillistzero.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ<br>ທີ່ສັ່ງ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ<br>ທີ່ໄດ້ຮັບ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in invoicedetaillistzero"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                  </td>
                  
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>

            </table>

            
            <b-field v-if="printtype == 4 && receiptdetaillistfull.length > 0">
              ລາຍການສິນຄ້າ ທີ່ໄດ້ທັງໝົດ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 4 && receiptdetaillistfull.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ໋ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in receiptdetaillistfull"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT * data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>
              
            </table>

            
            <b-field v-if="printtype == 4 && receiptdetaillistsome.length > 0">
              <br> ລາຍການສິນຄ້າ ທີ່ໄດ້ບາງສ່ວນ
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 4 && receiptdetaillistsome.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ໋ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in receiptdetaillistsome"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT * data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>
              
            </table>

            
            <b-field v-if="printtype == 4 && receiptdetaillistzero.length > 0">
              <br> ລາຍການສິນຄ້າ ທີ່ບໍ່ໄດ້
            </b-field>
            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 4 && receiptdetaillistzero.length > 0"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ລວມເປັນເງິນ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in receiptdetaillistzero"
                  :key="data.PRODUCTID_SUB"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BGETAMOUNT * data.UNITPRICE | formatNumberLocal }}
                  </td>
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>
              
            </table>

            <table class="table is-fullwidth is-narrow is-small"  v-if="printtype == 4">
              <tfoot>
                <tr>
                  <th class="has-text-right" style="background-color: gray; width: 70%;">
                    ລວມ
                    {{ receiptdetaillisttotal.count | formatNumberLocal }}
                    ລາຍການ
                  </th>
                  <th class="has-text-right" style="background-color: gray; width: 20%;">
                    {{  
                       receiptdetaillisttotal.total | formatNumberLocal
                    }}
                  </th>
                  <th class="has-text-right" style="background-color: gray; width: 10%;">
                    
                  </th>
                </tr>
              </tfoot>
            
            </table>
           

            <table
              class="table is-fullwidth is-narrow is-small"
              v-if="printtype == 5"
            >
              <thead>
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຈຳນວນ
                  </th>
                  
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ໝາຍເຫດ
                  </th>
                </tr>
              </thead>  
              <tbody>
                <tr
                  v-for="(data, index) in marketorderdatedetail"
                  :key="data.ID"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td class="set-border">
                    <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME_SUB }}  
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.QUANTITY | formatNumberLocal }}
                  </td>

                 
                  <td class="has-text-right set-border"></td>
                </tr>
              </tbody>
            </table>

            <div class="columns" style="page-break-inside: avoid;" >
              <div class="column" v-if="printtype !=5 && printtype !=1000 && printtype !=10001">
                <div>
                  <div style="font-weight: bold; font-size: 16px;">
                    Confirm and Accept by Customer
                  </div>

                  <div style="font-size: 12px; ">Name: {{ b2bname }}</div>

                  <div style="font-size: 12px; " v-if="b2btype !=2">
                    Contact Number: {{ b2bphoneno }}
                  </div>

                  <div style="font-size: 12px; ">
                    Address: {{ b2bprovince }} {{ b2bdistrict }} {{ b2bvillage }}
                  </div>
                  <div style="font-size: 12px;">
                    .................................................................................
                  </div>
                  <div style="font-size: 12px; ">
                    (Signature/ Company Stamp)
                  </div>
                </div>
                <br>
                <div v-if="printtype ==3 || printtype ==333">
                  <img 
                    class="image-area"
                    width="80%"    
                    style=""
                    :src="getImgUrl('sign/qr.png')"
                    alt="Placeholder image"
                  />
                </div>  
                
              </div>   
             
              <div
                class="column"
                style="text-align: center; font-weight: bold; font-size: 16px;"
                v-if="printtype !=5"
              >
                <div style="text-align: center;">
                  <div v-if="printtype ===1000 || printtype ===10001" style="text-align: right;">
                    Agrilao Innovation Ordinary Partnership<br> 
                    Deputy Managing Director<br>
                  </div>
                  <div v-else>
                    Agrilao Innovation Ordinary Partnership<br> 
                    Deputy Managing Director<br>
                  </div>
                  
                  <!-- <b-field v-if="b2bname =='520' && (printtype == '4'|| printtype == '333')"> -->
                  <b-field v-if="printtype == '4'">   
                    
                  </b-field>  
                  <b-field v-else-if="companytype==2 || companytype==3"> 
                    
                  </b-field> 
                  <b-field v-else>
                    <b-field style="text-align: right;">
                      <img v-if="(printtype ===1000 || printtype ===10001) " 
                        class="image-area"
                        width="25%"    
                        style=""
                        :src="getImgUrl('sign/deputymanagingdirector.png')"
                        alt="Placeholder image"
                      />
                    </b-field>
                      
                      <img v-if="printtype !=1000 && printtype !=10001"     
                        class="image-area"
                        style=""
                        :src="getImgUrl('sign/deputymanagingdirector.png')"
                        alt="Placeholder image"
                      />
                  </b-field>  
                  
                </div> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isModalOpen" class="modal">
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <!-- Your modal content goes here -->
        <p>This is the modal content.</p>
        <b-datepicker
          ref="datepicker"
          :date-formatter="dateFormatter"
          v-model="prepareDate"
        >
          <!-- Your datepicker content here -->
          <button ref="submitButton">Submit</button>
        </b-datepicker>
      </div>
    </div>
    <div v-if="isPopupVisible" class="popup" @click="hidePopup">     
      <span class="close" @click.stop="hidePopup">&times;</span>
      <img :src="popupImgSrc" class="popup-content">
    </div>
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
import axios from "axios";

// import PrintSummaryTable from "@/components/PrintSummaryTable.vue";
import { BFormSelect } from 'bootstrap-vue'
// import { data } from "jQuery";
//import { orderBy } from "lodash";
// import { data } from "jQuery";


export default {
  components: { Multiselect, BFormSelect},
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeb2b: [],
      // inactivemarkets: [],
      b2buserid: null,
      b2busername: null,

      activeTab: 0,

      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      activeSubTab: 0,
      productType: [],
      products: [],
      productamount: [],
      selecteddate: null,

      activeFormTypeTab: 0,

      activeSub2TabWait: 0,
      activeSub2TabPrepare: 0,
      activeSub2TabQuotation: 0,
      activeSub2TabInvoice: 0,
      activeSub2TabReceipt: 0,
      activeSub2TabProfit: 0,
      activeB2BTab: 0,
      activeB2BStockTab: 0,
      activeSub2TabAllOrders: 0,
      activePaymentData: 0,
      activeSub2TabMarketBatch: 0,

      activeSub3TabJoinOrder: 0,

      quotaltoproduction: [],
      activeQuotaSubTab: 0,
      quotadate: null,
      quotadatetypes: null,
      quotadateproducts: null,
      selectedquotaddate: null,
      contractid: null,
      contractno: null,
      subcontractno: null,
      selectedcontractno: null,
      selectedsubcontractno: null,
      countryList: [],
      SelectedCountry: null,
      ProvinceList: [],
      SelectedProvince: null,
      district: null,
      village: null,
      contractstatus: null,
      contractdate: null,
      contractdetail: null,
      contractlist_waittoapprove: [],
      contractlist_waitinvoice: [],
      contractlist_waitreceipt: [],
      contractlist_receipt: [],
      isContractProductList: false,
      waitdatelist: [],
      preparedatelist: [],
      quotationdatelist: [],
      invoicedatelist: [],
      receiptdatelist: [],
      profitdatelist: [],
      profitLostDateList: [],
      profitProfitDateList: [],
      profiProductPriceList: [],
      profitAllDateList: [],
      allordersdatelist: [],
      paymentdatalist: [],
      b2bpaymentdatalist: [],
      b2bpaymentdatalistdetail: [],
      allquotationformarketdatelist: [],

      profitByDate: [],

      activeQuotaProgressTab: 0,

      productBuyPrice: [],
      productBuyPriceHistory: [],

      DppProvinceList: [],
      SelectedDppProvince: null,
      stockList: [],
      selectedStock: null,

      selectedProvinceid: null,
      selectedBranchid: null,
      selectedWaitDate: null,
      selectedPrepareDate: null,
      selectedQuotationDate: null,
      selectedInvoiceDate: null,
      selectedReceiptDate: null,
      selectedAllOrdersDate: null,
      selectedMarketBatchDate: null,
      selectedPurchaseMarketPrepareID: null,
      selectedDate: null,
      selectedContractID: null,
      selectedPurchaseID: null,
      selectedPurchaseLOCKED: null,
      isNewB2B: null,
      waitdetaillist: [],
      preparedetaillist: [],
      preparecount: [],

      quotationdetaillisttotal: [],
      quotationdetaillist: [],
      quotationdetaillistfull: [],
      quotationdetaillistsome: [],
      quotationdetaillistzero: [],

      invoicedetaillisttotal: [],
      invoicedetaillist: [],
      invoicedetaillistfull: [],
      fullname: null,
      invoicedetaillistsome: [],
      invoicedetaillistzero: [],
      invoiceTotal: 0,

      receiptdetaillist: [],
      receiptdetaillisttotal: [],
      receiptdetaillistfull: [],
      receiptdetaillistsome: [],
      receiptdetaillistzero: [],

      profitdetaillist: [],

      allordersdetaillist: [],
      marketbatchdetaillist: [],
      printdetaillist: [],

      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/"
          : "http://localhost/agrilao-manager-v2/api/uploads/",

      productphotopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/products/"
          : "https://agrilao.com/manager-main/api/uploads/products/",

      quotationup: 0,
      contractProgress: 0,
      enableprepareedit: 0,
      enablequotationedit: 0,
      enableinvoiceedit: 0,
      enablemarketorderedit: 0,
      submitData: [],
      submitType: null,
      printtype: null,

      b2bproductsearch: null,
      b2bproductTypeId: null,

      b2bproductsearchm: null,

      startOrderDate: null,
      endOrderDate: null,

      startProfitDate: null,
      endProfitDate: null,

      selectedstartProfitDate: null,
      selectedendProfitDate: null,

      startProductPriceDate: null,
      endProductPriceDate: null,

      startMarketBatchDate: null,
      endMarketBatchDate: null,

      activeSub2TabMarketOrder: 0,
      startMarketOrderDate: null,
      endMarketOrderDate: null,

      b2bphoneno: null,
      b2bname: null,
      companytype: null,
      b2bprovince: null,
      b2bdistrict: null,
      b2bvillage: null,

      allOrdersB2BName: null,
      marketBatchB2BName: null,

      allOrderStatusList: [
        { STATUS: "ALL", NAME: "ALL" },
        { STATUS: "1", NAME: "Prepare" },
        { STATUS: "2", NAME: "Quotation" },
        { STATUS: "3", NAME: "Invoice" },
        { STATUS: "4", NAME: "Receipt" },
      ],
      selectedAllStatus: null,
      selectedAllOrderCustomer: null,
      selectedAllProfitCustomer: null,
      selectedAllProfitStatus: null,
      
      selectedProductPriceProduct: null,
      selectedAllProfitProduct: null,

      selectedProductType: null,
      topProductTypeList: [],
      topProductUsage: [],

      selectedAllproductid: 0,

      hasSomeUnSubmitPurchase: null,

      productB2BSTATUS: null,
      productssearch: [],
      filteredProducts: [],

      preparedate: null,
      isModalOpen: false,
      allorderstatus: null,

      currentDate: null,

      allMarketBillDateList: [],
      allMarketBillDateDetail: [],
      purchaserProduct:[],
      allMarketBillDateDetailOrderbycustomer: [],
      allMarketBillDateDetailOrder: [],
      allMarketBillDateDetailPurchaserProduct: [],
      marketProductTempQuantity: 0,
      productMarketID: 0,
      allMarketBillDateDetailProduct: [],
      marketList: [],
      selectedMarketBatchDetailDate: null,
      selectedMarketBatchID: null,
      selectedProductid: null,
      selectedProductQuantity: null,

      allmarketorderdate: [],
      marketorderdatedetail: [],
      marketorderdatedetailproduct: [],

      selectedMarketOrderBatchID: null,
      selectedMarketOrderDate: null,
      selectedMarketOrderMarketID: null,
      selectedMarketOrderMarketname: null,

      isSaveMarketButton: true,
      marketbatchstatus: null,
      selectedBatchid: null,

      quotationmarketbatchstatus: [],

      ordercompanylist: [],

      show: null,
      showm: null,

      MARKETQUANTITY: 0,
      SELECTEDMARKET: [],

      amountOptions: Array.from({ length: 20}, (_, index) => ({
        value: index + 1,
        text: (index + 1).toString()
      })),  

      amountSub: Array.from({ length: 200}, (_, index) => ({
        value: index,
        text: (index).toString()
      })),  


      buylist: [],

      checkedValue: "0",
      productsub_list: [],

      
      buyListProductTypeList:[],
      selectedBuyListProductType: null,
      buyListProductList:[],
      selectedBuyListProduct: null,
      buyListProductSubList: [],
      selectedBuyListProductSub: null,

      b2btype: null,
      selectedSubB2B: null,
      subB2BList: [],
      
      profitDateDetailList: [],
      selectedProfitCompany: null,
      selectedProfitPurchaseID: null,
      selectedProfitStatus: null,

      profitStatusList: [
        { ID: "2", NAME: "ລໍຖ້າຮັບເຄື່ອງ" },
        { ID: "3", NAME: "ລໍຖ້າຊຳລະ" },
        { ID: "4", NAME: "ຊຳລະແລ້ວ" },
      ],
      productPriceProductList: [],
      profitAllProductList: [],
      orderByList: [
        { ID: "1", NAME: "ຕາມສິນຄ້າ" },
        { ID: "2", NAME: "ຕາມຜູ້ຮັບຜິດຊອບ" },
        { ID: "3", NAME: "ຕາມຮ້ານ" }
      ],

      companyByList: [
        { ID: "1", NAME: "ຕາມສິນຄ້າ BatchID" },
        { ID: "2", NAME: "ຕາມເສັ້ນທາງ" }
      ],
      selectedCompanyby: null,

      selectedOrderby: null,
      orderBySet: 1,

      isQuotationChangeDate: false,
      quotationDate: null,
      checkmarketAllProduct : 0,
      checkmarketBuyProduct : 0,

      profitSelectedB2BUSERNAME: null,

      subProductPromotionList: [],
      promotionList: [],

      stockTypeList: [
        { ID: 1, NAME: "ຂາເຂົ້າ" },
        { ID: 2, NAME: "ຂາອອກ" }
      ],
      selectedStockType: [],
      isStockIn: 1,
      stockDate: null,
      stockStartDate: null,
      stockEndDate: null,

      selectedStockProduct: [],
      stockProductSub: [],
      selectedStockProductAmount: 0,
      selectedStockProductAmountOut: 0,
      selectedStockProductTotal: 0,
      selectedVender: [],
      stockVenderList: [],

      stockinHistory: [],
      stockOutHistory:[],

      selectedMarketUser: [],
      selectedMarketUserList: [],

      stockRemain: [],

      priceModelType: 1,
      checkProductList: [],

      selectedMarket: null,

      b2bproductIsCliamedList: [
        "Normal" ,
        "Cliam" 
      ],  

      selectedIsCliamed: [],      
      // selectedIsCliamed: this.b2bproductIsCliamedList[0],        
      countBuyHistoryAmount1: 0,
      countBuyHistoryAmount2: 0,

      paymentStatus: 0,

      receiptDateTime: null,

      selectedPaymentType: null,
      paymentTypeList: [
        { ID: 1, NAME: "ບິນດຽວ" },
        { ID: 2, NAME: "ບິນລວມ" }
      ],

      isManyBill: 0,

      selectedBank: null,
      bankList: [
        { ID: 1, NAME: "BCEL" },
        { ID: 2, NAME: "LDB" },
        { ID: 3, NAME: "JDB" },
        { ID: 4, NAME: "LVB" },
        { ID: 5, NAME: "SCB" },
        { ID: 99, NAME: "ເງິນສົດ" },
        { ID: 100, NAME: "ອື່ນໆ" },
      ],

      paymentReceiptNo: null,
      selectedFile: null,
      url: "uploadreceiptimage", // function name in api site
      photoname: null,
      photopath_receipt:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/paymentreceipt/"
          : "http://localhost/agrilao-manager-v2/api/uploads/paymentreceipt/",
      photopreview: null,

      receiptdata: [],
      isPopupVisible: false,
      popupImgSrc: '',
      billList: Array(10).fill(''),

      selectedPaymentDateType: null,
      paymentDateType: [
        { ID: 1, NAME: "ວັນທີສັ່ງສິນຄ້າ" },
        { ID: 2, NAME: "ວັນທີຊຳລະເງິນ" },
      ],
      startPaymentDate: null,
      endPaymentDate: null,

      startB2BPaymentDate: null,
      endB2BPaymentDate: null,

      b2bPaymentCompany: null,
      b2bPaymentStartDate :null,
      b2bPaymentEnddate : null,

      allquotationdatelist: [],
      isAllQuotation: 0,

      isNumberEdit: 0,

      receiveno: null,

      iskarghuptoaccount: 0,

      invoiceAccountStatus: 0,

      customerPOInput: null,
      customerPO: null,

          
    }; 
  },
  methods: {  

    goBacktoInvoiceDetail(){
      this.paymentStatus = 0;
    },

    sendKangHuptoAccount(redate){
      
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {

          this.$swal({
            title: "ໃສ່ລະຫັດເພື່ອຢືນຢັນ",
            input: 'password',  // Input type password
            inputPlaceholder: 'ລະຫັດຜ່ານ',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'ຢືນຢັນ',
            cancelButtonText: 'ຍົກເລີກ',
            confirmButtonColor: "#41B883",
            cancelButtonColor: "#F7C325",  
            reverseButtons: true,  
            preConfirm: (password) => {
              if (!password) {
                this.$swal.showValidationMessage('ກະລຸນາໃສ່ລະຫັດຢືນຢັນ');  
              } else {
                return password;
              }  
            }
          }).then((secondResult) => {
            if (secondResult.value) {
              // Check password before proceeding (you can validate with an API)
              const password = secondResult.value;
              
              // Example API validation (replace with your actual API call)
  
                if (password==="999888") {
                  // Proceed with the action after successful password validation
                  
                  var params = {
                    redate: redate,
                    purchaseid: this.selectedPurchaseID,
                    contractid: this.invoicedetaillisttotal.CONTRACTID,
                    customername: this.invoicedetaillisttotal.COMPANY,  
                    amount: this.invoicedetaillisttotal.total,  
                    // vat: this.invoicedetaillisttotal.total* 0.1,  // in case vat, ແຕ່ລະຮ້ານບໍ່ຄືກັນ  
                    vat: 0,
                    username: this.username,
                  };  

                  // console.log("params: " + JSON.stringify(params));   

                  RestAPI.sendKangHuptoAccount(params)
                    .then((res) => {
                      console.log("res.data.code: " + JSON.stringify(res.data.code));     
                       
                      if(res.data.code =='00'){
                        this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");

                        this.iskarghuptoaccount = 1; 

                      }else if(res.data.code =='01'){
                        this.$swal("ເລກທີໃບຮັບເງິນຊ້ຳ!", "", "error");
                        return false;

                      }else{
                        this.$swal("ດຳເນີນການບໍ່ສຳເລັດ", "", "error");
                        return false;
                      }
                         
                     
                    })
                    .catch((error) => {
                      console.log(error);
                      if (error == "Error: Request failed with status code 400") {
                        this.$swal("Check Input Data", "", "error");
                      } else {
                        this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                      }
                    });
                } else {
                  this.$swal("ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ", "", "error");
                }
                
            }
          });

        }
      });
    },

    numberEditForm(){
      this.isNumberEdit = 1;
    },

    editNumber(){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?", 
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            b2busername: this.b2busername,
            data: this.quotationdetaillistfull,
            username: this.username,
          };
          // console.log("params: " + JSON.stringify(params));   
          RestAPI.editB2BOrderNumber(params)
            .then(() => {
              this.isNumberEdit = 0;
              this.openContractDateForm(2, this.submitData);
              
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });

      
      
    },
    getMarketOptions() {
      // var PURCHASER = [
      //   { PURCHASERID: 1 },
      //   { PURCHASERID: 2 },
      // ];

      // this.marketList = [
      //   { ID: 1, NAME: "AAA" },
      //   { ID: 2, NAME: "BBB" },
      //   { ID: 3, NAME: "CCC" },
      //   { ID: 4, NAME: "DDD" },
      // ];

      // return this.marketList.filter(market =>
      //   PURCHASER.some(purchaser => purchaser.PURCHASERID === market.ID)
      // );

      // return this.marketList.filter(market => market.ID === PURCHASER.PURCHASERID);

      return this.marketList;

    },
    gotoJoinBillB2Blist(){
      this.isAllQuotation = 0;
    },
    getQuotationDateList(){
      this.isAllQuotation = 1;
      // console.log("startdate: "+ this.dateFormatterYYYYMMDD(this.startMarketBatchDate))     
      // console.log("enddate: "+ this.dateFormatterYYYYMMDD(this.endMarketBatchDate))

      const loadingComponent = this.$loading.open({});  
      
      RestAPI.getQuotationDateList(this.dateFormatterYYYYMMDD(this.startMarketBatchDate), this.dateFormatterYYYYMMDD(this.endMarketBatchDate)) 
          .then((res) => {
            this.allquotationdatelist =  res.data;     
            loadingComponent.close();
            // console.log("this.allquotationdatelist 01: " + JSON.stringify(this.allquotationdatelist[0].full.length))     
            // console.log("this.allquotationdatelist: " + JSON.stringify(this.allquotationdatelist))   
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    getStockHistory(){      
      var params = {
            startdate: this.dateFormatterYYYYMMDD(this.stockStartDate),  
            enddate: this.dateFormatterYYYYMMDD(this.stockEndDate),  
            username: this.username,      
          };   
          
         RestAPI.getStockHistory(params) 
          .then((res) => {
            this.stockinHistory =  res.data.stockInHistory;
            this.stockOutHistory = res.data.stockOutHistory;
            this.stockRemain = res.data.stockRemain;            
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    saveStockOut(){
      this.$swal({  
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",  
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
       if (result.value) {

          var params = {
            txdate: this.dateFormatterYYYYMMDD(this.stockDate),  
            mproductid: this.selectedStockProduct.ID,
            quantity: this.selectedStockProductAmount,
            total: this.selectedStockProductTotal,
            marketuserid: this.selectedMarketUser.ID,
            startdate:  this.dateFormatterYYYYMMDD(this.stockStartDate),
            enddate:  this.dateFormatterYYYYMMDD(this.stockEndDate),
            username: this.username,    
          };

          // console.log("params: "+JSON.stringify(params))  
          
         RestAPI.saveStockOut(params)   
           .then((res) => {
            //  this.allProfitStatus();
             if(res.data==="OVER"){
                this.$swal("ເອົາອອກສາງ ເກີນຈຳນວນທີ່ມີ", "", "error");
                return false;
             }
             this.selectedStockProduct = [];
             this.selectedStockProductAmount= 0;
             this.selectedStockProductTotal = 0;
             this.selectedMarketUser = [],

            //  this.getStockHistory();

            //  this.stockOutHistory = res.data.stockout;
            //  this.stockRemain = res.data.remain;
            //  console.log("this.stockOutHistory :" + JSON.stringify(this.stockOutHistory ))  
             this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
            })
           .catch((error) => {
             console.log(error);
             if (error == "Error: Request failed with status code 400") {
               this.$swal("Check Input Data", "", "error");
             } else {
               this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
             }
         });
       }
     });
    },

    saveStockIn(){ 
      if(this.selectedVender== null || this.selectedStockProduct == null || this.selectedStockProductAmount == 0 || this.selectedStockProductTotal== 0){     
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");

      }else{
        this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",  
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
          if (result.value) {

              var params = {
                txdate: this.dateFormatterYYYYMMDD(this.stockDate),
                mproductid: this.selectedStockProduct.ID,
                quantity: this.selectedStockProductAmount,
                total: this.selectedStockProductTotal,
                venderid: this.selectedVender.ID,
                startdate:  this.dateFormatterYYYYMMDD(this.stockStartDate),
                enddate:  this.dateFormatterYYYYMMDD(this.stockEndDate),
                username: this.username,  
              };

              // console.log("params: "+JSON.stringify(params))  
              
             RestAPI.saveStockIn(params) 
               .then(() => {
                //  this.allProfitStatus();
                this.selectedStockProduct = [];
                this.selectedStockProductAmount= 0;
                this.selectedStockProductTotal = 0;
                this.selectedVender = [],

                // this.getStockHistory();

                //  this.stockinHistory = res.data.stockin;
                //  this.stockRemain = res.data.remain;
                //  console.log("this.stockinHistory :" + JSON.stringify(this.stockinHistory ))  
                 this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                })
               .catch((error) => {
                 console.log(error);
                 if (error == "Error: Request failed with status code 400") {
                   this.$swal("Check Input Data", "", "error");
                 } else {
                   this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                 }
             });
          }
        });
      }
      
     
    },

    onSelectedStockType(){

      this.isStockIn = this.selectedStockType.ID == 1 ? 1 : 0;

      console.log("isStockIn: " +this.isStockIn)
    },
    savePromotionPrice(){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",  
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
       if (result.value) {
         var params;

          params = {
            data: this.subProductPromotionList,
            username: this.username,  
          };
 
         
         RestAPI.savePromotionPrice(params) 
           .then(() => {
             this.allProfitStatus();
             this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
            })
           .catch((error) => {
             console.log(error);
             if (error == "Error: Request failed with status code 400") {
               this.$swal("Check Input Data", "", "error");
             } else {
               this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
             }
         });
       }
     });
    },
    
    getPriceModel(type){
      this.priceModelType = type == 1 ? 0 : 1;
      this.profiProductPriceList = [];
      var params = {
            type: type,
            startdate: this.dateFormatterYYYYMMDD(this.startProfitDate),
            enddate: this.dateFormatterYYYYMMDD(this.endProfitDate),
            username: this.username,    
          };
        //  console.log("params: " +JSON.stringify(params))  
         RestAPI.getPriceModel(params) 
          .then((res) => {
            this.profiProductPriceList =  res.data;     
            // console.log("this.profiProductPriceList: " +JSON.stringify(this.profiProductPriceList))
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
      
    },

    saveAllLostProductPrice(type){
    
     this.$swal({
       title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
       showCancelButton: true,
       showCloseButton: true,
       confirmButtonText: "ຕ້ອງການ",
       cancelButtonText: "ບໍ່ຕ້ອງການ",  
       confirmButtonColor: "#d33",
       cancelButtonColor: "#3085d6",
     }).then((result) => {
       if (result.value) {
         var params;
         if(type==1){
           params = {
             data: this.profitLostDateList,
             username: this.username,  
           };
         }else{
           params = {
             data: this.profitProfitDateList,
             username: this.username,  
           };
         }
         
         // console.log("pararms: " + JSON.stringify(params))  
         RestAPI.saveAllLostProductPrice(params) 
           .then(() => {
             this.allProfitStatus();
             this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
            })
           .catch((error) => {
             console.log(error);
             if (error == "Error: Request failed with status code 400") {
               this.$swal("Check Input Data", "", "error");
             } else {
               this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
             }
         });
       }
     });
   },


    saveProfitAllProductPrice(){  
      
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",  
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          const loadingComponent = this.$loading.open({});  
          var params;
         
          params = {
            data: this.profiProductPriceList,
            username: this.username,  
          };
         
          
          // console.log("pararms: " + JSON.stringify(params))  
          RestAPI.saveProfitAllProductPrice(params) 
            .then(() => {
              loadingComponent.close();
              this.allProfitStatus();
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
          });
        }
      });
    },

    saveProfitProductPrice(index){  
      
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",  
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          const loadingComponent = this.$loading.open({});  
          var params;
         
          params = {
            data: this.profiProductPriceList,
            index: index,
            username: this.username,  
          };
         
          
          // console.log("pararms: " + JSON.stringify(params))  
          RestAPI.saveProfitProductPrice(params) 
            .then(() => {  
              loadingComponent.close();
              this.allProfitStatus();
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
          });
        }
      });
    },
 
    allProductsBySelected(){
      // var params = {
      //   b2busername: this.selectedAllOrderCustomer,
      //   startdate: this.dateFormatterYYYYMMDD(this.startOrderDate),
      //   enddate: this.dateFormatterYYYYMMDD(this.endOrderDate),
      //   username: this.username,  
      // };
      
      RestAPI.getallProfitAllProductByProductSelected(this.dateFormatterYYYYMMDD(this.startProfitDate),this.dateFormatterYYYYMMDD(this.endProfitDate), this.profitSelectedB2BUSERNAME, this.selectedProductPriceProduct.ID)
      .then((res) => {
        this.profitAllDateList = res.data;
        // console.log("profitAllDateList : "+JSON.stringify(res.data))
        })
      .catch((error) => {
        console.log(error);
        if (error == "Error: Request failed with status code 400") {
          this.$swal("Check Input Data", "", "error");
        } else {
          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
        }
      });


    },

    onSelectBuylistQuantity(index){
        console.log("onSelectBuylistQuantity ")  
        var params = {
          id: this.buylist[index].ID,
          amount1: this.buylist[index].AMOUNT1,
          amount2: this.buylist[index].AMOUNT2,
          type: 1,   
          b2busername: this.b2busername,  
          contractid: this.contractid,
          username: this.username,    
        };
        console.log("type = 1 "+ JSON.stringify(params))  
        RestAPI.addQuantitytoBuylist(params)
          .then(res => {
            this.buylist = res.data.buylist;
            this.countBuyHistoryAmount1 = res.data.countamount1;
            this.countBuyHistoryAmount2 = res.data.countamount2;
            this.buylist.forEach(item => {  
              // console.log("item.ISCLIAMED: " + item.ISCLIAMED)    
              if (item.ISCLIAMED ==0 ) {
                // console.log("item.ISCLIAMED 0")   
                item.ISCLIAMED = this.b2bproductIsCliamedList[0];   
              }else{
                // console.log("item.ISCLIAMED 1")   
                item.ISCLIAMED = this.b2bproductIsCliamedList[1];   
              }
            });
            })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });


    },

    onSelectBuylistQuantity2(){
      // if(this.buylist[index].AMOUNT2 != 0){
      //   var params = {
      //     id: this.buylist[index].ID,
      //     type: 2,
      //     amount: this.buylist[index].AMOUNT2,
      //     b2busername: this.b2busername,
      //     contractid: this.contractid,
      //     username: this.username,  
      //   };
      //   // console.log("type = 2 "+ JSON.stringify(params))
      //   RestAPI.addQuantitytoBuylist(params)
      //   .then(res => {
         
      //       this.countBuyHistoryAmount1 = res.data.countamount1;
      //       this.countBuyHistoryAmount2 = res.data.countamount2;
      //       })
      //     .catch((error) => {
      //       console.log(error);
      //       if (error == "Error: Request failed with status code 400") {
      //         this.$swal("Check Input Data", "", "error");
      //       } else {
      //         this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
      //       }
      //     });
      // }

    },

    saveBuyHistory(){
      
        this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            const hasAmount1 = this.buylist.some(item => parseFloat(item.AMOUNT1) === 0.1);
            const hasAmount2 = this.buylist.some(item => parseFloat(item.AMOUNT2) === 0.1);
            if (hasAmount1 || hasAmount2) {
              this.$swal("ຜິດພາດ, ມີບາງລາຍການ 0.1", "", "error");
              return false;
            }

            var params = {
              contractid: this.contractid,
              data: this.buylist,  
              b2busername: this.b2busername,
              username: this.username,    
            };
            // console.log("pararms: " + JSON.stringify(params))  
            const loadingComponent = this.$loading.open({});
            RestAPI.saveBuyHistory(params)
              .then((res) => {
                this.buylist = [];
                this.buylist= res.data.buylist;  
                this.countBuyHistoryAmount1 = res.data.countamount1;
                this.countBuyHistoryAmount2 = res.data.countamount2;   
                // console.log("buylist: " + JSON.stringify(this.buylist));   
                this.buylist.forEach(item => {  
                  // console.log("item.ISCLIAMED: " + item.ISCLIAMED)    
                  if (item.ISCLIAMED ==0 ) {
                    // console.log("item.ISCLIAMED 0")   
                    item.ISCLIAMED = this.b2bproductIsCliamedList[0];   
                  }else{
                    // console.log("item.ISCLIAMED 1")   
                    item.ISCLIAMED = this.b2bproductIsCliamedList[1];     
                  }
                  
                });
              })  
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                } 
              });

            loadingComponent.close();

          }
        });
      
        
      
    },


    onSelectedOrderby(){
      this.orderBySet = this.selectedOrderby.ID;
      this.marketBillDetail(this.selectedMarketBatchID, this.selectedOrderby.ID)
    },

    onSelectedCompanyby(){
      this.companyBySet = this.selectedCompanyby.ID;
      this.allMarketBatchStatus(this.companyBySet)
    },

    changeQuotationDate(){
      
      // console.log("this.quotationdate: " + this.dateFormatterYYYYMMDD(this.quotationDate))
      
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",  
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            purchaseid: this.selectedPurchaseID,
            quotationdate: this.dateFormatterYYYYMMDD(this.quotationDate),
            username: this.username,  
          };
          // console.log("pararms: " + JSON.stringify(params))  
          RestAPI.changeQuotationDate(params)
            .then(() => {
              this.allProductStatus();
              this.isQuotationChangeDate = false;
              this.selectedQuotationDate = this.dateFormatterYYYYMMDD(this.quotationDate);
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
      
    },
    changeQuotationDateForm(){
      this.isQuotationChangeDate = true;
    },  

    checkPreQuantity(id){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            id: id,
            purchaseid: this.selectedPurchaseID,
            username: this.username,
          };

          console.log("pararms: " + JSON.stringify(params))  
          RestAPI.checkPreQuantity(params)
            .then((res) => {
              console.log("preparedetaillist: " + JSON.stringify(res.data))  

              this.preparedetaillist = res.data.list;      
              this.preparecount = res.data.count; 
              // this.allProductStatus(1);
              // this.openContractDateForm(this.submitType, this.submitData)

              // this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.$swal({
                title: "ສຳເລັດ",
                text: "ດຳເນີນການ ສຳເລັດ!",
                icon: "success",
                timer: 200,
                showConfirmButton: false, 
              });

              
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    
    removeProductsubFormPurchaseList(id){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            id: id,
            username: this.username,
          };

          // console.log("pararms: " + JSON.stringify(params))  
          RestAPI.removeProductsubFormPurchaseList(params)
            .then(() => {
              this.allProductStatus();
              this.openContractDateForm(this.submitType, this.submitData)

              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");

              
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    removeProductFormBuyList(id){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            id: id,
            username: this.username,
          };

          // console.log("pararms: " + JSON.stringify(params))  
          RestAPI.removeProductFormBuyList(params)
            .then(() => {
              this.allProductStatus();
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");

              
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    saveProductToBlackList(data){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            b2busername: this.b2busername,
            contractid: this.contractid,
            productid: data.PRODUCTID,
            productname: data.PRODUCTNAME,
            username: this.username,
          };

          // console.log("pararms: " + JSON.stringify(params))  
          RestAPI.saveProductToBlackList(params)
            .then(() => {
              this.allProductStatus();
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");

              
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });  
        }
      });
    },

    getProfitDetailList(purchaseid){
      RestAPI.getProfitDetailList(purchaseid, this.selectedReceiptDate, this.selectedAllproductid)
        .then((res) => {
          this.profitDateDetailList= res.data
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        }); 
    },


    onSelectedSubProduct(index){
      this.buylist[index].NEEDTOUPDATE = 0;

      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            productid_sub: this.buylist[index].PRODUCTID_SUB.PRODUCTID_SUB,
            productid: this.buylist[index].PRODUCTID,
            username: this.username,
          };

          console.log("pararms: " + JSON.stringify(params))  
          // RestAPI.addSubProduct(params)
          //   .then(() => {
          //     this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              
          //    })
          //   .catch((error) => {
          //     console.log(error);
          //     if (error == "Error: Request failed with status code 400") {
          //       this.$swal("Check Input Data", "", "error");
          //     } else {
          //       this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          //     }
          //   });
        }
      });


    },

    getsubProduct(index){
      for (let key in this.buylist) {
        if (key != index) {
          this.buylist[key].NEEDTOUPDATE = 0;
        }
      }

      this.buylist[index].NEEDTOUPDATE = 1;

      // console.log("PRODUCTID" + this.buylist[index].PRODUCTID );
      RestAPI.getsubProduct(this.buylist[index].PRODUCTID)
        .then((res) => {
          this.productsub_list= res.data
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    asignMarket(data){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            data: data,
            marketbatchid: this.selectedMarketBatchID,
            redate: this.selectedMarketBatchDate,
            username: this.username,
          };

          // console.log("data: " + JSON.stringify(data))
          console.log("params: " + JSON.stringify(params))
          RestAPI.asignMarket(params)  
            .then(() => {
              this.marketBillDetail(this.selectedMarketBatchID,1);
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    asignMarket_temp(data, purchaserid){
      const loadingComponent = this.$loading.open({});

      var params = [];
    
      params = {
        marketbatchid: this.selectedMarketBatchID,
        redate: this.selectedMarketBatchDate,
        productid: data.PRODUCTID,
        marketid: purchaserid,  
        quantity: data.QUANTITY,
        wantquantity: data.QUANTITY,
        username: this.username,       
      };

      // console.log("this.SELECTEDMARKET.ID: " + JSON.stringify(data.SELECTEDMARKET.ID))
      // console.log("asignMarket_temp params: " + JSON.stringify(params))  
      RestAPI.asignMarket_temp(params)
      .then(() => {
        params = [];
        this.marketBillDetail(this.selectedMarketBatchID,1);
        loadingComponent.close();
        
        })     
      .catch((error) => {
        loadingComponent.close();
        console.log(error);
        if (error == "Error: Request failed with status code 400") {
          this.$swal("Check Input Data", "", "error");
        } else {
          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
        }
      });

          
    },

    asignMarket_temp_inDetail(data){
      const loadingComponent = this.$loading.open({});
      var params = [];
      params = {
        marketbatchid: this.selectedMarketBatchID,
        redate: this.selectedMarketBatchDate,
        productid: data.PRODUCTID,  
        marketid: data.SELECTEDMARKET.ID,  
        quantity: data.MARKETQUANTITY,
        wantquantity: data.QUANTITY,
        username: this.username,       
      };

      // console.log("data: " + JSON.stringify(data));
      // console.log("asignMarket_temp params: " + JSON.stringify(params))  
      RestAPI.asignMarket_temp(params)
      .then((res) => {
        loadingComponent.close();    
        params = [];
        console.log("res.data: " +JSON.stringify(res.data))
        if(res.data == "overamount"){
          this.joinOrderDetail(this.selectedMarketBatchID, this.selectedPurchaseMarketPrepareID, this.selectedProductid, this.MARKETQUANTITY , this.selectedMarketBatchDate)
          this.$swal("ມອບເກີນຈຳນວນ", "-", "error");
          return false;
        }
        this.marketBillDetail(this.selectedMarketBatchID,1);
        this.joinOrderDetail(this.selectedMarketBatchID, this.selectedPurchaseMarketPrepareID, this.selectedProductid, this.MARKETQUANTITY , this.selectedMarketBatchDate)
        
        })     
      .catch((error) => {
        loadingComponent.close();    
        console.log(error);
        if (error == "Error: Request failed with status code 400") {
          this.$swal("Check Input Data", "", "error");
        } else {
          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
        }
      });

      
    },

    cancelAsignMarket_temp(data, type){
       const loadingComponent = this.$loading.open({});
       var params = [];
       params = {
          marketbatchid: this.selectedMarketBatchID,
          redate: this.selectedMarketBatchDate,
          productid: data.PRODUCTID,
          quantity: data.QUANTITY,
          username: this.username,     
        };

        // console.log("this.SELECTEDMARKET.ID: " + JSON.stringify(data.SELECTEDMARKET.ID))
        // console.log("params: " + JSON.stringify(params))  
        RestAPI.cancelAsignMarket_temp(params)  
        .then(() => {
          loadingComponent.close();    
          params = [];
          this.marketBillDetail(this.selectedMarketBatchID,1);
          if(type==2){
            this.activeSub3TabJoinOrder = 1;
            this.joinOrderDetail(this.selectedMarketBatchID, this.selectedPurchaseMarketPrepareID, this.selectedProductid, this.MARKETQUANTITY , this.selectedMarketBatchDate)
          }
          
          })     
        .catch((error) => {
          loadingComponent.close();    
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    cancelPurchaserDetailByID(ID, PRODUCTID, MARKETBATCHID, QUANTITY){


      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
            var params = {
            productid: PRODUCTID,
            detailid: ID,
            marketbatchid: MARKETBATCHID,
            quantity: QUANTITY,
            username: this.username,     
          };

          // console.log("this.SELECTEDMARKET.ID: " + JSON.stringify(data.SELECTEDMARKET.ID))
          // console.log("params: " + JSON.stringify(params))  
          RestAPI.cancelPurchaserDetailByID(params)  
          .then(() => {
            this.marketBillDetail(this.selectedMarketBatchID,1);
            this.activeSub3TabJoinOrder = 0;           
            
            })     
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }  
          });
        }
      });
    
        
    },

    joinOrderDetail(batchid, purchasemarketprepareid, productid, quantity, selectedMarketBatchDate){
      this.activeSub3TabJoinOrder = 1;
      this.selectedBatchid = batchid;
      this.selectedPurchaseMarketPrepareID = purchasemarketprepareid; 
      this.selectedProductid = productid;
      this.MARKETQUANTITY = quantity;
      this.selectedMarketBatchDate = selectedMarketBatchDate; 
      
      this.selectedProductQuantity = quantity;
      
      RestAPI.joinOrderDetail(this.username, batchid, productid)
        .then((res) => {
          // console.log("joinOrderDetail res.data: "+ JSON.stringify(res.data))  
          this.allMarketBillDateDetailOrderbycustomer = res.data.orderbycustomer;
          this.allMarketBillDateDetailOrder = res.data.order;
          this.marketProductTempQuantity = res.data.purchasemarkettemp_quantity.QUANTITY_TEMP
          this.productMarketID = res.data.purchasemarkettemp_quantity.MARKETID
          this.allMarketBillDateDetailPurchaserProduct = res.data.purchaserproduct;
          this.marketList = res.data.market;
          // this.allMarketBillDateDetailProduct = res.data;
          // console.log("res.data: " + JSON.stringify(res.data)) 

        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });

    },

    getMarketOrderDetail(batchid, redate,marketid, marketname){
      this.activeSub2TabMarketOrder = 1;
      this.selectedMarketOrderBatchID = batchid;
      this.selectedMarketOrderDate = redate;
      this.selectedMarketOrderMarketname = marketname;
      this.selectedMarketOrderMarketID = marketid;

      RestAPI.getMarketOrderDetail(batchid, redate,marketid)
        .then((res) => {
          this.marketorderdatedetail = res.data;

        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getMarketOrderDate(){},
    // getMarketOrderDate(){
    //   RestAPI.getMarketOrderDate(
    //     this.dateFormatterYYYYMMDD(this.startMarketOrderDate),
    //     this.dateFormatterYYYYMMDD(this.endMarketOrderDate)
    //   )
    //     .then((res) => {
    //       this.allmarketorderdate = res.data.marketorderdate;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
    // },

    saveMarketforMarketBill(){
     
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            purchasemarketprepareid: this.selectedPurchaseMarketPrepareID,
            productid: this.selectedProductid,
            marketbilldetail: this.allMarketBillDateDetailOrder,
            username: this.username,
          };
          // console.log("params: " + JSON.stringify(params))  
          RestAPI.saveMarketforMarketBill(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.marketBillDetail(this.selectedMarketBatchID,1)
              this.joinOrderDetail(this.selectedBatchid,this.selectedPurchaseMarketPrepareID,this.selectedProductid, this.MARKETQUANTITY,this.selectedMarketBatchDate);
              this.allMarketBatchStatus(); 
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    confirmMarketforMarketBill(){
     
     this.$swal({
       title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
       showCancelButton: true,
       showCloseButton: true,
       confirmButtonText: "ຕ້ອງການ",
       cancelButtonText: "ບໍ່ຕ້ອງການ",
       confirmButtonColor: "#d33",
       cancelButtonColor: "#3085d6",
     }).then((result) => {
       if (result.value) {
         var params = {
           batchid: this.allMarketBillDateDetail[0].MARKETBATCHID,
           username: this.username,  
         };
         // console.log("params: " + JSON.stringify(params))  
         RestAPI.confirmMarketforMarketBill(params)
           .then(() => {
             this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
             this.marketBillDetail(this.selectedMarketBatchID)
             this.getMarketOrderDate();  
             this.allMarketBatchStatus();
             
            })
           .catch((error) => {
             console.log(error);  
             if (error == "Error: Request failed with status code 400") {
               this.$swal("Check Input Data", "", "error");
             } else {
               this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
             }
           });
       }
     });
   },

    marketBillDetail(batchid, orderby){
      
      this.selectedMarketBatchID = batchid;

      RestAPI.getallMarketBatchDetail(batchid, this.username, orderby)  
        .then((res) => {
          
          this.allMarketBillDateDetail = res.data.detail;
          // console.log("allMarketBillDateDetail : " + JSON.stringify(res.data.detail))  

          this.purchaserProduct = res.data.purchaser;
          this.checkmarketAllProduct = res.data.checkmakretproduct.ALLPRODUCT;
          this.checkmarketBuyProduct = res.data.checkmakretproduct.BUYPRODUCT;
          // console.log("res.data.checkmakretproduct: batchid : " + JSON.stringify(res.data.checkmakretproduct))  
          // console.log("batchid : " + batchid)  
          this.marketbatchstatus = res.data.detail[0].MARKETBATCHSTATUS;
          this.marketList = res.data.market;

          this.activeSub2TabMarketBatch = 3;

          // console.log("res.data-: " + JSON.stringify(res.data.market))

          // this.selectedMarketBatchDetailDate =res.data.companylist[0].REDATE;
          // this.isSaveMarketButton = res.data.remainmarket.remain == 0 ? false : true;
          // this.ordercompanylist = res.data.companylist;

          // console.log("res.data-: " + JSON.stringify(res.data))
          // console.log("res.data- REDATE: " + JSON.stringify(res.data.detail[0]))


        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });

    },

    allMarketBatchStatus( byroute = 0) {
      // this.b2bname = null;
      // this.activeSub2TabMarketBatch = 0;
      this.marketbatchdetaillist = [];
      this.selectedMarketBatchDate = null; 
      
      RestAPI.getallMarketBatchStatus(
        this.dateFormatterYYYYMMDD(this.startMarketBatchDate),
        this.dateFormatterYYYYMMDD(this.endMarketBatchDate), byroute
      )
        .then((res) => {
          this.allquotationformarketdatelist = res.data.allquotationformarket;
          this.allMarketBillDateList = res.data.allmarketbilldate;

        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    joinMarketBatch(type, data){
      // console.log("data: "+ JSON.stringify(data))
      // 0 no action , 1 join 
      if(type==1){
          this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            var params = {
              purchaseid: data.PURCHASEID,
              b2busername: data.B2BUSERNAME,
              redate: data.REDATE,
              username: this.username,
            };
            // console.log("data: " + JSON.stringify(data))
            RestAPI.joinMarketBatchOrder(params)
              .then(() => {
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                this.allMarketBatchStatus(); 
                
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
              });
          }
        });
       
      }
      else if(type==0){

        this.marketBillDetail(data.MARKETBATCHID, 1);  
        this.selectedMarketBatchDate = data.REDATE;
        // console.log("data.REDATE: " +data.REDATE)
        // console.log("this.selectedMarketBatchDate: " +this.selectedMarketBatchDate)
      }


    },

    cancelJoinMarketBatchOrder(batchid){

          this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            var params = {
              batchid: batchid,
              username: this.username,
            };
            // console.log("data: " + JSON.stringify(data))
            RestAPI.cancelJoinMarketBatchOrder(params)
              .then(() => {
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                this.allMarketBatchStatus();   
                this.activeSub2TabMarketBatch = 0;
                
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
              });
          }
        });
 


    },
    loadB2BProductRequirement(){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {  
            products: this.waitdetaillist, 
            b2busername: this.b2busername,
            redate: this.selectedWaitDate,
            provinceid: this.b2bprovince,
            district: this.b2bdistrict,
            village: this.b2bvillage,
            username: this.username,
          };
          // console.log("params: " + JSON.stringify(params))
          RestAPI.loadB2BProductRequirement(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.allProductStatus();
              this.activeTab = 3;
              this.activeSub2TabPrepare = 0;
              this.waitdetaillist = [];
              this.selectedWaitDate = null;
              this.waitdetaillist = [];
              this.activeSub2TabWait = 0;
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },



    onCopyReceiptToPrepare(){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            products: this.receiptdetaillist, 
            b2busername: this.b2busername,
            contractid: this.contractid,
            redate:  this.dateFormatterYYYYMMDD(this.preparedate),
            username: this.username,
          };
          RestAPI.copyReceiptToPrePare(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.activeTab = 3;
              this.activeSub2TabPrepare = 0;
              // this.getContractProducts();
              this.allProductStatus();
              this.preparedetaillist = [];
              this.selectedPrepareDate = null;
              this.receiptdetaillist = [];
              this.selectedReceiptDate = null;
              this.activeSub2TabReceipt = 0;
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    onCopyReceiptToPrepareV2(){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            products: this.buylist, 
            b2busername: this.b2busername,
            contractid: this.contractid,
            redate:  this.dateFormatterYYYYMMDD(this.preparedate),
            username: this.username,
          };

          console.log("params: " + JSON.stringify(params))
          RestAPI.copyReceiptToPrePareV2(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.activeTab = 3;
              this.activeSub2TabPrepare = 0;
              // this.getContractProducts();
              this.allProductStatus();
              this.preparedetaillist = [];
              this.selectedPrepareDate = null;
              this.receiptdetaillist = [];
              this.selectedReceiptDate = null;
              this.activeSub2TabReceipt = 0;
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    productSearchm() {
      this.showm = this.b2bproductsearchm;
    },
    productSearch() {
      // console.log("this.b2bproductsearch: " + this.b2bproductsearch)
      // this.show = this.b2bproductsearch;

      if (this.b2bproductsearch) {
        this.filteredProducts = this.productssearch.filter(product => {
        // Assuming product name is in 'name' property, adjust this according to your data structure
          return product.PRODUCTNAME_SUB.toLowerCase().includes(this.b2bproductsearch.toLowerCase());
        });
        // var params = {
        //   search: this.b2bproductsearch,
        //   contractid: this.contractid,
        //   selecteddate: this.dateFormatterYYYYMMDD(this.selecteddate)
        // };
        // RestAPI.productB2BSearch(params)
        //   .then((res) => {
        //     // var save = res.data.save;
        //     // var remain = res.data.remain;
        //     // this.productssearch =  save.concat(remain) ;
        //     this.productssearch = res.data.remain;
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //     this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        //   });
      } else {
        // this.getSavedProductB2BSearch();
        this.filteredProducts = this.productssearch;
      }

    },

    getSavedProductB2BSearch() {
      // console.log("getSavedProductB2BSearch");
        var params = {
          contractid: this.contractid,
          selecteddate: this.dateFormatterYYYYMMDD(this.selecteddate)
        };
        RestAPI.getSavedProductB2BSearch(params)
          .then((res) => {
            // console.log("res.data: " + JSON.stringify(res.data))
            // this.productssearch =  res.data ;
            var save = res.data.save;
            var remain = res.data.remain;
            this.productssearch =  save.concat(remain) ;
            // this.productssearch =  res.data.remain ;
            this.filteredProducts = this.productssearch; // Populate filteredProducts as well
          })
          .catch((error) => {
            console.log(error);
            this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
          });

    },
    backToForm() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            purchaseid: this.selectedPurchaseID,
            username: this.username,
          };
          RestAPI.b2bPurchaseOrderBackToForm(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.activeTab = 1;
              this.activeSub2TabPrepare = 0;
              // this.getContractProducts();
              this.allProductStatus();
              this.preparedetaillist = [];
              this.selectedPrepareDate = null;
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });  
    },
    backToPrepare() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {

          this.$swal({
            title: "ໃສ່ລະຫັດເພື່ອຢືນຢັນ",
            input: 'password',  // Input type password
            inputPlaceholder: 'ລະຫັດຜ່ານ',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'ຢືນຢັນ',
            cancelButtonText: 'ຍົກເລີກ',
            confirmButtonColor: "#41B883",
            cancelButtonColor: "#F7C325",  
            reverseButtons: true,  
            preConfirm: (password) => {
              if (!password) {
                this.$swal.showValidationMessage('ກະລຸນາໃສ່ລະຫັດຢືນຢັນ');  
              } else {
                return password;
              }  
            }
          }).then((secondResult) => {
            if (secondResult.value) {
              // Check password before proceeding (you can validate with an API)
              const password = secondResult.value;
              
              // Example API validation (replace with your actual API call)
  
                if (password==="88998899") {
                  // Proceed with the action after successful password validation
                  var params = {
                    purchaseid: this.selectedPurchaseID,
                    username: this.username,
                  };
                  RestAPI.b2bPurchaseOrderBackToPrepare(params)
                    .then(() => {
                      this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                      this.activeTab = 3;
                      this.activeSub2TabPrepare = 0;
                      // this.getContractProducts();
                      this.allProductStatus();
                      this.preparedetaillist = [];
                      this.selectedPrepareDate = null;
                    })
                    .catch((error) => {
                      console.log(error);
                      if (error == "Error: Request failed with status code 400") {
                        this.$swal("Check Input Data", "", "error");
                      } else {
                        this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                      }
                    });
                } else {
                  this.$swal("ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ", "", "error");
                }
                
            }
          });

        }
      });
    },
    submitProductsAmount() {
      // this.contractid;
      // this.dateFormatterYYYYMMDD(this.selecteddate)
      // console.log(" this.contractid: " +  this.contractid)
      // console.log(" this.selecteddate: " +  this.dateFormatterYYYYMMDD(this.selecteddate))
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            contractid: this.contractid,
            purchasedate: this.dateFormatterYYYYMMDD(this.selecteddate),
            username: this.username,
          };
          RestAPI.submitB2BProductsAmount(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.activeTab = 3;
              this.activeSub2TabPrepare = 0;
              // this.getContractProducts();
              this.allProductStatus();
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    // productSearch(typeId) {
    //   this.b2bproductTypeId = typeId;
    //   // console.log("this.b2bproductsearch: "+ this.b2bproductsearch)
    //   // console.log("this.b2bproductTypeId: "+ this.b2bproductTypeId)

    //   RestAPI.getContractProductsBySearch(
    //     this.contractid,
    //     this.dateFormatterYYYYMMDD(this.selecteddate),
    //     1, this.b2bproductsearch, this.b2bproductTypeId
    //   )
    //     .then((res) => {
    //       this.products = res.data;
    //       console.log("products: " + JSON.stringify(this.products));
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });

    // },
    editPrepare() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            purchaseid: this.selectedPurchaseID,
            b2busername: this.b2busername,
            prepareprodcutlist: this.preparedetaillist,
            po: this.customerPO,
            username: this.username,
          };
          // console.log("params: " + JSON.stringify(params));   
          RestAPI.editB2BPrepareProduct(params)
            .then(() => {
              // console.log("data: " + JSON.stringify(res.data));
              this.allProductStatus();
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.openContractDateForm(1, this.submitData);
              this.enableprepareedit = 0;
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    cancelPrepare() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            purchaseid: this.selectedPurchaseID,
            username: this.username,
          };
          RestAPI.cancelB2BPrepareProduct(params)
            .then(() => {
              // console.log("data: " + JSON.stringify(res.data));

              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.enableprepareedit = 0;
              this.activeSub2TabPrepare = 0;
              this.preparedetaillist = [];
              // this.getContractProducts();
              this.allProductStatus();
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    saveCustomerPO() {
      if(this.customerPO == null){   
  
        this.$swal("ກະລຸນາປ້ອນ PO", "", "warning");

      }else{
      
          this.$swal({
            title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "ຕ້ອງການ",
            cancelButtonText: "ບໍ່ຕ້ອງການ",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
            if (result.value) {
              var params = {
                purchaseid: this.selectedPurchaseID,
                po: this.customerPO,
                username: this.username,
              };
              console.log("params: " + JSON.stringify(params))
              RestAPI.saveCustomerPO(params)
                .then(() => {
                  // console.log("data: " + JSON.stringify(res.data));

                  this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                  this.enableprepareedit = 0;
                  this.activeSub2TabPrepare = 1;
                  this.preparedetaillist = [];
                  // this.getContractProducts();
                  this.openContractDateForm(1, this.submitData);
                  
                })
                .catch((error) => {
                  console.log(error);
                  if (error == "Error: Request failed with status code 400") {
                    this.$swal("Check Input Data", "", "error");
                  } else {
                    this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                  }
                });
            }
          });
      }
    },
    cancelQuotation() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            purchaseid: this.selectedPurchaseID,
            username: this.username,
          };
          RestAPI.cancelB2BQuotationProduct(params)
            .then(() => {
              // console.log("data: " + JSON.stringify(res.data));

              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.enableprepareedit = 0;
              this.activeSub2TabQuotation = 0;
              this.quotationdetaillist = [];
              this.selectedQuotationDate = null;
              // this.getContractProducts();
              this.allProductStatus();
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    editQuotation() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            b2busername: this.b2busername,
            quotationprodcutlistfull: this.quotationdetaillistfull,
            quotationprodcutlistsome: this.quotationdetaillistsome, 
            quotationprodcutlistzero: this.quotationdetaillistzero,  
            username: this.username,
          };
          console.log("editQuotation: " + JSON.stringify(params));
          RestAPI.editB2BQuotationProduct(params)
            .then(() => {
              // console.log("data: " + JSON.stringify(res.data));

              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.openContractDateForm(2, this.submitData);
              this.enablequotationedit = 0;  
              this.allProductStatus();
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    enablePrepareEdit() {
      this.enableprepareedit = 1;
    },
    enableQuotationEdit() {
      this.enablequotationedit = 1;
    },
    enableInvoiceEdit() {
      this.enableinvoiceedit = 1;
    },
    editInvoice() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            b2busername: this.b2busername,
            invoiceprodcutlistfull: this.invoicedetaillistfull,
            invoiceprodcutlistsome: this.invoicedetaillistsome, 
            invoiceprodcutlistzero: this.invoicedetaillistzero,    
            username: this.username,
          };
          console.log("params: " + JSON.stringify(params));
          RestAPI.editB2BInvoiceProduct(params)
            .then(() => {
              // console.log("data: " + JSON.stringify(res.data));

              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.openContractDateForm(3, this.submitData);  
              this.allProductStatus();    
              this.enableinvoiceedit = 0;
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    lockNewB2BProductPrice() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            phurchaseid: this.selectedPurchaseID,    
            username: this.username,
          };
          // console.log("params: " + JSON.stringify(params));
          RestAPI.lockNewB2BProductPrice(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.openContractDateForm(3, this.submitData);  
              this.allProductStatus();    
              this.enableinvoiceedit = 0;   
              this.selectedPurchaseLOCKED = 1;
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    enableMarketOrderEdit() {
      this.enablemarketorderedit = 1; 
    },
    editMarketOrder() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            b2busername: this.b2busername,
            marketorderdatedetail: this.marketorderdatedetail,
            username: this.username,
          };
          // console.log("params: " + JSON.stringify(params));
          RestAPI.editB2BMarketOrder(params)
            .then(() => {
              // console.log("data: " + JSON.stringify(res.data));

              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.getMarketOrderDetail(this.selectedMarketOrderBatchID, this.selectedMarketOrderDate, this.selectedMarketOrderMarketID, this.selectedMarketOrderMarketname);
              this.enablemarketorderedit = 0;
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    cancelForm() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var params = {
            selecteddate: this.dateFormatterYYYYMMDD(this.selecteddate),
            username: this.b2busername,
          };

          const loadingComponent = this.$loading.open({});

          console.log("params: " +JSON.stringify(params))

          RestAPI.cancelB2BFormProduct(params)
            .then(() => {
              // console.log("data: " + JSON.stringify(res.data));

              // this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");

              // this.getContractProducts();
              this.allProductStatus();
              this.productSearch();

              loadingComponent.close();

              this.$swal({
                title: "ສຳເລັດ",
                text: "ດຳເນີນການ ສຳເລັດ!",
                icon: "success",
                timer: 500,
                showConfirmButton: false, 
              });

            })
            .catch((error) => {  
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    paymentConfirmForm(){
      this.paymentStatus = 1;
      
    },

    onSelectPaymentType(){
      if(this.selectedPaymentType.ID ==1){
        this.isManyBill = 0;
      }else{
        this.isManyBill = 1;
      }
      
    },

    doPaymentConfirm(redate){
      if(this.selectedPaymentType== null || this.selectedBank == null || this.receiptDateTime == null || this.photoname== null || this.receiveno == null){   
        // console.log("-----------------------")
        // console.log("selectedPaymentType: " +JSON.stringify(this.selectedPaymentType))
        // console.log("selectedBank: " +JSON.stringify(this.selectedBank))
        // console.log("receiptDateTime: " +JSON.stringify(this.receiptDateTime))
        // console.log("paymentReceiptNo: " +JSON.stringify(this.paymentReceiptNo))
        // console.log("photoname: " +JSON.stringify(this.photoname))
  
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");

      }else{
        this.$swal({
          title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",  
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#3085d6",  
          cancelButtonColor: "#F7C325", 
          reverseButtons: true
        }).then((result) => {
          if (result.value) {

            this.$swal({
              title: "ໃສ່ລະຫັດເພື່ອຢືນຢັນ",
              input: 'password',  // Input type password
              inputPlaceholder: 'ລະຫັດຜ່ານ',
              inputAttributes: {
                autocapitalize: 'off'
              },
              showCancelButton: true,
              confirmButtonText: 'ຢືນຢັນ',
              cancelButtonText: 'ຍົກເລີກ',
              confirmButtonColor: "#41B883",
              cancelButtonColor: "#F7C325",  
              reverseButtons: true,  
              preConfirm: (password) => {
                if (!password) {
                  this.$swal.showValidationMessage('ກະລຸນາໃສ່ລະຫັດຢືນຢັນ');  
                } else {
                  return password;
                }  
              }
            }).then((secondResult) => {
              if (secondResult.value) {
                // Check password before proceeding (you can validate with an API)
                const password = secondResult.value;
                
                // Example API validation (replace with your actual API call)

                  if (password==="999888") {
                    // Proceed with the action after successful password validation
                    
                    var params = {
                      redate: redate,
                      purchaseid: this.selectedPurchaseID,
                      contractid: this.invoicedetaillisttotal.CONTRACTID,
                      customername: this.invoicedetaillisttotal.COMPANY,  
                      amount: this.invoiceTotal,  
                      // vat: this.invoiceTotal* 0.1,  // in case vat, ແຕ່ລະຮ້ານບໍ່ຄືກັນ
                      vat: 0,

                      receiveno: this.receiveno,
                      receiptdatetime: this.dateFormatterYYYYMMDD(this.receiptDateTime),
                      paymenttypeid : this.selectedPaymentType.ID,
                      bankid: this.selectedBank.ID,
                      billlist: this.billList,
                      photoname: this.photoname,  
                      username: this.username,
                    };

                    

                    // console.log("params-: " +JSON.stringify(params))

                    const loadingComponent = this.$loading.open({});  
                    RestAPI.doPaymentConfirm(params)  
                      .then((res) => {
                        
                        
                        loadingComponent.close();

                        if(res.data.code =='00'){
                          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");

                          this.selectedPaymentType= null;
                          this.selectedBank = null;
                          this.receiptDateTime = null;
                          this.paymentReceiptNo = null;
                          this.billList = Array(10).fill('');
                          this.photoname = null;
                          this.photopreview = null;
                          this.selectedFile = null;
                          this.paymentStatus = 0;
                          this.isManyBill = 0;

                          this.allProductStatus();

                          this.invoicedetaillist = [];
                          this.invoicedetaillisttotal = [];
                          this.invoicedetaillistfull = [];
                          this.invoicedetaillistsome = [];
                          this.invoicedetaillistzero = [];
                          this.selectedInvoiceDate = null;
                          this.activeSub2TabInvoice= 0;   
                          this.activeTab = 6;
                          this.activeSub2TabReceipt= 0;
                          this.receiveno = null;

                        }else if(res.data.code =='01'){
                          this.$swal("ເລກທີໃບຮັບເງິນຊ້ຳ!", "", "error");
                          return false;

                        }else{
                          this.$swal("ດຳເນີນການບໍ່ສຳເລັດ", "", "error");
                          return false;
                        }

                      })
                      .catch((error) => {
                        console.log(error);
                        if (error == "Error: Request failed with status code 400") {
                          this.$swal("Check Input Data", "", "error");
                        } else {
                          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                        }
                      });
                  } else {
                    this.$swal("ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ", "", "error");
                  }
                  
              }
            });

          }


            



              
          
        });
      }
        
    },

    triggerFileInput() {
      const fileInput = document.getElementById('fileupload');
      fileInput.value = null; // Reset file input
      fileInput.click(); // Trigger file input click
    },

    onFileSelected(event) {
      this.selectedFile = "";
      
      if (event.target.files.length === 0) {
        return; // No file selected
      }

      const loadingComponent = this.$loading.open({});  

      this.selectedFile = event.target.files[0];
      const fd = new FormData();
      fd.append("image", this.selectedFile);

      axios.post(this.url, fd)
        .then((res) => {
          this.photoname = res.data;
          this.photopreview = this.getReceiptImgUrl(this.photoname);
          // console.log("photoname: " + this.photoname);
          // console.log("photopreview: " + this.photopreview);
          loadingComponent.close();
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
        });
    },
    getReceiptImgUrl(photoname) {
      return photoname
        ? this.photopath_receipt + photoname
        : this.photopath_receipt + "unknown.png";
    },
    // getReceiptImgUrl(photoname) {
    //   var photopreview = photoname
    //     ? this.photopath_receipt + photoname
    //     : this.photopath_receipt + "unknown.png";
    //   // console.log("photoname: " + photoname)
    //   // console.log("photopreview: " + photopreview)
    //   return photopreview;
    // },

    // onFileSelected(event) {
    //   this.selectedFile ="";
    //   console.log("url: "+ this.url)
    //   console.log("photopath: " + this.photopath_receipt)   
    //   this.selectedFile = event.target.files[0];
    //   const fd = new FormData();
    //   fd.append("image", this.selectedFile);
    //   axios.post(this.url, fd).then((res) => {
    //     this.photoname = res.data;
    //     this.photopreview = this.photopath_receipt + res.data;
    //     console.log("photoname: "+ this.photoname)   
    //   });
    // },
      
    changeContractDateStatus(purchaseStatus) { 
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params;

          if(purchaseStatus==4){
            params = {
              purchaseid: this.selectedPurchaseID,
              status: purchaseStatus,
              username: this.username,

              paymenttype: '',
              paymentdate: '',
              receiveno: '',
              photoname: '',

            };
          }else if(purchaseStatus==2){
            console.log("purchaseStatus: 2 " )
            console.log("selectedSubB2B: " + this.selectedSubB2B)  
            console.log("b2btype: " + this.b2btype)  

            
            
            if(this.selectedSubB2B == null && this.b2btype== 2){ 
              this.$swal("ເລືອກຊື່ລູກຄ້າ", "", "error");
              return false;
            }else{
              console.log("b2btype: " + this.b2btype)
              params = {
                purchaseid: this.selectedPurchaseID,  
                b2bsubid: this.selectedSubB2B == null ? 0 : this.selectedSubB2B.ID,    
                status: purchaseStatus,
                username: this.username,
              };
            }
              
          }else{
            params = {
              purchaseid: this.selectedPurchaseID,
              status: purchaseStatus,
              username: this.username,
            };
          }
          

          // console.log("puchaseid: " + JSON.stringify(params))

          RestAPI.changeContractDateStatus(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              // this.openContractProductList(purchaseStatus - 1);
              // this.getContractProducts();
              this.allProductStatus();
              

              if (purchaseStatus - 1 == 0) {
                this.waitdetaillist = [];
                this.selectedWaitDate = null;
              } else if (purchaseStatus - 1 == 1) {
                this.preparedetaillist = [];
                this.selectedPrepareDate = null;
                this.activeSub2TabPrepare = 0;  
                this.activeTab = 4;
                this.activeSub2TabQuotation = 0;
              } else if (purchaseStatus - 1 == 2) {
                this.quotationdetaillist = [];
                this.selectedQuotationDate = null;
                this.activeSub2TabQuotation = 0;
                this.activeTab = 5;
                this.activeSub2TabInvoice= 0;
              } else if (purchaseStatus - 1 == 3) {
                this.invoicedetaillist = [];
                this.invoicedetaillisttotal = [];
                this.invoicedetaillistfull = [];
                this.invoicedetaillistsome = [];
                this.invoicedetaillistzero = [];
                this.selectedInvoiceDate = null;
                this.activeSub2TabInvoice= 0;
                this.activeTab = 6;
                this.activeSub2TabReceipt= 0;
              } else if (purchaseStatus - 1 == 4) {
                this.receiptdetaillist = [];
                this.selectedReceiptDate = null;
                this.activeSub2TabReceipt= 0;
                this.activeTab = 7;
                this.activeSub2TabAllOrders= 0;
              }
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    getUnSubmitPurchase() {
      RestAPI.getUnSubmitPurchase(this.selectedPurchaseID)
        .then((res) => {
          this.hasSomeUnSubmitPurchase = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    resetData (){
      this.waitdetaillist  = [];
      this.preparedetaillist  = [];
      this.preparecount  = [];

      this.quotationdetaillisttotal = [];
      this.quotationdetaillist = [];
      this.quotationdetaillistfull = [];
      this.quotationdetaillistsome = [];
      this.quotationdetaillistzero = [];

      this.invoicedetaillisttotal = [];
      this.invoicedetaillist = [];
      this.invoicedetaillistfull = [];
      this.invoicedetaillistsome = [];
      this.invoicedetaillistzero = [];

      this.receiptdata = [];
      this.receiptdetaillisttotal = [];
      this.receiptdetaillist = [];
      this.receiptdetaillistfull = [];
      this.receiptdetaillistsome = [];
      this.receiptdetaillistzero = [];

      
    },
    openContractDateForm(type, data) {
      
      this.allorderstatus = data.STATUS;
      this.submitData = data;
      this.submitType = type;
      this.selectedPurchaseID = data.PURCHASEID;
      this.selectedContractID = data.B2BID;

      this.invoiceAccountStatus = 0;
      this.iskarghuptoaccount = 0;

      const loadingComponent = this.$loading.open({});

      this.resetData();

      if (type == 0) {
        this.getUnSubmitPurchase();
        this.selectedWaitDate = data.REDATE;
        this.selectedDate = data.REDATE;
        this.activeSub2TabWait = 1;
      } else if (type == 1) {
        this.getUnSubmitPurchase();
        this.selectedPrepareDate = data.REDATE;
        this.selectedDate = data.REDATE;
        this.activeSub2TabPrepare = 1;
      } else if (type == 2) {
        this.quotationmarketbatchstatus = data.MARKETBATCHSTATUS;
        this.getUnSubmitPurchase();
        this.selectedQuotationDate = data.REDATE;
        this.selectedDate = data.REDATE;
        this.activeSub2TabQuotation = 1;
        this.printtype = 2;
      } else if (type == 3) {
        this.isNewB2B = data.ISNEW;
        this.selectedPurchaseLOCKED = data.LOCKED;
        this.selectedInvoiceDate = data.REDATE;
        this.selectedDate = data.REDATE;
        this.activeSub2TabInvoice = 1;
        this.printtype = 3;
      } else if (type == 4) {
        this.selectedReceiptDate = data.REDATE;
        this.selectedDate = data.REDATE;
        this.activeSub2TabReceipt = 1;
        this.printtype = 4;
      } else if (type == 5) {
        this.selectedAllOrdersDate = data.REDATE;
        this.selectedDate = data.REDATE;
        this.activeSub2TabAllOrders = 1;
        this.b2bname = null;
        this.allOrdersB2BName = data.COMPANY;
      }else if (type == 6) {
        this.selectedMarketBatchDate = data.REDATE;
        this.selectedDate = data.REDATE;
        this.activeSub2TabMarketBatch = 1;
        this.b2bname = null;
        this.marketBatchB2BName = data.COMPANY;
      }else if (type == 44) {
        this.selectedReceiptDate = data.REDATE;
        this.selectedDate = data.REDATE;
        this.activeB2BTab = 1;
        // this.printtype = 44;
        this.selectedProfitCompany = data.COMPANY;
        this.selectedProfitPurchaseID = data.PURCHASEID;
        this.selectedProfitStatus = data.STATUS;
        this.getProfitDetailList(this.selectedPurchaseID);
      }else if (type == 444) {
        this.startProfitDate = data.REDATE;
        this.endProfitDate = data.REDATE;
        this.allProfitStatus();
        this.activeSub2TabProfit = 1;
      }

      if (data.QUOTATIONUP) {
        this.activeTab = 2;
        this.quotationup = 1;
        this.contractid = data.B2BID;
        this.selectedcontractno = data.CONTRACTNO;
        this.selectedsubcontractno = data.SUBCONTRACTNO;
        this.contractdate = data.CONTRACTDATE;
        this.b2busername = data.B2BUSERNAME;
        this.isContractProductList = true;
        this.contractstatus = data.STATUS;
        // this.contractstatus = STATUS;
      }

      // console.log("data: " + JSON.stringify(data));



      RestAPI.getContractDateProductList(
        type,
        this.selectedContractID,
        1,
        this.selectedDate,
        data.PURCHASEID,
        this.selectedAllproductid  
      )
        .then((res) => {
          loadingComponent.close();

          // console.log("this.selectedAllproductid  : " + this.selectedAllproductid  );  

          

          // console.log("marketbatchdetaillist total: " + JSON.stringify(res.data.total));
          // console.log("marketbatchdetaillist full: " + JSON.stringify(res.data.full));
          // console.log("marketbatchdetaillist some: " + JSON.stringify(res.data.some));
          // console.log("marketbatchdetaillist zero: " + JSON.stringify(res.data.zero));
          if (type == 0) {
            this.waitdetaillist = res.data;
          } else if (type == 1) {
            this.preparedetaillist = res.data.list;
            this.customerPO = res.data.list? res.data.list[0].CUSTOMERPO : null;
            this.preparecount = res.data.count;
            // console.log("preparecount-: " + JSON.stringify(this.preparecount));

          } else if (type == 2) {
            // console.log("res.data.total: " + JSON.stringify(res.data.total));  
            // console.log("res.data.list: " + JSON.stringify(res.data.list)); 
            // console.log("res.data.full: " + JSON.stringify(res.data.full)); 
            // console.log("res.data.some: " + JSON.stringify(res.data.some));
            // console.log("res.data.zero: " + JSON.stringify(res.data.zero));

            this.quotationdetaillisttotal = res.data.total;
            this.quotationdetaillist = res.data.list;
            this.customerPO = res.data.list? res.data.list[0].CUSTOMERPO : null;
            this.quotationdetaillistfull = res.data.full;
            this.fullname = this.quotationdetaillistfull ?  this.quotationdetaillistfull[0].FULLNAME : null;
            this.quotationdetaillistsome = res.data.some;
            this.quotationdetaillistzero = res.data.zero;

          } else if (type == 3) {

            
            this.invoicedetaillisttotal = res.data.total;
            this.invoiceTotal = parseInt(res.data.total.total);
            this.invoicedetaillist = res.data.list;   
            this.customerPO = res.data.list? res.data.list[0].CUSTOMERPO : null;
            this.invoicedetaillistfull = res.data.full;
            this.fullname = this.invoicedetaillistfull ?  this.invoicedetaillistfull[0].FULLNAME : null;

            this.invoiceAccountStatus= res.data.full[0].ACCOUNTSTATUS;
            if(this.invoiceAccountStatus ==1){   
              this.iskarghuptoaccount = 1;   
            }
            this.invoicedetaillistsome = res.data.some;
            this.invoicedetaillistzero = res.data.zero;

            

          } else if (type == 4) {
            // console.log("res.data.main: " + JSON.stringify(res.data.main));   
            this.receiptdata = res.data.main;
            this.receiptdetaillisttotal = res.data.total;    
            this.receiptdetaillist = res.data.list;
            this.customerPO = res.data.list? res.data.list[0].CUSTOMERPO : null;
            this.receiptdetaillistfull = res.data.full;
            this.fullname = this.receiptdetaillistfull ?  this.receiptdetaillistfull[0].FULLNAME : null;
            this.receiptdetaillistsome = res.data.some;
            this.receiptdetaillistzero = res.data.zero;
            
          } else if (type == 5) {
            this.allordersdetaillist = res.data;
          }
          else if (type == 6) {
            this.marketbatchdetaillist = res.data;
            // console.log("this.marketbatchdetaillist" + JSON.stringify(this.marketbatchdetaillist))
            this.selectedMarketOrderBatchID = res.data[0].MARKETBATCHID;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getCountry() {
      RestAPI.getCountry()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.countryList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    saveContract() {
      if (
        this.contractno === null ||
        this.subcontractno === null ||
        this.selecteddate === null ||
        this.SelectedCountry === null ||
        this.SelectedProvince === null ||
        this.district === null ||
        this.village === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          b2busername: this.b2busername,
          contracttype: 1, //purchase
          contractno: this.contractno,
          subcontractno: this.subcontractno,
          contractdate: this.dateFormatterYYYYMMDD(this.selecteddate),
          provinceid: this.SelectedProvince.ID,
          district: this.district,
          village: this.village,
          detail: this.contractdetail,
          dppprovinceid: null,
          ddppbranchid: null,
          stockid: null,
          username: this.username,
        };
        // console.log("params: " + JSON.stringify(params));
        RestAPI.saveContract(params)
          .then((res) => {
            // console.log("data: " + JSON.stringify(res.data))
            if (res.data == "duplicate b2bcontract") {
              this.$swal("ສັນຊາຊໍ້ຳ", "-", "error");
              return false;
            }

            this.getContractByB2bUser(this.b2busername);
            this.$swal("ບັນທຶກສັນຍາ ສຳເລັດ!", "", "success");
            this.saveAction = true;
            this.updateAction = false;
            this.selecteddate = null;
            this.contractno = null;
            this.subcontractno = null;
            this.detail = null;
            this.selectedCountry = null;
            this.SelectedProvince = null;
            this.district = null;
            this.village = null;
            this.SelectedDppProvince = null;
            this.selectedStock = null;
            // console.log(res);
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getContractByB2bUser(b2busername) {
      RestAPI.getContractByB2bUser(b2busername, 1)
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.contractlist_waittoapprove = res.data.waittoapprove;
          this.contractlist_waitinvoice = res.data.waitinvoice;
          this.contractlist_waitreceipt = res.data.waitreceipt;
          this.contractlist_receipt = res.data.receipt;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getB2bUser() {
      RestAPI.getDASMWaiterB2bUser()
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.activeb2b = res.data;
          // this.inactivemarkets = res.data.inactivemarkets;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProductType() {
      RestAPI.getB2BProductType()
        .then((res) => {
          this.productType = res.data;
          this.buyListProductTypeList = res.data;
          this.topProductTypeList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getContractProducts() {
      // console.log("getContractProducts")
      RestAPI.getContractProductsByType(
        this.contractid,
        this.dateFormatterYYYYMMDD(this.selecteddate),
        1
      )
        .then((res) => {
            var save = res.data.save;
            var remain = res.data.remain;
            this.products =  save.concat(remain) ;
          this.productB2BSTATUS = this.products[0].B2BSTATUS;
          this.getSavedProductB2BSearch();
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    createNewContract(B2BUSERNAME, PROVINCEID, DISTRICT, VILLAGE) {
      console.log("createNewContract start");

      // Return the Promise
      return new Promise((resolve, reject) => {
        var params = {
          b2busername: B2BUSERNAME,
          provinceid: PROVINCEID,
          district: DISTRICT,
          village: VILLAGE,
          username: this.username,
        };

        RestAPI.createNewContract(params)
          .then((res) => {
            this.contractid = res.data;
            console.log("createNewContract end");
            // Resolve the Promise with any data you want to pass back
            resolve(res.data);
          })
          .catch((error) => {
            console.log(error);
            // Reject the Promise with the error
            reject(error);
          });
      });
    },

    // createNewContract(B2BUSERNAME, PROVINCEID, DISTRICT, VILLAGE) {
    //   console.log("createNewContract start")
    //   var params = {
    //     b2busername: B2BUSERNAME,
    //     provinceid: PROVINCEID,
    //     district: DISTRICT,
    //     village: VILLAGE,
    //     username: this.username,
    //   };

    //   // console.log("params: " + JSON.stringify(params))
    //   RestAPI.createNewContract(params)
    //     .then((res) => {
    //       this.contractid = res.data;
    //       console.log("createNewContract end")

    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       if (error == "Error: Request failed with status code 400") {
    //         this.$swal("Check Input Data", "", "error");
    //       } else {
    //         this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
    //       }
    //     });
    // },

    async productform(
      B2BUSERID,
      B2BUSERNAME,
      CONTRACTID,
      PROVINCEID,
      DISTRICT,
      VILLAGE,
      PHONENO,
      COMPANYNAME,
      COMPANYTYPE,
      PROVINCENAME,
      TYPE
    ) {

      const loadingComponent = this.$loading.open({});

      this.b2buserid = B2BUSERID;
      this.b2busername = B2BUSERNAME;
      this.b2bphoneno = PHONENO;
      
      this.b2bprovince = PROVINCENAME;
      this.b2bdistrict = DISTRICT;
      this.b2bvillage = VILLAGE;
      
      this.activeSub2TabWait = 0;
      this.activeSub2TabPrepare = 0;
      this.activeSub2TabQuotation = 0;
      this.activeSub2TabInvoice = 0;
      this.activeSub2TabReceipt = 0;
      this.activeSub2TabMarketBatch = 0;
      this.activeSub2TabAllOrders = 0;
      
      

      if (!CONTRACTID || CONTRACTID == null) {
        // Use await with createNewContract
        await this.createNewContract(
          B2BUSERNAME,  
          PROVINCEID,
          DISTRICT,
          VILLAGE
        );
        // this.getContractProducts();
        
        this.allProductStatus();
        this.getB2bUser();

        loadingComponent.close();

      } else {
        this.contractid = CONTRACTID;
        // this.getContractProducts();
        this.allProductStatus();

        loadingComponent.close();
      }

     

      this.isContractProductList = false;

      if(TYPE==0){
        this.activeTab = 2;
      }else if(TYPE==3){
        this.activeTab = 6;
        this.activeSub2TabReceipt = 2;
      }else if(TYPE==3){
        this.activeTab = 3;
        this.activeSub2TabReceipt = 0;
      }else if(TYPE==4){
        this.activeTab = 4;
        this.activeSub2TabReceipt = 0;
      }else if(TYPE==5){
        this.activeTab = 5;
        this.activeSub2TabReceipt = 0;
      }
      else{
        this.activeTab = 1;
      }
      

      this.b2bname = COMPANYNAME;   
      this.companytype = COMPANYTYPE;


      
      

      
    },
    quotadetailform(
      CONTRACTID,
      B2BUSERNAME,
      CONTRACTNO,
      SUBCONTRACTNO,
      CONTRACTDATE,
      SELECTEDDPPBRANCHID,
      SELECTEDDPPPROVINCE,
      STATUS
    ) {
      this.quotationup = 0;
      // this.productdetaillist = [];
      this.selectedContractDate = null;
      this.selectedContractID = null;
      this.preparedatelist = [];
      this.activeTab = 2;
      this.contractid = this.contractid;
      this.selectedcontractno = CONTRACTNO;
      this.selectedsubcontractno = SUBCONTRACTNO;
      this.contractdate = CONTRACTDATE;
      this.b2busername = B2BUSERNAME;
      this.selectedBranchid = SELECTEDDPPBRANCHID;
      this.selectedProvinceid = SELECTEDDPPPROVINCE;
      this.contractstatus = STATUS;
      // this.getContractProducts();  
      this.openContractProductList();
      this.activeSub2TabPrepare = 0;
      this.activeSub2TabQuotation = 0;
      this.activeSub2TabInvoice = 0;
      this.activeSub2TabReceipt = 0;
      this.activeSub2TabAllOrders = 0;
      console.log("STATUS: " + STATUS);
      // console.log("redate: " + this.dateFormatterYYYYMMDD(this.selecteddate));
    },
    gotoB2Blist() {
      this.activeTab = 0;
    },
    // quotaToProduction(ID, MARTKETNAME){
    //   this.activeTab = 2;
    //   this.marketid = ID;
    //   this.marketname = MARTKETNAME;

    //   RestAPI.getProductToProduction(this.marketid)
    //     .then(res => {
    //       this.quotaltoproduction = res.data;
    //     })
    //     .catch(error => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
    // },
    gotoquotadate() {
      this.activeQuotaSubTab = 0;
    },

    onSelecteddate(){

      // this.getContractProducts();
    },

    saveProductAmount(type) {
      //  console.log("this.formdate: "+ this.formdate)
      if (this.selecteddate == null) {
        this.$swal("ກະລູນາປ້ອນຈຳນວນວັນທີ", "", "error");
      }
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selecteddate),
        b2busername: this.b2busername,
        contractid: this.contractid,
        contractno: this.selectedcontractno,
        products: type == 1 ? this.products : this.productssearch,
        contracttype: 1,
        username: this.username,
      };

      // console.log("params: ", JSON.stringify(params));

      RestAPI.saveB2BQuotaProductAmount(params)
        .then((res) => {
          console.log("res: " + JSON.stringify(res.data));

          if (res.data.result > 0) {
            this.$swal("ບັນທືກ ສຳເລັດ!", "", "success");
          } else {
            this.$swal("ກະລຸນາປ້ອນຢ່າງໜ້ອຍ 1 ລາຍການ!", "", "warning");
          }

          // this.getContractProducts();
          this.allProductStatus();
          // this.productSearch();
          this.getSavedProductB2BSearch();
          this.preparedetaillist = [];
          this.b2bproductsearch = null;
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    unSetProductsAmount(type) {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selecteddate),
        contractid: this.contractid,
        typeid: type,
        username: this.username,
      };

      RestAPI.unSetContractProductsAmount(params)
        .then(() => {
          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
          // this.getContractProducts();
          this.allProductStatus();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    unSetProductAmount(ID, type) {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          //  console.log("this.formdate: "+ this.formdate)
          var params = {
            detailid: ID,
            username: this.username,
          };

          // console.log("par: " + JSON.stringify(params));

          RestAPI.unSetContractPurchaseProductAmount(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              if (type == 1) {
                this.openContractProductList(1);
              }

              // this.getContractProducts();
              this.allProductStatus();
              this.b2bproductsearch = null;
              // this.getSavedProductB2BSearch();
              // this.productSearch();
              
              this.preparedetaillist = [];
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    openContractProductList(status) {
      if (status == 1) {
        this.activeTab = 2;
        this.activeSub2TabPrepare = 0;
      } else if (status == 2) {
        this.activeTab = 3;
        this.activeSub2TabQuotation = 0;
      } else if (status == 3) {
        this.activeTab = 4;
        this.activeSub2TabInvoice = 0;
      } else if (status == 4) {
        this.activeTab = 5;
        this.activeSub2TabReceipt = 0;
      }

      this.allProductStatus();
    },

    allProductStatus() {

      const loadingComponent = this.$loading.open({});
      // this.allOrdersStatus();  
      // console.log("this.b2busername 0: " + this.b2busername)
      RestAPI.getContractProductListByContractType(this.contractid,this.b2busername, 1)
        .then((res) => {
          loadingComponent.close();
          // console.log("this.b2busername 1: " + this.b2busername)
          // console.log("allProductStatus: " + JSON.stringify(res.data))
        
            this.waitdatelist = [];
            this.preparedatelist = [];
            this.quotationdatelist = [];
            this.invoicedatelist = [];
            this.receiptdatelist = [];
            this.buylist = [];
            this.countBuyHistoryAmount1 = [];
            this.countBuyHistoryAmount2 = [];
            
            this.subB2BList = [];  
            this.b2btype =  [];
          
          


          this.waitdatelist = res.data.wait;
          this.preparedatelist = res.data.prepare;
          this.quotationdatelist = res.data.quotation;
          this.invoicedatelist = res.data.invoice;
          this.receiptdatelist = res.data.receipt;
          this.buylist = res.data.buylist;  
          this.countBuyHistoryAmount1 = res.data.countamount1;
          this.countBuyHistoryAmount2 = res.data.countamount2; 
          
          this.subB2BList = res.data.subb2blist ?  res.data.subb2blist : 0;  
          this.b2btype =  res.data.b2btype;

          // console.log("this.subB2BList: " + JSON.stringify(this.subB2BList));         

          this.buylist.forEach(item => {  
            // console.log("item.ISCLIAMED: " + item.ISCLIAMED)    
            if (item.ISCLIAMED ==0 ) {
              // console.log("item.ISCLIAMED 0")   
              item.ISCLIAMED = this.b2bproductIsCliamedList[0];   
            }else{
              // console.log("item.ISCLIAMED 1")   
              item.ISCLIAMED = this.b2bproductIsCliamedList[1];   
            }
          });


          // this.profitdatelist = res.data.profit;

          this.allOrdersStatus(); 
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    allOrdersStatus() {
      // this.b2bname = null;  

      // console.log("this.selectedAllOrderCustomer.USERNAME: " + JSON.stringify(this.selectedAllOrderCustomer));

      this.activeSub2TabAllOrders = 0;
      this.allordersdetaillist = [];
      this.selectedAllOrdersDate = null;
      var status = this.selectedAllStatus
        ? this.selectedAllStatus.STATUS
        : "ALL";
      var company = this.selectedAllOrderCustomer
        ? this.selectedAllOrderCustomer.USERNAME
        : "ALL";
      RestAPI.getContractProductListByContractTypeAllOrder(
        this.dateFormatterYYYYMMDD(this.startOrderDate),
        this.dateFormatterYYYYMMDD(this.endOrderDate),
        status,
        company
      )
        .then((res) => {
          this.allordersdatelist = res.data.allorders;
          this.allMarketBatchStatus();
          this.getMarketOrderDate();
          
        }).catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getPaymentData() {
      var paymentdatetype = this.selectedPaymentDateType ? this.selectedPaymentDateType.ID : '1';
      RestAPI.getPaymentData(
        this.dateFormatterYYYYMMDD(this.startPaymentDate),
        this.dateFormatterYYYYMMDD(this.endPaymentDate),
        paymentdatetype
      )
        .then((res) => {
          this.paymentdatalist = res.data;
          // console.log("res.data: " + JSON.stringify(res.data));
          
        }).catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getB2BPaymentData() {
      RestAPI.getB2BPaymentData(
        this.dateFormatterYYYYMMDD(this.startB2BPaymentDate),
        this.dateFormatterYYYYMMDD(this.endB2BPaymentDate)
      )
        .then((res) => {
          this.b2bpaymentdatalist = res.data;
          // console.log("this.b2bpaymentdatalist: " + JSON.stringify(res.data))
          
        }).catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getB2bPaymentDataDetail(company, b2busername, startdate, enddate) {
      this.activePaymentData = 2;
      this.b2bPaymentCompany = company;
      this.b2bPaymentStartDate = startdate;
      this.b2bPaymentEnddate = enddate;
      RestAPI.getB2bPaymentDataDetail(b2busername, this.dateFormatterYYYYMMDD(startdate), this.dateFormatterYYYYMMDD(enddate))   
        .then((res) => {
          this.b2bpaymentdatalistdetail = res.data;
        }).catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    allProfitStatus() {},
    
    // allProfitStatus() {

    //   const loadingComponent = this.$loading.open({});
      
    //   this.seletedstartProfitDate = this.startProfitDate;
    //   this.selectedendProfitDate = this.endProfitDate;
      
    //   var customer = this.selectedAllProfitCustomer ? this.selectedAllProfitCustomer.USERNAME : 0;
    //   var status = this.selectedAllProfitStatus ? this.selectedAllProfitStatus.ID : 0;
    //   this.selectedAllproductid = this.selectedAllProfitProduct ? this.selectedAllProfitProduct.ID : 0;

    //   console.log("allProfitStatus selectedAllproductid : " + this.selectedAllproductid)
    //   var type = 0;
    //   if(!customer && !status){
    //     type = 1;
    //   }else if(customer && !status){
    //     type = 2;
    //   }else if(!customer && status){
    //     type = 3;
    //   }else if(customer && status){
    //     type = 4
    //   }

    //   this.profitSelectedB2BUSERNAME =  this.selectedAllProfitCustomer ? this.selectedAllProfitCustomer.USERNAME : 0;

    //   // console.log("type: " + JSON.stringify(type))
    //   // console.log("selectedAllProfitCustomer: " + JSON.stringify(this.selectedAllProfitCustomer))
    //   // console.log("selectedAllProfitStatus: " + JSON.stringify(this.selectedAllProfitStatus))  
  


    //   RestAPI.getallProfit(this.dateFormatterYYYYMMDD(this.startProfitDate),this.dateFormatterYYYYMMDD(this.endProfitDate), type, customer, this.selectedAllproductid, status)
    //     .then((res) => {
    //       this.profitByDate = res.data.profitByDate;
    //       this.profitdatelist = res.data.profit;
    //       this.profitLostDateList = res.data.lost;
    //       this.profitProfitDateList = res.data.profitprofit;
    //       this.profitAllDateList = res.data.profitall;
    //       this.profitAllProductList = res.data.profitProductList; 
    //       this.profiProductPriceList = res.data.productprice;
    //       this.promotionList = res.data.promotionList;
    //       this.subProductPromotionList = res.data.subProductPromotionList;
    //       // this.stockVenderList = res.data.stockVenderList;  
    //       this.selectedMarketUserList = res.data.selectedMarketUserList;

    //       // this.stockRemain = res.data.stockRemain;
    //       // this.stockinHistory = res.data.stockInHistory;  
    //       // this.stockOutHistory = res.data.stockOutHistory; 

    //       // this.getStockHistory();

    //       loadingComponent.close();

    //       // console.log("res.data.stockInHistory: " + JSON.stringify(res.data.stockInHistory))   
    //       // console.log("res.data.stockOutHistory: " + JSON.stringify(res.data.stockOutHistory))  
    //       // console.log("res.data.startProfitDate: " + JSON.stringify(this.dateFormatterYYYYMMDD(this.startProfitDate)))      
    //       // console.log("res.data.endProfitDate: " + JSON.stringify(this.dateFormatterYYYYMMDD(this.endProfitDate)))      
              
          
    //       // console.log("res.data.profitall: " + JSON.stringify(res.data.profitall))   
    //       // console.log("res.data.productprice: " + JSON.stringify(res.data.productprice))  
               
          
    //     })
        
    //     .catch((error) => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
    // },

    onSelectVender(){

      var venderid=  this.selectedVender.ID
   

      RestAPI.getProductByVender(venderid)
        .then((res) => {
          this.stockProductSub = res.data; 
          // console.log("stockProductSub:" + JSON.stringify(res.data));

        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
      
 

    getProductPrice() {
      var productid = this.selectedProductPriceProduct ? this.selectedProductPriceProduct.ID : 0 ;
      RestAPI.getProductPrice(this.dateFormatterYYYYMMDD(this.startProductPriceDate),this.dateFormatterYYYYMMDD(this.endProductPriceDate), productid )
        .then((res) => {
          this.productBuyPrice = res.data.buyprice;
          this.productPriceProductList = res.data.productlist;
          // console.log("this.productBuyPrice: "+ JSON.stringify(res.data.buyprice));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getTopProductUsage(){
      var producttype = this.selectedProductType ? this.selectedProductType.TYPEID : 0 ;
      RestAPI.getTopProductUsage(this.dateFormatterYYYYMMDD(this.startProductPriceDate),this.dateFormatterYYYYMMDD(this.endProductPriceDate), producttype )
        .then((res) => {
          this.topProductUsage = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
      
    },

    getProductPriceHistory() {
      RestAPI.getProductPriceHistory()
        .then((res) => {
          this.productBuyPriceHistory = res.data.buypricehistory;
          // console.log("this.productBuyPrice: "+ JSON.stringify(res.data.buyprice));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    openContractQuotaForm() {
      this.isContractProductList = false;
    },
    confirmContractProducts() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            contractid: this.contractid,
            branchid: this.selectedBranchid,
            provinceid: this.selectedProvinceid,
            username: this.username,
          };
          RestAPI.confirmContractProducts(params)
            .then(() => {
              this.$swal("ຢືນຢັນລາຍການສິນຄ້າໃນສັນຍາ ສຳເລັດ!", "", "success");
              this.openContractProductList();
              this.contractstatus = 2;
              this.contractform(this.b2buserid, this.b2busername, 1);
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    cancelConfirmContractProducts() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            contractid: this.contractid,
            username: this.username,
          };
          RestAPI.cancelConfirmContractProducts(params)
            .then(() => {
              this.$swal(
                "ຍົກເລີກການຢືນຢັນລາຍການສິນຄ້າ ໃນສັນຍາ ສຳເລັດ!",
                "",
                "success"
              );
              this.openContractProductList();
              this.contractstatus = 1;
              this.contractform(this.b2buserid, this.b2busername, 1);
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    onCountrySelected() {
      RestAPI.getProvincebyCountry(this.SelectedCountry.ID)
        .then((res) => {
          // console.log("country selected...")
          this.ProvinceList = res.data;
          this.SelectedProvince = null;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getDppProvince() {
      RestAPI.getDppProvince()
        .then((res) => {
          // console.log("country selected...")
          this.DppProvinceList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getStockList() {
      RestAPI.getStockList(this.username)
        .then((res) => {
          // console.log("getStockList : " + JSON.stringify(res.data));
          this.stockList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getProvince() {
      RestAPI.getProvincebyCountry(this.selectedCountry.ID)
        .then((res) => {
          // console.log("country selected...")
          this.provinceList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
    year(date) {
      return new moment(date).format("YYYY");
    },
    loadCheckProduct(){
      RestAPI.loadCheckProduct()    
        .then((res) => {
          // console.log("checkProductList: " + JSON.stringify(res.data));  
          this.checkProductList = res.data;
          setTimeout(() => {
            window.print();
          }, 5000);
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
      
    }
    ,  
    print(type) {
      
      this.printtype = type;
      if(type===2000){
        console.log("2000");
        this.loadCheckProduct();
      }else{
        
        if(type==3 || type==33 || type==333 || type==2  || type==22 || type==222 || type==5 || type==1000 || type==10001 || type==3000){
          
          setTimeout(() => {
            var loadingComponent = this.$loading.open({}); 
            window.print(); 
            loadingComponent.close();

          }, 2000);

          
          
        }else{
          window.print();
        }
        
        console.log("printtype: " + this.printtype);             
        console.log("companytype -: " + this.companytype);                  
          
        
    
        if (this.printtype === 2) {
          this.activeSub2TabInvoice = 0;
          this.invoicedetaillisttotal = [];
          this.invoicedetaillist = [];
          this.invoicedetaillistfull = [];
          this.invoicedetaillistsome = [];
          this.invoicedetaillistzero = [];
          this.selectedInvoiceDate = null;

          this.activeSub2TabReceipt = 0;
          this.receiptdetaillist = [];
          this.selectedReceiptDate = null;
        } else if (this.printtype === 3) {
          this.activeSub2TabQuotation = 0;
          this.quotationdetaillist = [];
          this.selectedQuotationDate = null;

          this.activeSub2TabReceipt = 0;
          this.receiptdetaillist = [];
          this.selectedReceiptDate = null;
        } else if (this.printtype === 33) {  
          this.activeSub2TabQuotation = 0;
          this.quotationdetaillist = [];
          this.selectedQuotationDate = null;

          this.activeSub2TabReceipt = 0;
          this.receiptdetaillist = [];
          this.selectedReceiptDate = null;
        } else if (this.printtype === 4) {
          this.activeSub2TabQuotation = 0;
          this.quotationdetaillist = [];
          this.selectedQuotationDate = null;

          this.activeSub2TabInvoice = 0;
          this.invoicedetaillisttotal = [];
          this.invoicedetaillistlist = [];
          this.invoicedetaillistfull = [];
          this.invoicedetaillistsome = [];
          this.invoicedetaillistzero = [];
          this.selectedInvoiceDate = null;
        } 
      }
        
    },
    

    showPopup(PHOTONAME) {
      this.popupImgSrc = this.getReceiptImgUrl(PHOTONAME);   
      this.isPopupVisible = true;
      console.log("showPopup: "+ PHOTONAME);       
    },
    hidePopup() {
      this.isPopupVisible = false;
    },

    getImgUrl(photoname) { 
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      return photopreview;
    },

    getProductPhoto(photoname) { 
      var photopreview = photoname
        ? this.productphotopath + photoname
        : this.productphotopath + "unknown.png";  
      return photopreview;
    },
    loaddatatoBuyhistory(){
      RestAPI.loaddatatoBuyhistory()  
        .then(() => {
          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    onSelectedProductType(){

      var params = {
        marketid: 22,
        typeid: this.selectedBuyListProductType.TYPEID,
      };
      // console.log("params:" + JSON.stringify(params));

      RestAPI.getProductByType(params)
        .then((res) => {
          this.buyListProductList = res.data;   

          // console.log(" res.data:" + JSON.stringify( res.data));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onSelectedProduct(){
      this.buyListProductSubList = [];
      var params = {
        marketid: 22,
        productid: this.selectedBuyListProduct.PRODUCTID,
        b2busername:  this.b2busername,
      };
      // console.log("params:" + JSON.stringify(params));

      RestAPI.getProductSubByProduct(params)
        .then((res) => {
          this.buyListProductSubList = res.data;   

          console.log(" res.data:" + JSON.stringify( res.data));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    onSelectedProductSub(){
  
      var params = {
        marketid: 22,
        b2bcontractid: this.contractid,  
        b2busername:  this.b2busername,
        productid: this.selectedBuyListProduct.PRODUCTID,
        productid_sub : this.selectedBuyListProductSub.PRODUCTID_SUB,
        buylist: this.buylist,
        username: this.username,
      };
      // console.log("params:" + JSON.stringify(params));

      RestAPI.addProductSubToBuyList(params)
        .then(() => {
          this.allProductStatus();
          this.onSelectedProduct();
          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
        })
        .catch((error) => {
          console.log(error);  
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");      
        });
    },

  },
  mounted() {   
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.getB2bUser();
    this.getProductType();
    this.selecteddate = new Date();  
    this.preparedate = new Date();
    this.currentDate = new Date();
    this.startOrderDate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth(),
      1
    );
    this.endOrderDate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth() + 1,
      0
    );

    this.startPaymentDate = new Date();
    this.endPaymentDate = new Date();

    this.startB2BPaymentDate = new Date();
    this.endB2BPaymentDate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth() + 1,
      0
    );

    this.startProfitDate = new Date(this.currentDate);
    this.endProfitDate = new Date(this.currentDate);  

    this.startProductPriceDate = new Date(this.currentDate);
    this.endProductPriceDate = new Date(this.currentDate);  

    this.startMarketBatchDate = this.startOrderDate;
    this.endMarketBatchDate = this.endOrderDate;  
    this.startMarketOrderDate = this.startOrderDate;
    this.endMarketOrderDate = this.endOrderDate;

    this.quotationDate = new Date(this.currentDate);

    this.selectedquotaddate = new Date();
    this.formdate = new Date();
    this.allOrdersStatus();
  },  

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    isSummaryOnFirstPage() {
      // Adjust this logic based on the number of rows and your page layout
      const numRowsPerPage = 20; // Change this based on your requirement
      return this.quotationdetaillist.length <= numRowsPerPage;
    },

 

    

    // isLastPage() {
    //   return this.currentPage === this.totalPages;
    // },

    // isFirstPage() {
    //   return this.currentPage === 1;
    // },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-35 {
  flex: 0 0 25%;
}
.column-65 {
  flex: 0 0 75%;
}

.asterisk {
  color: red;
}
  
.table {
  border-collapse: collapse;
  width: 100%;
}

.set-border {
  border: 1px solid #838282;
}

tbody tr:last-child td {
  border-bottom: 1px solid #838282 !important;
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none; 
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
